import "./frontend.5e8f58f8.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5384"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5384"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fFSBL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c6ea426cade81eb$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
function $1c6ea426cade81eb$var$LoadingSpinner({ size: size = 'medium', className: className = '' }) {
    const sizeClass = `loading-spinner--${size}`;
    const spinnerClass = [
        'loading-spinner',
        sizeClass,
        className
    ].filter(Boolean).join(' ');
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: spinnerClass,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "spinner-circle"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "spinner-text",
                children: "Loading..."
            })
        ]
    });
}
var $1c6ea426cade81eb$export$2e2bcd8739ae039 = $1c6ea426cade81eb$var$LoadingSpinner;

});


var $ih19M = parcelRequire("ih19M");

var $9ATkq = parcelRequire("9ATkq");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");
function $e11a6c830487d92f$var$Button({ children: children, onClick: onClick, variant: variant = 'primary', size: size = 'medium', type: type = 'button', disabled: disabled = false, className: className = '', ...props }) {
    const baseClass = 'gw-button';
    const variantClass = `gw-button--${variant}`;
    const sizeClass = `gw-button--${size}`;
    const disabledClass = disabled ? 'gw-button--disabled' : '';
    const buttonClass = [
        baseClass,
        variantClass,
        sizeClass,
        disabledClass,
        className
    ].filter(Boolean).join(' ');
    return /*#__PURE__*/ (0, $ih19M.jsx)("button", {
        type: type,
        onClick: onClick,
        disabled: disabled,
        className: buttonClass,
        ...props,
        children: children
    });
}
var $e11a6c830487d92f$export$2e2bcd8739ae039 = $e11a6c830487d92f$var$Button;


function $8adbcafe5c7ec1d7$var$Header({ searchTerm: searchTerm, onSearch: onSearch, onShowFilters: onShowFilters, onClearFilters: onClearFilters, hasActiveFilters: hasActiveFilters, sortBy: sortBy, onSortChange: onSortChange, sortOptions: sortOptions = [], mobileView: // Mobile mode signal (controls are rendered in MobileBottomBar)
mobileView }) {
    const [localSearchTerm, setLocalSearchTerm] = (0, $bh6RR.useState)(searchTerm);
    const isMobileHeader = mobileView !== undefined;
    (0, $bh6RR.useEffect)(()=>{
        setLocalSearchTerm(searchTerm);
    }, [
        searchTerm
    ]);
    const handleSearchSubmit = (e)=>{
        e.preventDefault();
        onSearch(localSearchTerm);
    };
    const handleClearSearch = ()=>{
        setLocalSearchTerm('');
        onSearch('');
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)("header", {
        className: "gw-bp-geosearch-header",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "search-section",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("form", {
                        onSubmit: handleSearchSubmit,
                        className: "search-form",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "search-input-wrapper",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                        type: "text",
                                        value: localSearchTerm,
                                        onChange: (e)=>setLocalSearchTerm(e.target.value),
                                        placeholder: "Search members...",
                                        className: "search-input"
                                    }),
                                    localSearchTerm && /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                        type: "button",
                                        onClick: handleClearSearch,
                                        className: "clear-search-btn",
                                        "aria-label": "Clear search",
                                        children: "\xd7"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $e11a6c830487d92f$export$2e2bcd8739ae039), {
                                type: "submit",
                                variant: "primary",
                                children: "Search"
                            })
                        ]
                    }),
                    isMobileHeader && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "mobile-sort-row",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                htmlFor: "mobile-sort-select",
                                className: "mobile-sort-label",
                                children: "Sort"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("select", {
                                id: "mobile-sort-select",
                                value: sortBy,
                                onChange: (e)=>onSortChange(e.target.value),
                                className: "mobile-sort-select",
                                "aria-label": "Sort members",
                                children: (sortOptions.length > 0 ? sortOptions : [
                                    {
                                        value: 'joined',
                                        label: 'Recently Joined'
                                    },
                                    {
                                        value: 'joined_asc',
                                        label: 'Oldest Joined'
                                    },
                                    {
                                        value: 'last_active',
                                        label: 'Recently Active'
                                    },
                                    {
                                        value: 'last_active_asc',
                                        label: 'Least Recently Active'
                                    },
                                    {
                                        value: 'name',
                                        label: 'Name (A-Z)'
                                    },
                                    {
                                        value: 'name_desc',
                                        label: 'Name (Z-A)'
                                    }
                                ]).map((option)=>/*#__PURE__*/ (0, $ih19M.jsx)("option", {
                                        value: option.value,
                                        children: option.label
                                    }, option.value))
                            })
                        ]
                    })
                ]
            }),
            !isMobileHeader && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "controls-section",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $e11a6c830487d92f$export$2e2bcd8739ae039), {
                        onClick: onShowFilters,
                        variant: hasActiveFilters ? 'primary' : 'secondary',
                        className: hasActiveFilters ? 'has-active-filters' : '',
                        children: [
                            "Filters ",
                            hasActiveFilters && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "filter-indicator",
                                children: "*"
                            })
                        ]
                    }),
                    (hasActiveFilters || searchTerm) && /*#__PURE__*/ (0, $ih19M.jsx)((0, $e11a6c830487d92f$export$2e2bcd8739ae039), {
                        onClick: onClearFilters,
                        variant: "outline",
                        size: "small",
                        children: "Clear All"
                    })
                ]
            })
        ]
    });
}
var $8adbcafe5c7ec1d7$export$2e2bcd8739ae039 = $8adbcafe5c7ec1d7$var$Header;



var $ih19M = parcelRequire("ih19M");
const $222280692cf2e3e9$var$svgStyle = {
    display: 'block',
    width: 18,
    height: 18,
    fill: 'currentColor',
    flexShrink: 0
};
const $222280692cf2e3e9$var$IconList = ()=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        style: $222280692cf2e3e9$var$svgStyle,
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "3",
                y: "7",
                width: "2",
                height: "2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "3",
                y: "11",
                width: "2",
                height: "2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "3",
                y: "15",
                width: "2",
                height: "2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "7",
                y: "7",
                width: "14",
                height: "2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "7",
                y: "11",
                width: "14",
                height: "2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "7",
                y: "15",
                width: "14",
                height: "2"
            })
        ]
    });
const $222280692cf2e3e9$var$IconMap = ()=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        style: $222280692cf2e3e9$var$svgStyle,
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                points: "9,3 9,19 15,21 15,5"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                points: "3,5 3,20 9,18 9,3"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("polygon", {
                points: "15,5 15,21 21,19 21,4"
            })
        ]
    });
const $222280692cf2e3e9$var$IconFilter = ()=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        style: $222280692cf2e3e9$var$svgStyle,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M4 6h16v2H4zm3 5h10v2H7zm3 5h4v2h-4z"
        })
    });
function $222280692cf2e3e9$var$MobileBottomBar({ mobileView: mobileView, onMobileViewChange: onMobileViewChange, onShowFilters: onShowFilters, hasActiveFilters: hasActiveFilters, activeFilterCount: activeFilterCount, showClear: showClear, onClear: onClear, showMap: showMap = true }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "mobile-bottom-bar",
        role: "tablist",
        "aria-label": "Mobile navigation",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                type: "button",
                className: `bottom-tab ${mobileView === 'list' || !showMap ? 'active' : ''}`,
                onClick: ()=>onMobileViewChange('list'),
                role: "tab",
                "aria-selected": mobileView === 'list' || !showMap,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($222280692cf2e3e9$var$IconList, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        children: "LIST"
                    })
                ]
            }),
            showMap && /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                type: "button",
                className: `bottom-tab ${mobileView === 'map' ? 'active' : ''}`,
                onClick: ()=>onMobileViewChange('map'),
                role: "tab",
                "aria-selected": mobileView === 'map',
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($222280692cf2e3e9$var$IconMap, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        children: "MAP"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                type: "button",
                className: `bottom-tab ${hasActiveFilters ? 'has-active-filters' : ''}`,
                onClick: onShowFilters,
                role: "tab",
                "aria-label": "Filters",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($222280692cf2e3e9$var$IconFilter, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        children: "FILTERS"
                    }),
                    hasActiveFilters && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "filter-badge",
                        "aria-label": `${activeFilterCount} active filters`,
                        children: activeFilterCount
                    })
                ]
            })
        ]
    });
}
var $222280692cf2e3e9$export$2e2bcd8739ae039 = $222280692cf2e3e9$var$MobileBottomBar;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
function $f9a85ac8928fb9dc$export$37dc31edf9cb7f3() {
    const [dimensions, setDimensions] = (0, $bh6RR.useState)({
        width: window.innerWidth,
        height: window.innerHeight
    });
    (0, $bh6RR.useEffect)(()=>{
        const handleResize = ()=>{
            setDimensions({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    return {
        isMobile: dimensions.width < 768,
        isTablet: dimensions.width >= 768 && dimensions.width < 1400,
        isDesktop: dimensions.width >= 1400,
        width: dimensions.width,
        height: dimensions.height
    };
}


function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    return $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $39ab41060f0dd572$export$2e2bcd8739ae039.apply(null, arguments);
}


function $cb0e0834598ff6d6$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $ca073d81f2a471af$export$2e2bcd8739ae039(t, e) {
    return $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ca073d81f2a471af$export$2e2bcd8739ae039(t, e);
}


function $c375c92967c25393$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $ca073d81f2a471af$export$2e2bcd8739ae039)(t, o);
}


var $16d5efbf3de5c533$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $16d5efbf3de5c533$var$isEqual(first, second) {
    if (first === second) return true;
    if ($16d5efbf3de5c533$var$safeIsNaN(first) && $16d5efbf3de5c533$var$safeIsNaN(second)) return true;
    return false;
}
function $16d5efbf3de5c533$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$16d5efbf3de5c533$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $16d5efbf3de5c533$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $16d5efbf3de5c533$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $16d5efbf3de5c533$export$2e2bcd8739ae039 = $16d5efbf3de5c533$var$memoizeOne;



var $bh6RR = parcelRequire("bh6RR");
function $cd488cd9c287f883$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $3cc8a1e45b82291d$var$hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var $3cc8a1e45b82291d$var$now = $3cc8a1e45b82291d$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $3cc8a1e45b82291d$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $3cc8a1e45b82291d$var$requestTimeout(callback, delay) {
    var start = $3cc8a1e45b82291d$var$now();
    function tick() {
        if ($3cc8a1e45b82291d$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $3cc8a1e45b82291d$var$size = -1; // This utility copied from "dom-helpers" package.
function $3cc8a1e45b82291d$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($3cc8a1e45b82291d$var$size === -1 || recalculate) {
        var div = document.createElement('div');
        var style = div.style;
        style.width = '50px';
        style.height = '50px';
        style.overflow = 'scroll';
        document.body.appendChild(div);
        $3cc8a1e45b82291d$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $3cc8a1e45b82291d$var$size;
}
var $3cc8a1e45b82291d$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $3cc8a1e45b82291d$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($3cc8a1e45b82291d$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement('div');
        var outerStyle = outerDiv.style;
        outerStyle.width = '50px';
        outerStyle.height = '50px';
        outerStyle.overflow = 'scroll';
        outerStyle.direction = 'rtl';
        var innerDiv = document.createElement('div');
        var innerStyle = innerDiv.style;
        innerStyle.width = '100px';
        innerStyle.height = '100px';
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $3cc8a1e45b82291d$var$cachedRTLResult = 'positive-descending';
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $3cc8a1e45b82291d$var$cachedRTLResult = 'negative';
            else $3cc8a1e45b82291d$var$cachedRTLResult = 'positive-ascending';
        }
        document.body.removeChild(outerDiv);
        return $3cc8a1e45b82291d$var$cachedRTLResult;
    }
    return $3cc8a1e45b82291d$var$cachedRTLResult;
}
var $3cc8a1e45b82291d$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $3cc8a1e45b82291d$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $3cc8a1e45b82291d$var$devWarningsOverscanCount = null;
var $3cc8a1e45b82291d$var$devWarningsOverscanRowsColumnsCount = null;
var $3cc8a1e45b82291d$var$devWarningsTagName = null;
function $3cc8a1e45b82291d$var$createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $c375c92967c25393$export$2e2bcd8739ae039)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                horizontalScrollDirection: 'forward',
                scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: 'forward'
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === 'rtl';
                    itemStyleCache[key] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === 'rtl') switch($3cc8a1e45b82291d$var$getRTLOffsetType()){
                        case 'negative':
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case 'positive-descending':
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $3cc8a1e45b82291d$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $3cc8a1e45b82291d$var$requestTimeout(_this._resetIsScrolling, $3cc8a1e45b82291d$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $3cc8a1e45b82291d$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? 'auto' : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $3cc8a1e45b82291d$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === 'number') outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === 'number') outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === 'rtl') switch($3cc8a1e45b82291d$var$getRTLOffsetType()){
                    case 'negative':
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case 'positive-ascending':
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $3cc8a1e45b82291d$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $3cc8a1e45b82291d$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $bh6RR.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $bh6RR.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $bh6RR.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === 'function') {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === 'function') {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $bh6RR.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var $3cc8a1e45b82291d$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $3cc8a1e45b82291d$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $3cc8a1e45b82291d$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $3cc8a1e45b82291d$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === 'column') instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $3cc8a1e45b82291d$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $3cc8a1e45b82291d$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $3cc8a1e45b82291d$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $3cc8a1e45b82291d$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $3cc8a1e45b82291d$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $3cc8a1e45b82291d$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $3cc8a1e45b82291d$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $3cc8a1e45b82291d$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $3cc8a1e45b82291d$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === 'column' ? props.width : props.height;
    var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === 'column' ? $3cc8a1e45b82291d$var$getEstimatedTotalWidth(props, instanceProps) : $3cc8a1e45b82291d$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === 'smart') {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
        else align = 'center';
    }
    switch(align){
        case 'start':
            return maxOffset;
        case 'end':
            return minOffset;
        case 'center':
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case 'auto':
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $3cc8a1e45b82291d$export$32c206c84102e73c = /*#__PURE__*/ $3cc8a1e45b82291d$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $3cc8a1e45b82291d$var$getItemMetadata('column', props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $3cc8a1e45b82291d$var$findNearestItem('column', props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata('column', props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $3cc8a1e45b82291d$var$getItemMetadata('column', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $3cc8a1e45b82291d$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $3cc8a1e45b82291d$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $3cc8a1e45b82291d$var$getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $3cc8a1e45b82291d$var$getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $3cc8a1e45b82291d$var$getItemMetadata('row', props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $3cc8a1e45b82291d$var$findNearestItem('row', props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata('row', props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $3cc8a1e45b82291d$var$getItemMetadata('row', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === 'number') instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === 'number') instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $3cc8a1e45b82291d$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $3cc8a1e45b82291d$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $3cc8a1e45b82291d$var$devWarningsDirection = null;
var $3cc8a1e45b82291d$var$devWarningsTagName$1 = null;
function $3cc8a1e45b82291d$var$createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $c375c92967c25393$export$2e2bcd8739ae039)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                scrollDirection: 'forward',
                scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
                    var isRtl = direction === 'rtl';
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : '100%',
                        width: isHorizontal ? size : '100%'
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($3cc8a1e45b82291d$var$getRTLOffsetType()){
                        case 'negative':
                            scrollOffset = -scrollLeft;
                            break;
                        case 'positive-descending':
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $3cc8a1e45b82291d$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $3cc8a1e45b82291d$var$requestTimeout(_this._resetIsScrolling, $3cc8a1e45b82291d$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $3cc8a1e45b82291d$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = 'auto';
            var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            // This is an edge case for lists; normally they only scroll in the dominant direction.
            var scrollbarSize = 0;
            if (this._outerRef) {
                var outerRef = this._outerRef;
                if (layout === 'vertical') scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? $3cc8a1e45b82291d$var$getScrollbarSize() : 0;
                else scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? $3cc8a1e45b82291d$var$getScrollbarSize() : 0;
            }
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
            if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') {
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($3cc8a1e45b82291d$var$getRTLOffsetType()){
                        case 'negative':
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case 'positive-ascending':
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $3cc8a1e45b82291d$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? $3cc8a1e45b82291d$var$defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $bh6RR.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $bh6RR.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $bh6RR.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? '100%' : estimatedTotalSize,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: isHorizontal ? estimatedTotalSize : '100%'
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === 'function') {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === 'function') {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $bh6RR.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        layout: 'vertical',
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $3cc8a1e45b82291d$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $3cc8a1e45b82291d$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $3cc8a1e45b82291d$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $3cc8a1e45b82291d$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $3cc8a1e45b82291d$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $3cc8a1e45b82291d$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $3cc8a1e45b82291d$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $3cc8a1e45b82291d$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $3cc8a1e45b82291d$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $3cc8a1e45b82291d$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $3cc8a1e45b82291d$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $3cc8a1e45b82291d$export$d8ac3b6b20be856e = /*#__PURE__*/ $3cc8a1e45b82291d$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $3cc8a1e45b82291d$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $3cc8a1e45b82291d$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $3cc8a1e45b82291d$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $3cc8a1e45b82291d$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $3cc8a1e45b82291d$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $3cc8a1e45b82291d$export$f331158cccad7361 = /*#__PURE__*/ $3cc8a1e45b82291d$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === 'smart') {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === 'smart') {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $3cc8a1e45b82291d$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $3cc8a1e45b82291d$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $3cc8a1e45b82291d$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var $3cc8a1e45b82291d$var$_excluded = [
    "style"
], $3cc8a1e45b82291d$var$_excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $3cc8a1e45b82291d$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(prevProps, $3cc8a1e45b82291d$var$_excluded);
    var nextStyle = nextProps.style, nextRest = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(nextProps, $3cc8a1e45b82291d$var$_excluded2);
    return !$3cc8a1e45b82291d$var$shallowDiffers(prevStyle, nextStyle) && !$3cc8a1e45b82291d$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $3cc8a1e45b82291d$export$aa365c903ed149ff(nextProps, nextState) {
    return !$3cc8a1e45b82291d$export$b141efd0b0fb9174(this.props, nextProps) || $3cc8a1e45b82291d$var$shallowDiffers(this.state, nextState);
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
function $a1fea1d50965ba93$var$MessageButton({ recipientId: recipientId, recipientName: recipientName, className: className = '', size: size = 'medium', variant: variant = 'primary', disabled: disabled = false, onMessageSent: onMessageSent = null }) {
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (disabled || isLoading) return;
        // Fire custom event to open message modal
        const event = new CustomEvent('openMessageModal', {
            detail: {
                recipientId: recipientId,
                recipientName: recipientName,
                onMessageSent: onMessageSent
            }
        });
        window.dispatchEvent(event);
    };
    const getSizeClass = ()=>{
        switch(size){
            case 'small':
                return 'btn-sm';
            case 'large':
                return 'btn-lg';
            case 'icon':
                return 'btn-icon';
            default:
                return '';
        }
    };
    const getVariantClass = ()=>{
        switch(variant){
            case 'secondary':
                return 'btn-secondary';
            case 'outline':
                return 'btn-outline';
            default:
                return 'btn-primary';
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
        onClick: handleClick,
        disabled: disabled || isLoading,
        className: `base-btn message-btn ${getSizeClass()} ${getVariantClass()} ${className}`,
        title: `Send message to ${recipientName}`,
        "aria-label": `Send message to ${recipientName}`,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                className: "message-icon",
                width: size === 'icon' ? 16 : 16,
                height: size === 'icon' ? 16 : 16,
                viewBox: "0 0 24 24",
                fill: "currentColor",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M7 9H17V11H7V9Z"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M7 12H13V14H7V12Z"
                    })
                ]
            }),
            size !== 'icon' && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "message-text",
                children: "Message"
            })
        ]
    });
}
var $a1fea1d50965ba93$export$2e2bcd8739ae039 = $a1fea1d50965ba93$var$MessageButton;



var $ih19M = parcelRequire("ih19M");

var $ih19M = parcelRequire("ih19M");
function $8c423fd050ecb4d2$var$ProfileIcon({ width: width = 16, height: height = 16, className: className = "" }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        className: `profile-icon ${className}`,
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
        })
    });
}
var $8c423fd050ecb4d2$export$2e2bcd8739ae039 = $8c423fd050ecb4d2$var$ProfileIcon;


function $6d110c7f994fee80$var$ProfileButton({ profileUrl: profileUrl, memberName: memberName, className: className = '', size: size = 'medium', variant: variant = 'primary', disabled: disabled = false }) {
    const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (disabled || !profileUrl) return;
        // Open profile in new tab
        window.open(profileUrl, '_blank', 'noopener,noreferrer');
    };
    const getSizeClass = ()=>{
        switch(size){
            case 'small':
                return 'btn-sm';
            case 'large':
                return 'btn-lg';
            case 'icon':
                return 'btn-icon';
            default:
                return '';
        }
    };
    const getVariantClass = ()=>{
        switch(variant){
            case 'secondary':
                return 'btn-secondary';
            case 'outline':
                return 'btn-outline';
            default:
                return 'btn-primary';
        }
    };
    if (!profileUrl) return null;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
        onClick: handleClick,
        disabled: disabled,
        className: `base-btn profile-btn ${getSizeClass()} ${getVariantClass()} ${className}`,
        title: `View ${memberName}'s profile`,
        "aria-label": `View ${memberName}'s profile`,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8c423fd050ecb4d2$export$2e2bcd8739ae039), {
                width: size === 'icon' ? 16 : 14,
                height: size === 'icon' ? 16 : 14
            }),
            size !== 'icon' && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "button-text",
                children: "View"
            })
        ]
    });
}
var $6d110c7f994fee80$export$2e2bcd8739ae039 = $6d110c7f994fee80$var$ProfileButton;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
function $46492165c57fbd0a$var$FavoriteButton({ userId: userId, isFavorite: isFavorite, onToggle: onToggle, isPending: isPending = false, size: size = 'normal', variant: variant = 'outline', disabled: disabled = false }) {
    const [isHovered, setIsHovered] = (0, $bh6RR.useState)(false);
    const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!disabled && !isPending && onToggle) onToggle(userId);
    };
    const getButtonClass = ()=>{
        const baseClass = 'base-btn favorite-btn';
        const sizeClass = size === 'icon' ? 'btn-icon' : size === 'small' ? 'btn-sm' : '';
        const variantClass = variant === 'outline' ? 'btn-outline' : variant === 'overlay' ? 'btn-overlay' : '';
        const stateClass = isFavorite ? 'favorited' : '';
        const pendingClass = isPending ? 'pending' : '';
        const disabledClass = disabled ? 'disabled' : '';
        return [
            baseClass,
            sizeClass,
            variantClass,
            stateClass,
            pendingClass,
            disabledClass
        ].filter(Boolean).join(' ');
    };
    const getTitle = ()=>{
        if (isPending) return isFavorite ? 'Removing from favorites...' : 'Adding to favorites...';
        return isFavorite ? 'Remove from favorites' : 'Add to favorites';
    };
    const HeartIcon = ({ filled: filled })=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
            className: "favorite-icon",
            width: size === 'icon' ? "16" : "14",
            height: size === 'icon' ? "16" : "14",
            viewBox: "0 0 24 24",
            fill: filled ? "currentColor" : "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
            })
        });
    const LoadingSpinner = ()=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
            className: "favorite-loading",
            width: size === 'icon' ? "16" : "14",
            height: size === 'icon' ? "16" : "14",
            viewBox: "0 0 24 24",
            fill: "none",
            children: /*#__PURE__*/ (0, $ih19M.jsxs)("circle", {
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeDasharray: "32",
                strokeDashoffset: "32",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("animate", {
                        attributeName: "stroke-dasharray",
                        dur: "2s",
                        values: "0 32;16 16;0 32;0 32",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("animate", {
                        attributeName: "stroke-dashoffset",
                        dur: "2s",
                        values: "0;-16;-32;-32",
                        repeatCount: "indefinite"
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
        className: getButtonClass(),
        onClick: handleClick,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        title: getTitle(),
        disabled: disabled || isPending,
        "aria-label": getTitle(),
        children: [
            isPending ? /*#__PURE__*/ (0, $ih19M.jsx)(LoadingSpinner, {}) : /*#__PURE__*/ (0, $ih19M.jsx)(HeartIcon, {
                filled: isFavorite || isHovered && !isFavorite
            }),
            size !== 'icon' && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "button-text",
                children: isFavorite ? 'Favorited' : 'Favorite'
            })
        ]
    });
}
var $46492165c57fbd0a$export$2e2bcd8739ae039 = $46492165c57fbd0a$var$FavoriteButton;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
function $0e1959f263d7c540$var$LazyCoverImage({ src: src, alt: alt, className: className = 'cover-image', fallback: fallback = null, placeholder: placeholder = null, aspectRatio: aspectRatio = '16:9', isAvatar: isAvatar = false, avatarWidth: avatarWidth = '30%' }) {
    const [isLoaded, setIsLoaded] = (0, $bh6RR.useState)(false);
    const [isInView, setIsInView] = (0, $bh6RR.useState)(false);
    const [hasError, setHasError] = (0, $bh6RR.useState)(false);
    const imgRef = (0, $bh6RR.useRef)(null);
    const observerRef = (0, $bh6RR.useRef)(null);
    // Default fallback cover image - rectangular pattern
    const getDefaultCover = ()=>{
        return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgdmlld0JveD0iMCAwIDMyMCAxODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIiBmaWxsPSIjZjBmMGYwIi8+CjxwYXRoIGQ9Ik0xMjAgNjBMMTQwIDkwSDE2MEwxODAgNjBMMjAwIDkwSDIyMEwyNDAgNjBMMjYwIDkwSDI4MEwzMDAgNjBWMTIwSDIwVjYwSDEyMFoiIGZpbGw9IiNkZGQiLz4KPGNpcmNsZSBjeD0iODAiIGN5PSI4MCIgcj0iMjAiIGZpbGw9IiNjY2MiLz4KPC9zdmc+';
    };
    // Default fallback for avatars - circular user icon
    const getDefaultAvatar = ()=>{
        return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUwIiBoZWlnaHQ9IjE1MCIgdmlld0JveD0iMCAwIDE1MCAxNTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9Ijc1IiBjeT0iNzUiIHI9Ijc1IiBmaWxsPSIjZTBlMGUwIi8+CjxjaXJjbGUgY3g9Ijc1IiBjeT0iNTUiIHI9IjI1IiBmaWxsPSIjYmRiZGJkIi8+CjxwYXRoIGQ9Ik0zNSAxMzBDMzUgMTA1IDUyIDg1IDc1IDg1Qzk4IDg1IDExNSAxMDUgMTE1IDEzMCIgZmlsbD0iI2JkYmRiZCIvPgo8L3N2Zz4=';
    };
    // Calculate container dimensions based on aspect ratio
    const getContainerStyle = ()=>{
        const [width, height] = aspectRatio.split(':').map(Number);
        const paddingBottom = `${height / width * 100}%`;
        return {
            position: 'relative',
            width: '100%',
            paddingBottom: paddingBottom,
            backgroundColor: '#f0f0f0',
            background: '#f0f0f0',
            borderRadius: 'var(--border-radius, 8px)',
            overflow: 'hidden'
        };
    };
    // Get image styles - different for avatars vs cover images
    const getImageStyle = ()=>{
        const baseStyle = {
            position: 'absolute',
            opacity: isLoaded ? 1 : 0,
            transition: 'opacity 0.2s ease-in-out'
        };
        if (isAvatar) // Avatar: centered, circular - equal width/height within container
        return {
            ...baseStyle,
            width: avatarWidth,
            height: '90%',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            objectFit: 'cover',
            borderRadius: '50%'
        };
        // Cover image: fill the container
        return {
            ...baseStyle,
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        };
    };
    // Set up intersection observer for lazy loading
    (0, $bh6RR.useEffect)(()=>{
        const imgElement = imgRef.current;
        if (!imgElement) return;
        // If IntersectionObserver is not supported, load immediately
        if (!window.IntersectionObserver) {
            setIsInView(true);
            return;
        }
        observerRef.current = new IntersectionObserver((entries)=>{
            const [entry] = entries;
            if (entry.isIntersecting) {
                setIsInView(true);
                // Disconnect observer once image is in view
                observerRef.current?.disconnect();
            }
        }, {
            // Start loading when image is 100px away from viewport
            rootMargin: '100px',
            threshold: 0.1
        });
        observerRef.current.observe(imgElement);
        // Cleanup
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, []);
    const handleLoad = ()=>{
        setIsLoaded(true);
    };
    const handleError = ()=>{
        setHasError(true);
        setIsLoaded(true); // Consider loaded even with error to show fallback
    };
    // Determine which image source to use
    const imageSrc = hasError ? fallback || (isAvatar ? getDefaultAvatar() : getDefaultCover()) : src;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        ref: imgRef,
        className: `lazy-cover-container ${className}-container ${isAvatar ? 'is-avatar-container' : ''}`,
        style: getContainerStyle(),
        children: [
            !isLoaded && placeholder && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "cover-placeholder",
                style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: placeholder
            }),
            isInView && /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: imageSrc,
                alt: alt,
                className: `${className} ${isLoaded ? 'loaded' : 'loading'} ${isAvatar ? 'avatar-image' : ''}`,
                onLoad: handleLoad,
                onError: handleError,
                style: getImageStyle()
            }),
            !isLoaded && !placeholder && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "cover-loading",
                style: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    border: '2px solid #ddd',
                    borderTop: '2px solid #666',
                    animation: 'spin 1s linear infinite'
                }
            })
        ]
    });
}
var $0e1959f263d7c540$export$2e2bcd8739ae039 = $0e1959f263d7c540$var$LazyCoverImage;



var $ih19M = parcelRequire("ih19M");
function $06fe465818eef2df$var$AvailabilityButton({ userId: userId, userName: userName, className: className = '', size: size = 'small', variant: variant = 'outline', disabled: disabled = false }) {
    const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (disabled) return;
        const event = new CustomEvent('openAvailabilityCalendar', {
            detail: {
                userId: userId,
                userName: userName
            }
        });
        window.dispatchEvent(event);
    };
    const getSizeClass = ()=>{
        switch(size){
            case 'small':
                return 'btn-sm';
            case 'large':
                return 'btn-lg';
            case 'icon':
                return 'btn-icon';
            default:
                return '';
        }
    };
    const getVariantClass = ()=>{
        switch(variant){
            case 'secondary':
                return 'btn-secondary';
            case 'outline':
                return 'btn-outline';
            default:
                return 'btn-primary';
        }
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
        onClick: handleClick,
        disabled: disabled,
        className: `base-btn availability-btn ${getSizeClass()} ${getVariantClass()} ${className}`,
        title: `Check ${userName}'s availability`,
        "aria-label": `Check ${userName}'s availability`,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                className: "availability-icon",
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        x: "3",
                        y: "4",
                        width: "18",
                        height: "18",
                        rx: "2",
                        ry: "2"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("line", {
                        x1: "16",
                        y1: "2",
                        x2: "16",
                        y2: "6"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("line", {
                        x1: "8",
                        y1: "2",
                        x2: "8",
                        y2: "6"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("line", {
                        x1: "3",
                        y1: "10",
                        x2: "21",
                        y2: "10"
                    })
                ]
            }),
            size !== 'icon' && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "btn-label",
                children: "Check Dates"
            })
        ]
    });
}
var $06fe465818eef2df$export$2e2bcd8739ae039 = $06fe465818eef2df$var$AvailabilityButton;


// Helper function to decode HTML entities - moved outside component to avoid circular dependency
const $890a3db709ac5fb3$var$decodeHtmlEntities = (str)=>{
    if (!str) return str;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
};
// Memoize the member card to prevent unnecessary re-renders
const $890a3db709ac5fb3$var$OptimizedMemberCard = /*#__PURE__*/ (0, $bh6RR.memo)(function MemberCard({ member: member, viewMode: viewMode, config: config, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, isFavorite: isFavorite, onToggleFavorite: onToggleFavorite, isPendingFavorite: isPendingFavorite, isLoggedIn: isLoggedIn = true, ...props }) {
    // Memoize decoded display name to avoid re-computing
    const displayName = (0, $bh6RR.useMemo)(()=>{
        return $890a3db709ac5fb3$var$decodeHtmlEntities(member.display_name);
    }, [
        member.display_name
    ]);
    // Memoize intro text processing
    const processedIntroText = (0, $bh6RR.useMemo)(()=>{
        if (!member.intro_text) return null;
        const decoded = $890a3db709ac5fb3$var$decodeHtmlEntities(member.intro_text);
        if (viewMode === 'compact') {
            const formCfg = config?.config || config || {};
            const limit = formCfg.intro_char_limit_compact || 80;
            return decoded.length > limit ? `${decoded.substring(0, limit)}...` : decoded;
        }
        // Standard/cards view: PHP already truncates at intro_char_limit, just decode
        return decoded;
    }, [
        member.intro_text,
        viewMode,
        config
    ]);
    // Field IDs to display in member-actions instead of member-fields
    const actionFieldIds = [
        '912',
        '913'
    ];
    // Memoize display fields processing (excluding action fields)
    const processedDisplayFields = (0, $bh6RR.useMemo)(()=>{
        if (!member.display_fields || member.display_fields.length === 0) return null;
        // Filter out fields 912 and 913 - they'll be shown in member-actions
        const listFields = member.display_fields.filter((field)=>{
            if (actionFieldIds.includes(String(field.field_id))) return false;
            if (viewMode === 'compact') return field.show_in_compact === true;
            return field.show_in_list !== false;
        });
        if (listFields.length === 0) return null;
        const maxFields = viewMode === 'compact' ? 2 : 4;
        return listFields.slice(0, maxFields).map((field, index)=>{
            if (!field.value) return null;
            // Handle custom formatted fields (admin-set HTML content)
            if (field.type === 'custom_format') return {
                key: index,
                fieldId: field.field_id,
                label: $890a3db709ac5fb3$var$decodeHtmlEntities(field.label),
                hideLabel: field.hide_label || false,
                value: field.value,
                isHtml: true
            };
            // Handle regular fields with HTML entity decoding
            const fieldValue = Array.isArray(field.value) ? field.value.map((v)=>$890a3db709ac5fb3$var$decodeHtmlEntities(v)).join(', ') : $890a3db709ac5fb3$var$decodeHtmlEntities(field.value);
            return {
                key: index,
                fieldId: field.field_id,
                label: $890a3db709ac5fb3$var$decodeHtmlEntities(field.label),
                hideLabel: field.hide_label || false,
                value: fieldValue,
                isHtml: false
            };
        }).filter(Boolean);
    }, [
        member.display_fields,
        viewMode
    ]);
    // Memoize action fields (912 and 913) for display in member-actions
    const actionFields = (0, $bh6RR.useMemo)(()=>{
        if (!member.display_fields || member.display_fields.length === 0) return null;
        const fields = member.display_fields.filter((field)=>actionFieldIds.includes(String(field.field_id)) && field.value);
        if (fields.length === 0) return null;
        return fields.map((field, index)=>{
            if (field.type === 'custom_format') return {
                key: index,
                fieldId: field.field_id,
                value: field.value,
                isHtml: true
            };
            const fieldValue = Array.isArray(field.value) ? field.value.map((v)=>$890a3db709ac5fb3$var$decodeHtmlEntities(v)).join(', ') : $890a3db709ac5fb3$var$decodeHtmlEntities(field.value);
            return {
                key: index,
                fieldId: field.field_id,
                value: fieldValue,
                isHtml: false
            };
        });
    }, [
        member.display_fields
    ]);
    // Memoize activity date formatting
    const formattedActivityDate = (0, $bh6RR.useMemo)(()=>{
        if (!member.last_activity) return null;
        return new Date(member.last_activity).toLocaleDateString();
    }, [
        member.last_activity
    ]);
    // Determine if we're using avatar as the header image
    // The config prop is the top-level config object, form settings are in config.config
    const formConfig = config?.config || config || {};
    const coverImageSource = formConfig.cover_image_source || 'bp_cover';
    const isUsingAvatarAsCover = coverImageSource === 'bp_avatar';
    // Guard: some plugins store the cover image field as an HTML <img> tag — extract the src URL
    const rawCoverImage = member.cover_image;
    const coverImageUrl = rawCoverImage && rawCoverImage.includes('<img') ? (rawCoverImage.match(/src=["']([^"']+)["']/) || [])[1] || '' : rawCoverImage;
    const headerImageSrc = coverImageUrl || member.avatar_url;
    // Use 3:1 for avatars (shorter height), wider ratio for actual cover images
    const headerAspectRatio = isUsingAvatarAsCover ? '3:1' : viewMode === 'cards' ? '16:7' : '3:1';
    const renderDisplayFields = ()=>{
        if (!processedDisplayFields) return null;
        return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: "member-fields",
            children: processedDisplayFields.map((field)=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "member-field",
                    "data-field-id": field.fieldId,
                    id: `geo-xfield-${field.fieldId}`,
                    children: [
                        !field.hideLabel && /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                            className: "field-label",
                            children: [
                                field.label,
                                ":"
                            ]
                        }),
                        field.isHtml ? /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            className: "field-value field-html-content",
                            dangerouslySetInnerHTML: {
                                __html: field.value
                            }
                        }) : /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            className: "field-value",
                            children: field.value
                        })
                    ]
                }, field.key))
        });
    };
    const renderLocationInfo = ()=>{
        if (member.has_location) return null;
        return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "location-info",
            children: [
                "\uD83D\uDCCD ",
                member.location_text || 'No location set'
            ]
        });
    };
    // Memoize favorite status check
    const memberIsFavorite = (0, $bh6RR.useMemo)(()=>{
        return isFavorite(member.user_id);
    }, [
        isFavorite,
        member.user_id
    ]);
    // Memoize pending status check  
    const memberIsPending = (0, $bh6RR.useMemo)(()=>{
        return isPendingFavorite(member.user_id);
    }, [
        isPendingFavorite,
        member.user_id
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: `member-card ${viewMode}-view`,
        "data-user-id": member.user_id,
        "data-member-id": member.user_id,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ...props,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: `member-cover-header ${isUsingAvatarAsCover ? 'avatar-as-cover' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e1959f263d7c540$export$2e2bcd8739ae039), {
                        src: headerImageSrc,
                        alt: displayName,
                        className: `member-cover-image ${isUsingAvatarAsCover ? 'is-avatar' : ''}`,
                        aspectRatio: headerAspectRatio,
                        isAvatar: isUsingAvatarAsCover,
                        avatarWidth: viewMode === 'compact' ? '90%' : '30%'
                    }),
                    isLoggedIn && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "header-actions",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $46492165c57fbd0a$export$2e2bcd8739ae039), {
                            userId: member.user_id,
                            isFavorite: memberIsFavorite,
                            onToggle: onToggleFavorite,
                            isPending: memberIsPending,
                            size: "icon",
                            variant: "overlay"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "member-content",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "member-info",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                                className: "member-name",
                                children: displayName
                            }),
                            processedIntroText && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "member-intro",
                                children: processedIntroText
                            }),
                            renderLocationInfo(),
                            renderDisplayFields(),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "member-meta",
                                children: formattedActivityDate && /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                    className: "last-activity",
                                    children: [
                                        "Active: ",
                                        formattedActivityDate
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "member-actions",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $6d110c7f994fee80$export$2e2bcd8739ae039), {
                                profileUrl: member.profile_url,
                                memberName: displayName,
                                size: viewMode === 'compact' ? 'icon' : 'small',
                                variant: "outline"
                            }),
                            config?.gwVisitsCalendarEnabled && /*#__PURE__*/ (0, $ih19M.jsx)((0, $06fe465818eef2df$export$2e2bcd8739ae039), {
                                userId: member.user_id,
                                userName: displayName,
                                size: viewMode === 'compact' ? 'icon' : 'small',
                                variant: "outline"
                            }),
                            actionFields && actionFields.map((field)=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    className: "action-field",
                                    "data-field-id": field.fieldId,
                                    children: field.isHtml ? /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: field.value
                                        }
                                    }) : field.value
                                }, field.key)),
                            isLoggedIn && /*#__PURE__*/ (0, $ih19M.jsx)((0, $a1fea1d50965ba93$export$2e2bcd8739ae039), {
                                recipientId: member.user_id,
                                recipientName: displayName,
                                size: viewMode === 'compact' ? 'icon' : 'small',
                                variant: "outline"
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
var $890a3db709ac5fb3$export$2e2bcd8739ae039 = $890a3db709ac5fb3$var$OptimizedMemberCard;



var $fFSBL = parcelRequire("fFSBL");

var $bh6RR = parcelRequire("bh6RR");
function $24a650417eec3ffb$export$8a3a215bf1bb808c(members, dependencies = [], options = {}) {
    const { externalSortBy: externalSortBy, onSortChange: onSortChange, sortOptions: sortOptions = [], externalViewMode: externalViewMode, onViewModeChange: onViewModeChange } = options;
    const [internalSortBy, setInternalSortBy] = (0, $bh6RR.useState)('joined');
    const [internalViewMode, setInternalViewMode] = (0, $bh6RR.useState)('cards');
    const [pinnedMemberId, setPinnedMemberId] = (0, $bh6RR.useState)(null);
    const listRef = (0, $bh6RR.useRef)(null);
    const sortedMembersRef = (0, $bh6RR.useRef)([]);
    const sortBy = externalSortBy ?? internalSortBy;
    const viewMode = externalViewMode ?? internalViewMode;
    const resolvedSortOptions = (0, $bh6RR.useMemo)(()=>{
        if (Array.isArray(sortOptions) && sortOptions.length > 0) return sortOptions;
        return [
            {
                value: 'joined',
                label: 'Recently Joined',
                builtin: true,
                type: 'date'
            },
            {
                value: 'joined_asc',
                label: 'Oldest Joined',
                builtin: true,
                type: 'date'
            },
            {
                value: 'last_active',
                label: 'Recently Active',
                builtin: true,
                type: 'date'
            },
            {
                value: 'last_active_asc',
                label: 'Least Recently Active',
                builtin: true,
                type: 'date'
            },
            {
                value: 'name',
                label: 'Name (A-Z)',
                builtin: true,
                type: 'text'
            },
            {
                value: 'name_desc',
                label: 'Name (Z-A)',
                builtin: true,
                type: 'text'
            }
        ];
    }, [
        sortOptions
    ]);
    const sortOptionMap = (0, $bh6RR.useMemo)(()=>{
        const map = new Map();
        resolvedSortOptions.forEach((option)=>{
            if (option?.value) map.set(option.value, option);
        });
        return map;
    }, [
        resolvedSortOptions
    ]);
    const normalizeText = (0, $bh6RR.useCallback)((value)=>{
        if (Array.isArray(value)) return value.filter((entry)=>entry !== null && entry !== undefined).join(', ').toLowerCase();
        if (value === null || value === undefined) return '';
        return String(value).trim().toLowerCase();
    }, []);
    const normalizeNumber = (0, $bh6RR.useCallback)((value)=>{
        if (Array.isArray(value)) value = value.find((entry)=>entry !== null && entry !== undefined && String(entry).trim() !== '');
        if (value === null || value === undefined || value === '') return null;
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
    }, []);
    const normalizeDate = (0, $bh6RR.useCallback)((value)=>{
        if (Array.isArray(value)) value = value.find((entry)=>entry !== null && entry !== undefined && String(entry).trim() !== '');
        if (value === null || value === undefined || value === '') return null;
        const parsed = new Date(value).getTime();
        return Number.isFinite(parsed) ? parsed : null;
    }, []);
    const compareWithEmptyLast = (0, $bh6RR.useCallback)((a, b, direction, comparator)=>{
        const aEmpty = a === null || a === undefined || a === '';
        const bEmpty = b === null || b === undefined || b === '';
        if (aEmpty && bEmpty) return 0;
        if (aEmpty) return 1;
        if (bEmpty) return -1;
        return direction === 'desc' ? comparator(b, a) : comparator(a, b);
    }, []);
    const getMemberFieldValue = (0, $bh6RR.useCallback)((member, fieldId)=>{
        if (!member?.display_fields || !Array.isArray(member.display_fields)) return null;
        const target = member.display_fields.find((field)=>Number(field.field_id) === Number(fieldId));
        if (!target) return null;
        return target.sort_value ?? target.value ?? null;
    }, []);
    const compareMembers = (0, $bh6RR.useCallback)((a, b, currentSortBy)=>{
        switch(currentSortBy){
            case 'name':
                return compareWithEmptyLast(normalizeText(a.display_name), normalizeText(b.display_name), 'asc', (left, right)=>left.localeCompare(right));
            case 'name_desc':
                return compareWithEmptyLast(normalizeText(a.display_name), normalizeText(b.display_name), 'desc', (left, right)=>left.localeCompare(right));
            case 'joined':
                return compareWithEmptyLast(normalizeDate(a.member_since), normalizeDate(b.member_since), 'desc', (left, right)=>left - right);
            case 'joined_asc':
                return compareWithEmptyLast(normalizeDate(a.member_since), normalizeDate(b.member_since), 'asc', (left, right)=>left - right);
            case 'last_active':
                return compareWithEmptyLast(normalizeDate(a.last_activity ?? a.lastActive), normalizeDate(b.last_activity ?? b.lastActive), 'desc', (left, right)=>left - right);
            case 'last_active_asc':
                return compareWithEmptyLast(normalizeDate(a.last_activity ?? a.lastActive), normalizeDate(b.last_activity ?? b.lastActive), 'asc', (left, right)=>left - right);
            default:
                break;
        }
        const option = sortOptionMap.get(currentSortBy);
        if (!option || option.fieldId === undefined || option.fieldId === null) return 0;
        const direction = option.direction === 'desc' ? 'desc' : 'asc';
        const rawA = getMemberFieldValue(a, option.fieldId);
        const rawB = getMemberFieldValue(b, option.fieldId);
        if (option.type === 'number') return compareWithEmptyLast(normalizeNumber(rawA), normalizeNumber(rawB), direction, (left, right)=>left - right);
        if (option.type === 'date') return compareWithEmptyLast(normalizeDate(rawA), normalizeDate(rawB), direction, (left, right)=>left - right);
        return compareWithEmptyLast(normalizeText(rawA), normalizeText(rawB), direction, (left, right)=>left.localeCompare(right));
    }, [
        compareWithEmptyLast,
        getMemberFieldValue,
        normalizeDate,
        normalizeNumber,
        normalizeText,
        sortOptionMap
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!sortOptionMap.has(sortBy)) {
            if (onSortChange) onSortChange('joined');
            else setInternalSortBy('joined');
        }
    }, [
        onSortChange,
        sortBy,
        sortOptionMap
    ]);
    // Debounced sorting to prevent excessive re-computations
    const sortedMembers = (0, $bh6RR.useMemo)(()=>{
        if (!members || members.length === 0) return [];
        const sorted = [
            ...members
        ].sort((a, b)=>compareMembers(a, b, sortBy));
        // Move pinned member to position 0 if set
        if (pinnedMemberId) {
            const pinnedIndex = sorted.findIndex((m)=>m.user_id === pinnedMemberId);
            if (pinnedIndex > 0) {
                const [pinned] = sorted.splice(pinnedIndex, 1);
                sorted.unshift(pinned);
            }
        }
        // Cache sorted results for performance
        sortedMembersRef.current = sorted;
        return sorted;
    }, [
        members,
        sortBy,
        pinnedMemberId,
        compareMembers,
        ...dependencies
    ]);
    // Pin a member to the top of the list
    const pinMember = (0, $bh6RR.useCallback)((memberId)=>{
        setPinnedMemberId(memberId);
    }, []);
    // Clear the pinned member
    const clearPinnedMember = (0, $bh6RR.useCallback)(()=>{
        setPinnedMemberId(null);
    }, []);
    // Optimized scroll to member function
    const scrollToMember = (0, $bh6RR.useCallback)((memberId)=>{
        const memberIndex = sortedMembersRef.current.findIndex((m)=>m.user_id === memberId);
        if (memberIndex !== -1 && listRef.current) {
            listRef.current.scrollToItem(memberIndex, 'center');
            return true;
        }
        return false;
    }, []);
    // Batch view mode changes to prevent multiple re-renders
    const changeViewMode = (0, $bh6RR.useCallback)((newMode)=>{
        if (newMode !== viewMode) {
            if (onViewModeChange) onViewModeChange(newMode);
            else setInternalViewMode(newMode);
            // Small delay to allow component to re-render before resetting scroll position
            setTimeout(()=>{
                if (listRef.current) listRef.current.resetAfterIndex(0);
            }, 0);
        }
    }, [
        viewMode,
        onViewModeChange
    ]);
    // Optimized sort change with immediate feedback
    const changeSortBy = (0, $bh6RR.useCallback)((newSort)=>{
        if (newSort !== sortBy) {
            if (onSortChange) onSortChange(newSort);
            else setInternalSortBy(newSort);
        }
    }, [
        sortBy,
        onSortChange
    ]);
    // Get visible range for debugging/optimization
    const getVisibleRange = (0, $bh6RR.useCallback)(()=>{
        if (!listRef.current) return null;
        // This would need to be implemented based on react-window's internals
        // For now, return basic info
        return {
            startIndex: 0,
            endIndex: Math.min(10, sortedMembers.length - 1)
        };
    }, [
        sortedMembers.length
    ]);
    return {
        sortBy: sortBy,
        viewMode: viewMode,
        sortedMembers: sortedMembers,
        listRef: listRef,
        pinnedMemberId: pinnedMemberId,
        setSortBy: changeSortBy,
        setViewMode: changeViewMode,
        scrollToMember: scrollToMember,
        pinMember: pinMember,
        clearPinnedMember: clearPinnedMember,
        getVisibleRange: getVisibleRange
    };
}
function $24a650417eec3ffb$export$497518a8644fcabe(onMemberHover, onMemberHoverOut, delay = 100) {
    const hoverTimeoutRef = (0, $bh6RR.useRef)(null);
    const currentHoveredRef = (0, $bh6RR.useRef)(null);
    const handleMemberHover = (0, $bh6RR.useCallback)((member)=>{
        // Clear any existing timeout
        if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
        // Don't trigger if it's the same member
        if (currentHoveredRef.current?.user_id === member.user_id) return;
        // Set timeout for hover
        hoverTimeoutRef.current = setTimeout(()=>{
            currentHoveredRef.current = member;
            onMemberHover?.(member);
        }, delay);
    }, [
        onMemberHover,
        delay
    ]);
    const handleMemberHoverOut = (0, $bh6RR.useCallback)(()=>{
        // Clear any pending hover
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
        // Small delay before clearing hover to prevent flickering
        setTimeout(()=>{
            currentHoveredRef.current = null;
            onMemberHoverOut?.();
        }, 50);
    }, [
        onMemberHoverOut
    ]);
    // Cleanup on unmount
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    return {
        handleMemberHover: handleMemberHover,
        handleMemberHoverOut: handleMemberHoverOut
    };
}
function $24a650417eec3ffb$export$57ad6230e9163278(isFavorite, isPendingFavorite, onToggleFavorite) {
    const favoritesCache = (0, $bh6RR.useRef)(new Map());
    const pendingCache = (0, $bh6RR.useRef)(new Map());
    // Memoized favorite checker
    const checkIsFavorite = (0, $bh6RR.useCallback)((userId)=>{
        if (favoritesCache.current.has(userId)) return favoritesCache.current.get(userId);
        const result = isFavorite(userId);
        favoritesCache.current.set(userId, result);
        return result;
    }, [
        isFavorite
    ]);
    // Memoized pending checker
    const checkIsPending = (0, $bh6RR.useCallback)((userId)=>{
        if (pendingCache.current.has(userId)) return pendingCache.current.get(userId);
        const result = isPendingFavorite(userId);
        pendingCache.current.set(userId, result);
        return result;
    }, [
        isPendingFavorite
    ]);
    // Optimized toggle with cache invalidation
    const handleToggleFavorite = (0, $bh6RR.useCallback)((userId)=>{
        // Invalidate cache for this user
        favoritesCache.current.delete(userId);
        pendingCache.current.delete(userId);
        // Trigger the actual toggle
        onToggleFavorite(userId);
    }, [
        onToggleFavorite
    ]);
    // Clear cache when dependencies change
    (0, $bh6RR.useEffect)(()=>{
        favoritesCache.current.clear();
        pendingCache.current.clear();
    }, [
        isFavorite,
        isPendingFavorite
    ]);
    return {
        checkIsFavorite: checkIsFavorite,
        checkIsPending: checkIsPending,
        handleToggleFavorite: handleToggleFavorite
    };
}


const $6f60a1b0b070d9bc$var$DEFAULT_CARD_HEIGHT = 400; // Default height estimate for cards (increased for wider screens)
const $6f60a1b0b070d9bc$var$DEFAULT_COMPACT_HEIGHT = 115; // Default height estimate for compact view
const $6f60a1b0b070d9bc$var$OVERSCAN_COUNT = 5; // Number of items to render outside visible area
// ── Stable top-level components for react-window ──
// Defined outside VirtualizedMemberList so their component identity never changes.
// This prevents react-window from unmounting/remounting rows on every state change,
// which was causing LazyCoverImage/LazyAvatar to lose loaded state and reload images.
const $6f60a1b0b070d9bc$var$MeasuredCompactCard = /*#__PURE__*/ (0, $bh6RR.memo)(function MeasuredCompactCard({ index: index, member: member, viewMode: viewMode, isHighlighted: isHighlighted, style: style, data: data }) {
    const { config: config, handleMemberClick: handleMemberClick, checkIsFavorite: checkIsFavorite, handleToggleFavorite: handleToggleFavorite, checkIsPending: checkIsPending, isLoggedIn: isLoggedIn, setItemHeight: setItemHeight } = data;
    const measureRef = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        if (measureRef.current) {
            const height = measureRef.current.scrollHeight;
            setItemHeight(index, height);
        }
    });
    const { height: _, ...positionStyle } = style;
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        ref: measureRef,
        style: {
            ...positionStyle,
            overflow: 'visible'
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: `virtualized-member-item ${viewMode}-view ${isHighlighted ? 'member-highlighted' : ''}`,
            "data-member-id": member.user_id,
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $890a3db709ac5fb3$export$2e2bcd8739ae039), {
                member: member,
                viewMode: viewMode,
                config: config,
                onClick: ()=>handleMemberClick(member),
                isFavorite: checkIsFavorite,
                onToggleFavorite: handleToggleFavorite,
                isPendingFavorite: checkIsPending,
                isLoggedIn: isLoggedIn,
                "data-member-id": member.user_id
            }, member.user_id)
        })
    });
});
const $6f60a1b0b070d9bc$var$MeasuredGridRowComp = /*#__PURE__*/ (0, $bh6RR.memo)(function MeasuredGridRowComp({ index: index, items: items, style: style, columns: columns, setItemHeight: setItemHeight }) {
    const measureRef = (0, $bh6RR.useRef)(null);
    (0, $bh6RR.useEffect)(()=>{
        if (measureRef.current) {
            const height = measureRef.current.scrollHeight;
            setItemHeight(index, height);
        }
    });
    const { height: _, ...positionStyle } = style;
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        ref: measureRef,
        style: {
            ...positionStyle,
            overflow: 'visible'
        },
        className: "virtualized-grid-row",
        role: "row",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: "virtualized-grid",
            style: {
                display: 'grid',
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
                gridAutoRows: 'minmax(auto, max-content)'
            },
            children: items
        })
    });
});
// Main row component used by react-window – receives all dynamic data via the `data` prop
const $6f60a1b0b070d9bc$var$VirtualRow = /*#__PURE__*/ (0, $bh6RR.memo)(function VirtualRow({ index: index, style: style, data: data }) {
    const { sortedMembers: sortedMembers, viewMode: viewMode, highlightedMemberId: highlightedMemberId, config: config, columns: columns, handleMemberClick: handleMemberClick, checkIsFavorite: checkIsFavorite, handleToggleFavorite: handleToggleFavorite, checkIsPending: checkIsPending, isLoggedIn: isLoggedIn, setItemHeight: setItemHeight } = data;
    if (viewMode === 'compact') {
        const member = sortedMembers[index];
        if (!member) return null;
        const isHighlighted = highlightedMemberId === member.user_id;
        return /*#__PURE__*/ (0, $ih19M.jsx)($6f60a1b0b070d9bc$var$MeasuredCompactCard, {
            index: index,
            member: member,
            viewMode: viewMode,
            isHighlighted: isHighlighted,
            style: style,
            data: data
        });
    }
    // Cards view: render a grid row with N columns
    const startIndex = index * columns;
    const items = [];
    for(let col = 0; col < columns; col++){
        const itemIndex = startIndex + col;
        const member = sortedMembers[itemIndex];
        if (!member) break;
        const isHighlighted = highlightedMemberId === member.user_id;
        items.push(/*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: `virtualized-member-item cards-view ${isHighlighted ? 'member-highlighted' : ''}`,
            "data-member-id": member.user_id,
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $890a3db709ac5fb3$export$2e2bcd8739ae039), {
                member: member,
                viewMode: 'cards',
                config: config,
                onClick: ()=>handleMemberClick(member),
                isFavorite: checkIsFavorite,
                onToggleFavorite: handleToggleFavorite,
                isPendingFavorite: checkIsPending,
                isLoggedIn: isLoggedIn,
                "data-member-id": member.user_id
            })
        }, member.user_id));
    }
    return /*#__PURE__*/ (0, $ih19M.jsx)($6f60a1b0b070d9bc$var$MeasuredGridRowComp, {
        index: index,
        items: items,
        style: style,
        columns: columns,
        setItemHeight: setItemHeight
    });
});
function $6f60a1b0b070d9bc$var$VirtualizedMemberList({ members: members, loading: loading, config: config, onMemberHover: onMemberHover, onMemberHoverOut: onMemberHoverOut, registerMemberList: registerMemberList, isFavorite: isFavorite, onToggleFavorite: onToggleFavorite, isPendingFavorite: isPendingFavorite, isLoggedIn: isLoggedIn = true, showResultCount: showResultCount = false, totalMembers: totalMembers, sortBy: externalSortBy, onSortChange: onSortChange, sortOptions: sortOptions = [], viewMode: externalViewMode, onViewModeChange: onViewModeChange }) {
    const containerRef = (0, $bh6RR.useRef)(null);
    const itemHeights = (0, $bh6RR.useRef)(new Map());
    const resetPending = (0, $bh6RR.useRef)(false);
    const resetMinIndex = (0, $bh6RR.useRef)(Infinity);
    const [highlightedMemberId, setHighlightedMemberId] = (0, $bh6RR.useState)(null);
    const { isMobile: isMobile, isTablet: isTablet, isDesktop: isDesktop } = (0, $f9a85ac8928fb9dc$export$37dc31edf9cb7f3)();
    // Determine columns based on viewport; target 3 columns on desktop
    const columns = (0, $bh6RR.useMemo)(()=>{
        if (isDesktop) return 3;
        if (isTablet) return 2;
        return 1;
    }, [
        isDesktop,
        isTablet
    ]);
    // Use our optimization hooks
    const { sortBy: sortBy, viewMode: viewMode, sortedMembers: sortedMembers, listRef: listRef, pinnedMemberId: pinnedMemberId, setSortBy: setSortBy, setViewMode: setViewMode, scrollToMember: scrollToMember, pinMember: pinMember } = (0, $24a650417eec3ffb$export$8a3a215bf1bb808c)(members, [], {
        externalSortBy: externalSortBy,
        onSortChange: onSortChange,
        sortOptions: sortOptions,
        externalViewMode: externalViewMode,
        onViewModeChange: onViewModeChange
    });
    const { handleMemberHover: handleMemberHover, handleMemberHoverOut: handleMemberHoverOut } = (0, $24a650417eec3ffb$export$497518a8644fcabe)(onMemberHover, onMemberHoverOut, 150);
    const { checkIsFavorite: checkIsFavorite, checkIsPending: checkIsPending, handleToggleFavorite: handleToggleFavorite } = (0, $24a650417eec3ffb$export$57ad6230e9163278)(isFavorite, isPendingFavorite, onToggleFavorite);
    // Register the list container with the parent
    (0, $bh6RR.useEffect)(()=>{
        if (registerMemberList && containerRef.current) registerMemberList(containerRef.current);
    }, [
        registerMemberList
    ]);
    // Get item height for variable size list
    const getItemHeight = (0, $bh6RR.useCallback)((index)=>{
        const cached = itemHeights.current.get(index);
        if (cached) return cached;
        // Return estimated height based on view mode
        if (viewMode === 'compact') return $6f60a1b0b070d9bc$var$DEFAULT_COMPACT_HEIGHT;
        else // For cards view, we need to account for multiple cards per row
        // Use a larger estimate to prevent content cutoff at wider screens
        return $6f60a1b0b070d9bc$var$DEFAULT_CARD_HEIGHT + 60; // Extra padding for row container and larger content
    }, [
        viewMode
    ]);
    // Set item height after render and batch react-window resets for performance
    const setItemHeight = (0, $bh6RR.useCallback)((index, height)=>{
        const currentHeight = itemHeights.current.get(index);
        if (currentHeight !== height) {
            itemHeights.current.set(index, height);
            resetMinIndex.current = Math.min(resetMinIndex.current, index);
            // Batch resets: schedule a single forced resetAfterIndex per animation frame
            if (!resetPending.current) {
                resetPending.current = true;
                requestAnimationFrame(()=>{
                    if (listRef.current && typeof listRef.current.resetAfterIndex === 'function') listRef.current.resetAfterIndex(resetMinIndex.current, true);
                    resetPending.current = false;
                    resetMinIndex.current = Infinity;
                });
            }
        }
    }, []);
    // Handle member card click for highlighting
    const handleMemberClick = (0, $bh6RR.useCallback)((member)=>{
        setHighlightedMemberId(member.user_id);
        // Optional: also trigger the hover callback for map sync
        handleMemberHover(member);
    }, [
        handleMemberHover
    ]);
    // Memoized data object passed to VirtualRow via react-window's itemData prop.
    // This keeps the VirtualRow component reference stable across re-renders,
    // preventing unmount/remount of rows (which caused images to reload).
    const itemData = (0, $bh6RR.useMemo)(()=>({
            sortedMembers: sortedMembers,
            viewMode: viewMode,
            highlightedMemberId: highlightedMemberId,
            config: config,
            columns: columns,
            handleMemberClick: handleMemberClick,
            checkIsFavorite: checkIsFavorite,
            handleToggleFavorite: handleToggleFavorite,
            checkIsPending: checkIsPending,
            isLoggedIn: isLoggedIn,
            setItemHeight: setItemHeight
        }), [
        sortedMembers,
        viewMode,
        highlightedMemberId,
        config,
        columns,
        handleMemberClick,
        checkIsFavorite,
        handleToggleFavorite,
        checkIsPending,
        isLoggedIn,
        setItemHeight
    ]);
    // Track the actual members array (not sortedMembers which changes on pin)
    // to avoid full height-cache clears when only pinning changes the order.
    const prevMembersRef = (0, $bh6RR.useRef)(members);
    const prevViewModeRef = (0, $bh6RR.useRef)(viewMode);
    (0, $bh6RR.useEffect)(()=>{
        const membersChanged = prevMembersRef.current !== members;
        const viewModeChanged = prevViewModeRef.current !== viewMode;
        prevMembersRef.current = members;
        prevViewModeRef.current = viewMode;
        if (membersChanged || viewModeChanged) {
            itemHeights.current.clear();
            requestAnimationFrame(()=>{
                if (listRef.current && typeof listRef.current.resetAfterIndex === 'function') listRef.current.resetAfterIndex(0, true);
            });
        } else if (sortedMembers) // Pinning only – reset index positions without clearing height cache
        requestAnimationFrame(()=>{
            if (listRef.current && typeof listRef.current.resetAfterIndex === 'function') listRef.current.resetAfterIndex(0, false);
        });
    }, [
        viewMode,
        members,
        sortedMembers
    ]);
    // Scroll to top when a member is pinned (after re-render places it at index 0)
    (0, $bh6RR.useEffect)(()=>{
        if (pinnedMemberId && listRef.current) requestAnimationFrame(()=>{
            if (listRef.current) listRef.current.scrollToItem(0, 'start');
        });
    }, [
        pinnedMemberId
    ]);
    // Expose scroll method to parent
    (0, $bh6RR.useEffect)(()=>{
        if (containerRef.current) {
            containerRef.current.scrollToMember = scrollToMember;
            // Expose additional methods for map sync
            containerRef.current.highlightMember = (memberId)=>{
                // Pin the member to position #1, highlight it, and scroll to top
                pinMember(memberId);
                setHighlightedMemberId(memberId);
                return true;
            };
            containerRef.current.clearHighlight = ()=>{
                setHighlightedMemberId(null);
            };
            // Flag to indicate this is a virtualized list
            containerRef.current.isVirtualized = true;
        }
    }, [
        scrollToMember,
        sortedMembers,
        viewMode,
        columns,
        pinMember
    ]);
    if (loading && members.length === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "member-list-container",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fFSBL.default), {})
    });
    if (members.length === 0) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "member-list-container",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "no-results",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                    children: "No members found"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    children: "Try adjusting your search criteria or filters."
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "member-list-container",
        ref: containerRef,
        children: [
            !isMobile && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "list-controls",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "sort-controls",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                htmlFor: "sort-select",
                                children: "Sort by:"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("select", {
                                id: "sort-select",
                                value: sortBy,
                                onChange: (e)=>setSortBy(e.target.value),
                                className: "sort-select",
                                children: (sortOptions.length > 0 ? sortOptions : [
                                    {
                                        value: 'joined',
                                        label: 'Recently Joined'
                                    },
                                    {
                                        value: 'joined_asc',
                                        label: 'Oldest Joined'
                                    },
                                    {
                                        value: 'last_active',
                                        label: 'Recently Active'
                                    },
                                    {
                                        value: 'last_active_asc',
                                        label: 'Least Recently Active'
                                    },
                                    {
                                        value: 'name',
                                        label: 'Name (A-Z)'
                                    },
                                    {
                                        value: 'name_desc',
                                        label: 'Name (Z-A)'
                                    }
                                ]).map((option)=>/*#__PURE__*/ (0, $ih19M.jsx)("option", {
                                        value: option.value,
                                        children: option.label
                                    }, option.value))
                            })
                        ]
                    }),
                    showResultCount && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "result-count",
                        children: totalMembers !== undefined ? `Displaying ${sortedMembers.length} of ${totalMembers} users found` : `${sortedMembers.length} user${sortedMembers.length !== 1 ? 's' : ''} found`
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "view-controls",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                onClick: ()=>setViewMode('cards'),
                                className: `view-btn ${viewMode === 'cards' ? 'active' : ''}`,
                                "aria-label": "Card view",
                                children: "Cards"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                onClick: ()=>setViewMode('compact'),
                                className: `view-btn ${viewMode === 'compact' ? 'active' : ''}`,
                                "aria-label": "Compact view",
                                children: "Compact"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "virtualized-list-container",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3cc8a1e45b82291d$export$d8ac3b6b20be856e), {
                    ref: listRef,
                    height: 500,
                    itemCount: viewMode === 'cards' ? Math.ceil(sortedMembers.length / columns) : sortedMembers.length,
                    itemSize: getItemHeight,
                    overscanCount: $6f60a1b0b070d9bc$var$OVERSCAN_COUNT,
                    className: `virtualized-member-list ${viewMode}-view`,
                    itemData: itemData,
                    children: $6f60a1b0b070d9bc$var$VirtualRow
                })
            }),
            loading && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "loading-more",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $fFSBL.default), {
                        size: "small"
                    }),
                    "Loading more members..."
                ]
            })
        ]
    });
}
var $6f60a1b0b070d9bc$export$2e2bcd8739ae039 = $6f60a1b0b070d9bc$var$VirtualizedMemberList;


parcelRequire("fFSBL");
// Performance monitoring utilities for the virtualized member list
class $8d9aa284852b0090$export$9b229b42dc5ba616 {
    constructor(){
        this.metrics = new Map();
        this.observers = new Map();
        this.isEnabled = window.location.search.includes('debug=performance');
    }
    // Start timing a performance metric
    startTiming(label) {
        if (!this.isEnabled) return;
        const startTime = performance.now();
        this.metrics.set(label, {
            startTime: startTime,
            type: 'timing'
        });
    }
    // End timing and log result
    endTiming(label) {
        if (!this.isEnabled) return;
        const metric = this.metrics.get(label);
        if (metric && metric.type === 'timing') {
            const duration = performance.now() - metric.startTime;
            console.log(`\u{23F1}\u{FE0F} Performance: ${label} took ${duration.toFixed(2)}ms`);
            this.metrics.set(label, {
                ...metric,
                duration: duration,
                endTime: performance.now()
            });
        }
    }
    // Track render count
    trackRender(componentName) {
        if (!this.isEnabled) return;
        const key = `render_${componentName}`;
        const existing = this.metrics.get(key);
        const count = existing ? existing.count + 1 : 1;
        this.metrics.set(key, {
            count: count,
            type: 'render',
            lastRender: performance.now()
        });
        if (count % 10 === 0) console.log(`\u{1F504} Performance: ${componentName} has rendered ${count} times`);
    }
    // Track memory usage (approximate)
    trackMemory(label) {
        if (!this.isEnabled || !performance.memory) return;
        const memory = {
            used: performance.memory.usedJSHeapSize,
            total: performance.memory.totalJSHeapSize,
            limit: performance.memory.jsHeapSizeLimit
        };
        console.log(`\u{1F4BE} Memory (${label}):`, {
            used: `${(memory.used / 1048576).toFixed(2)}MB`,
            total: `${(memory.total / 1048576).toFixed(2)}MB`,
            percentage: `${(memory.used / memory.total * 100).toFixed(1)}%`
        });
    }
    // Monitor FPS during scrolling
    startFPSMonitoring(container) {
        if (!this.isEnabled) return;
        let frameCount = 0;
        let lastTime = performance.now();
        let animationId;
        const measureFPS = ()=>{
            frameCount++;
            const currentTime = performance.now();
            if (currentTime - lastTime >= 1000) {
                const fps = Math.round(frameCount * 1000 / (currentTime - lastTime));
                console.log(`\u{1F4CA} FPS: ${fps} frames per second`);
                frameCount = 0;
                lastTime = currentTime;
            }
            animationId = requestAnimationFrame(measureFPS);
        };
        const startMonitoring = ()=>{
            if (!animationId) measureFPS();
        };
        const stopMonitoring = ()=>{
            if (animationId) {
                cancelAnimationFrame(animationId);
                animationId = null;
            }
        };
        // Monitor during scroll
        container.addEventListener('scroll', startMonitoring);
        // Stop monitoring after scroll ends
        let scrollTimeout;
        container.addEventListener('scroll', ()=>{
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(stopMonitoring, 1000);
        });
        this.observers.set('fps', {
            startMonitoring: startMonitoring,
            stopMonitoring: stopMonitoring
        });
        return ()=>{
            container.removeEventListener('scroll', startMonitoring);
            stopMonitoring();
        };
    }
    // Monitor DOM node count
    monitorDOMNodes(label = 'default') {
        if (!this.isEnabled) return;
        const nodeCount = document.querySelectorAll('*').length;
        console.log(`\u{1F3D7}\u{FE0F} DOM Nodes (${label}): ${nodeCount}`);
        return nodeCount;
    }
    // Track intersection observer performance
    trackIntersectionObserver(entries, observerName = 'default') {
        if (!this.isEnabled) return;
        const visible = entries.filter((entry)=>entry.isIntersecting).length;
        const total = entries.length;
        console.log(`\u{1F441}\u{FE0F} Intersection Observer (${observerName}): ${visible}/${total} items visible`);
    }
    // Generate performance report
    getReport() {
        if (!this.isEnabled) return null;
        const report = {
            timestamp: new Date().toISOString(),
            metrics: Object.fromEntries(this.metrics),
            memory: performance.memory ? {
                used: performance.memory.usedJSHeapSize,
                total: performance.memory.totalJSHeapSize,
                limit: performance.memory.jsHeapSizeLimit
            } : null,
            timing: performance.timing ? {
                domComplete: performance.timing.domComplete - performance.timing.navigationStart,
                loadComplete: performance.timing.loadEventEnd - performance.timing.navigationStart
            } : null
        };
        console.table(this.metrics);
        return report;
    }
    // Clear all metrics
    clear() {
        this.metrics.clear();
        this.observers.clear();
    }
}
const $8d9aa284852b0090$export$e734799649365868 = new $8d9aa284852b0090$export$9b229b42dc5ba616();
function $8d9aa284852b0090$export$4fd1ca946eb45be1(componentName) {
    const monitor = $8d9aa284852b0090$export$e734799649365868;
    // Track render on every render
    monitor.trackRender(componentName);
    return {
        startTiming: (label)=>monitor.startTiming(`${componentName}_${label}`),
        endTiming: (label)=>monitor.endTiming(`${componentName}_${label}`),
        trackMemory: (label)=>monitor.trackMemory(`${componentName}_${label}`),
        monitorFPS: (container)=>monitor.startFPSMonitoring(container),
        getReport: ()=>monitor.getReport()
    };
}
function $8d9aa284852b0090$export$a8de6f70d03fc669(WrappedComponent, componentName) {
    return function PerformanceMonitoredComponent(props) {
        const monitor = $8d9aa284852b0090$export$4fd1ca946eb45be1(componentName);
        // Measure render time
        monitor.startTiming('render');
        const result = WrappedComponent(props);
        monitor.endTiming('render');
        return result;
    };
}


function $8ed5b744e753ec9f$var$PerformantMemberList({ members: members, loading: loading, config: config, onMemberHover: onMemberHover, onMemberHoverOut: onMemberHoverOut, registerMemberList: registerMemberList, isFavorite: isFavorite, onToggleFavorite: onToggleFavorite, isPendingFavorite: isPendingFavorite, isLoggedIn: isLoggedIn = true, enableVirtualization: enableVirtualization = true, performanceMode: performanceMode = 'auto', showResultCount: showResultCount = false, totalMembers: totalMembers, sortBy: sortBy, onSortChange: onSortChange, sortOptions: sortOptions, viewMode: viewMode, onViewModeChange: onViewModeChange }) {
    const [useVirtualization, setUseVirtualization] = (0, $bh6RR.useState)(enableVirtualization);
    const [showPerformanceToggle, setShowPerformanceToggle] = (0, $bh6RR.useState)(false);
    const memberCount = members?.length || 0;
    // Auto-decide on virtualization based on member count and performance mode
    (0, $bh6RR.useEffect)(()=>{
        setUseVirtualization(true);
    }, [
        memberCount,
        performanceMode,
        enableVirtualization,
        config
    ]);
    // Show performance toggle in development or when debug is enabled
    (0, $bh6RR.useEffect)(()=>{
        const isDevelopment = false;
        const hasDebugParam = window.location.search.includes('debug=performance');
        setShowPerformanceToggle(isDevelopment || hasDebugParam);
    }, []);
    // Monitor performance
    (0, $bh6RR.useEffect)(()=>{
        (0, $8d9aa284852b0090$export$e734799649365868).trackMemory('MemberList_Mount');
        (0, $8d9aa284852b0090$export$e734799649365868).monitorDOMNodes('MemberList_Mount');
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        (0, $8d9aa284852b0090$export$e734799649365868).startTiming('MemberList_DataUpdate');
        (0, $8d9aa284852b0090$export$e734799649365868).endTiming('MemberList_DataUpdate');
        (0, $8d9aa284852b0090$export$e734799649365868).trackMemory('MemberList_DataUpdate');
    }, [
        members
    ]);
    const handleToggleVirtualization = ()=>{
        (0, $8d9aa284852b0090$export$e734799649365868).startTiming('VirtualizationToggle');
        setUseVirtualization(!useVirtualization);
        (0, $8d9aa284852b0090$export$e734799649365868).endTiming('VirtualizationToggle');
        (0, $8d9aa284852b0090$export$e734799649365868).trackMemory('VirtualizationToggle');
    };
    // Render performance indicator
    const renderPerformanceInfo = ()=>{
        return null;
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        style: {
            position: 'relative'
        },
        children: [
            renderPerformanceInfo(),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $6f60a1b0b070d9bc$export$2e2bcd8739ae039), {
                members: members,
                loading: loading,
                config: config,
                onMemberHover: onMemberHover,
                onMemberHoverOut: onMemberHoverOut,
                registerMemberList: registerMemberList,
                isFavorite: isFavorite,
                onToggleFavorite: onToggleFavorite,
                isPendingFavorite: isPendingFavorite,
                isLoggedIn: isLoggedIn,
                showResultCount: showResultCount,
                totalMembers: totalMembers,
                sortBy: sortBy,
                onSortChange: onSortChange,
                sortOptions: sortOptions,
                viewMode: viewMode,
                onViewModeChange: onViewModeChange
            })
        ]
    });
}
var $8ed5b744e753ec9f$export$2e2bcd8739ae039 = $8ed5b744e753ec9f$var$PerformantMemberList;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bjwWZ = parcelRequire("bjwWZ");



var $657944b5b046418c$exports = {};
/*
 * Leaflet.markercluster 1.5.3+master.e5124b2,
 * Provides Beautiful Animated Marker Clustering functionality for Leaflet, a JS library for interactive maps.
 * https://github.com/Leaflet/Leaflet.markercluster
 * (c) 2012-2017, Dave Leaver, smartrak
 */ (function(global, factory) {
    factory($657944b5b046418c$exports);
})($657944b5b046418c$exports, function(exports1) {
    'use strict';
    /*
	 * L.MarkerClusterGroup extends L.FeatureGroup by clustering the markers contained within
	 */ var MarkerClusterGroup = L.MarkerClusterGroup = L.FeatureGroup.extend({
        options: {
            maxClusterRadius: 80,
            iconCreateFunction: null,
            clusterPane: L.Marker.prototype.options.pane,
            spiderfyOnEveryZoom: false,
            spiderfyOnMaxZoom: true,
            showCoverageOnHover: true,
            zoomToBoundsOnClick: true,
            singleMarkerMode: false,
            disableClusteringAtZoom: null,
            // Setting this to false prevents the removal of any clusters outside of the viewpoint, which
            // is the default behaviour for performance reasons.
            removeOutsideVisibleBounds: true,
            // Set to false to disable all animations (zoom and spiderfy).
            // If false, option animateAddingMarkers below has no effect.
            // If L.DomUtil.TRANSITION is falsy, this option has no effect.
            animate: true,
            //Whether to animate adding markers after adding the MarkerClusterGroup to the map
            // If you are adding individual markers set to true, if adding bulk markers leave false for massive performance gains.
            animateAddingMarkers: false,
            // Make it possible to provide custom function to calculate spiderfy shape positions
            spiderfyShapePositions: null,
            //Increase to increase the distance away that spiderfied markers appear from the center
            spiderfyDistanceMultiplier: 1,
            // Make it possible to specify a polyline options on a spider leg
            spiderLegPolylineOptions: {
                weight: 1.5,
                color: '#222',
                opacity: 0.5
            },
            // When bulk adding layers, adds markers in chunks. Means addLayers may not add all the layers in the call, others will be loaded during setTimeouts
            chunkedLoading: false,
            chunkInterval: 200,
            chunkDelay: 50,
            chunkProgress: null,
            //Options to pass to the L.Polygon constructor
            polygonOptions: {}
        },
        initialize: function(options) {
            L.Util.setOptions(this, options);
            if (!this.options.iconCreateFunction) this.options.iconCreateFunction = this._defaultIconCreateFunction;
            this._featureGroup = L.featureGroup();
            this._featureGroup.addEventParent(this);
            this._nonPointGroup = L.featureGroup();
            this._nonPointGroup.addEventParent(this);
            this._inZoomAnimation = 0;
            this._needsClustering = [];
            this._needsRemoving = []; //Markers removed while we aren't on the map need to be kept track of
            //The bounds of the currently shown area (from _getExpandedVisibleBounds) Updated on zoom/move
            this._currentShownBounds = null;
            this._queue = [];
            this._childMarkerEventHandlers = {
                'dragstart': this._childMarkerDragStart,
                'move': this._childMarkerMoved,
                'dragend': this._childMarkerDragEnd
            };
            // Hook the appropriate animation methods.
            var animate = L.DomUtil.TRANSITION && this.options.animate;
            L.extend(this, animate ? this._withAnimation : this._noAnimation);
            // Remember which MarkerCluster class to instantiate (animated or not).
            this._markerCluster = animate ? L.MarkerCluster : L.MarkerClusterNonAnimated;
        },
        addLayer: function(layer) {
            if (layer instanceof L.LayerGroup) return this.addLayers([
                layer
            ]);
            //Don't cluster non point data
            if (!layer.getLatLng) {
                this._nonPointGroup.addLayer(layer);
                this.fire('layeradd', {
                    layer: layer
                });
                return this;
            }
            if (!this._map) {
                this._needsClustering.push(layer);
                this.fire('layeradd', {
                    layer: layer
                });
                return this;
            }
            if (this.hasLayer(layer)) return this;
            //If we have already clustered we'll need to add this one to a cluster
            if (this._unspiderfy) this._unspiderfy();
            this._addLayer(layer, this._maxZoom);
            this.fire('layeradd', {
                layer: layer
            });
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            //Work out what is visible
            var visibleLayer = layer, currentZoom = this._zoom;
            if (layer.__parent) while(visibleLayer.__parent._zoom >= currentZoom)visibleLayer = visibleLayer.__parent;
            if (this._currentShownBounds.contains(visibleLayer.getLatLng())) {
                if (this.options.animateAddingMarkers) this._animationAddLayer(layer, visibleLayer);
                else this._animationAddLayerNonAnimated(layer, visibleLayer);
            }
            return this;
        },
        removeLayer: function(layer) {
            if (layer instanceof L.LayerGroup) return this.removeLayers([
                layer
            ]);
            //Non point layers
            if (!layer.getLatLng) {
                this._nonPointGroup.removeLayer(layer);
                this.fire('layerremove', {
                    layer: layer
                });
                return this;
            }
            if (!this._map) {
                if (!this._arraySplice(this._needsClustering, layer) && this.hasLayer(layer)) this._needsRemoving.push({
                    layer: layer,
                    latlng: layer._latlng
                });
                this.fire('layerremove', {
                    layer: layer
                });
                return this;
            }
            if (!layer.__parent) return this;
            if (this._unspiderfy) {
                this._unspiderfy();
                this._unspiderfyLayer(layer);
            }
            //Remove the marker from clusters
            this._removeLayer(layer, true);
            this.fire('layerremove', {
                layer: layer
            });
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            layer.off(this._childMarkerEventHandlers, this);
            if (this._featureGroup.hasLayer(layer)) {
                this._featureGroup.removeLayer(layer);
                if (layer.clusterShow) layer.clusterShow();
            }
            return this;
        },
        //Takes an array of markers and adds them in bulk
        addLayers: function(layersArray, skipLayerAddEvent) {
            if (!L.Util.isArray(layersArray)) return this.addLayer(layersArray);
            var fg = this._featureGroup, npg = this._nonPointGroup, chunked = this.options.chunkedLoading, chunkInterval = this.options.chunkInterval, chunkProgress = this.options.chunkProgress, l = layersArray.length, offset = 0, originalArray = true, m;
            if (this._map) {
                var started = new Date().getTime();
                var process = L.bind(function() {
                    var start = new Date().getTime();
                    // Make sure to unspiderfy before starting to add some layers
                    if (this._map && this._unspiderfy) this._unspiderfy();
                    for(; offset < l; offset++){
                        if (chunked && offset % 200 === 0) {
                            // every couple hundred markers, instrument the time elapsed since processing started:
                            var elapsed = new Date().getTime() - start;
                            if (elapsed > chunkInterval) break; // been working too hard, time to take a break :-)
                        }
                        m = layersArray[offset];
                        // Group of layers, append children to layersArray and skip.
                        // Side effects:
                        // - Total increases, so chunkProgress ratio jumps backward.
                        // - Groups are not included in this group, only their non-group child layers (hasLayer).
                        // Changing array length while looping does not affect performance in current browsers:
                        // http://jsperf.com/for-loop-changing-length/6
                        if (m instanceof L.LayerGroup) {
                            if (originalArray) {
                                layersArray = layersArray.slice();
                                originalArray = false;
                            }
                            this._extractNonGroupLayers(m, layersArray);
                            l = layersArray.length;
                            continue;
                        }
                        //Not point data, can't be clustered
                        if (!m.getLatLng) {
                            npg.addLayer(m);
                            if (!skipLayerAddEvent) this.fire('layeradd', {
                                layer: m
                            });
                            continue;
                        }
                        if (this.hasLayer(m)) continue;
                        this._addLayer(m, this._maxZoom);
                        if (!skipLayerAddEvent) this.fire('layeradd', {
                            layer: m
                        });
                        //If we just made a cluster of size 2 then we need to remove the other marker from the map (if it is) or we never will
                        if (m.__parent) {
                            if (m.__parent.getChildCount() === 2) {
                                var markers = m.__parent.getAllChildMarkers(), otherMarker = markers[0] === m ? markers[1] : markers[0];
                                fg.removeLayer(otherMarker);
                            }
                        }
                    }
                    if (chunkProgress) // report progress and time elapsed:
                    chunkProgress(offset, l, new Date().getTime() - started);
                    // Completed processing all markers.
                    if (offset === l) {
                        // Refresh bounds and weighted positions.
                        this._topClusterLevel._recalculateBounds();
                        this._refreshClustersIcons();
                        this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
                    } else setTimeout(process, this.options.chunkDelay);
                }, this);
                process();
            } else {
                var needsClustering = this._needsClustering;
                for(; offset < l; offset++){
                    m = layersArray[offset];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        if (originalArray) {
                            layersArray = layersArray.slice();
                            originalArray = false;
                        }
                        this._extractNonGroupLayers(m, layersArray);
                        l = layersArray.length;
                        continue;
                    }
                    //Not point data, can't be clustered
                    if (!m.getLatLng) {
                        npg.addLayer(m);
                        continue;
                    }
                    if (this.hasLayer(m)) continue;
                    needsClustering.push(m);
                }
            }
            return this;
        },
        //Takes an array of markers and removes them in bulk
        removeLayers: function(layersArray) {
            var i, m, l = layersArray.length, fg = this._featureGroup, npg = this._nonPointGroup, originalArray = true;
            if (!this._map) {
                for(i = 0; i < l; i++){
                    m = layersArray[i];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        if (originalArray) {
                            layersArray = layersArray.slice();
                            originalArray = false;
                        }
                        this._extractNonGroupLayers(m, layersArray);
                        l = layersArray.length;
                        continue;
                    }
                    this._arraySplice(this._needsClustering, m);
                    npg.removeLayer(m);
                    if (this.hasLayer(m)) this._needsRemoving.push({
                        layer: m,
                        latlng: m._latlng
                    });
                    this.fire('layerremove', {
                        layer: m
                    });
                }
                return this;
            }
            if (this._unspiderfy) {
                this._unspiderfy();
                // Work on a copy of the array, so that next loop is not affected.
                var layersArray2 = layersArray.slice(), l2 = l;
                for(i = 0; i < l2; i++){
                    m = layersArray2[i];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        this._extractNonGroupLayers(m, layersArray2);
                        l2 = layersArray2.length;
                        continue;
                    }
                    this._unspiderfyLayer(m);
                }
            }
            for(i = 0; i < l; i++){
                m = layersArray[i];
                // Group of layers, append children to layersArray and skip.
                if (m instanceof L.LayerGroup) {
                    if (originalArray) {
                        layersArray = layersArray.slice();
                        originalArray = false;
                    }
                    this._extractNonGroupLayers(m, layersArray);
                    l = layersArray.length;
                    continue;
                }
                if (!m.__parent) {
                    npg.removeLayer(m);
                    this.fire('layerremove', {
                        layer: m
                    });
                    continue;
                }
                this._removeLayer(m, true, true);
                this.fire('layerremove', {
                    layer: m
                });
                if (fg.hasLayer(m)) {
                    fg.removeLayer(m);
                    if (m.clusterShow) m.clusterShow();
                }
            }
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            //Fix up the clusters and markers on the map
            this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
            return this;
        },
        //Removes all layers from the MarkerClusterGroup
        clearLayers: function() {
            //Need our own special implementation as the LayerGroup one doesn't work for us
            //If we aren't on the map (yet), blow away the markers we know of
            if (!this._map) {
                this._needsClustering = [];
                this._needsRemoving = [];
                delete this._gridClusters;
                delete this._gridUnclustered;
            }
            if (this._noanimationUnspiderfy) this._noanimationUnspiderfy();
            //Remove all the visible layers
            this._featureGroup.clearLayers();
            this._nonPointGroup.clearLayers();
            this.eachLayer(function(marker) {
                marker.off(this._childMarkerEventHandlers, this);
                delete marker.__parent;
            }, this);
            if (this._map) //Reset _topClusterLevel and the DistanceGrids
            this._generateInitialClusters();
            return this;
        },
        //Override FeatureGroup.getBounds as it doesn't work
        getBounds: function() {
            var bounds = new L.LatLngBounds();
            if (this._topClusterLevel) bounds.extend(this._topClusterLevel._bounds);
            for(var i = this._needsClustering.length - 1; i >= 0; i--)bounds.extend(this._needsClustering[i].getLatLng());
            bounds.extend(this._nonPointGroup.getBounds());
            return bounds;
        },
        //Overrides LayerGroup.eachLayer
        eachLayer: function(method, context) {
            var markers = this._needsClustering.slice(), needsRemoving = this._needsRemoving, thisNeedsRemoving, i, j;
            if (this._topClusterLevel) this._topClusterLevel.getAllChildMarkers(markers);
            for(i = markers.length - 1; i >= 0; i--){
                thisNeedsRemoving = true;
                for(j = needsRemoving.length - 1; j >= 0; j--)if (needsRemoving[j].layer === markers[i]) {
                    thisNeedsRemoving = false;
                    break;
                }
                if (thisNeedsRemoving) method.call(context, markers[i]);
            }
            this._nonPointGroup.eachLayer(method, context);
        },
        //Overrides LayerGroup.getLayers
        getLayers: function() {
            var layers = [];
            this.eachLayer(function(l) {
                layers.push(l);
            });
            return layers;
        },
        //Overrides LayerGroup.getLayer, WARNING: Really bad performance
        getLayer: function(id) {
            var result = null;
            id = parseInt(id, 10);
            this.eachLayer(function(l) {
                if (L.stamp(l) === id) result = l;
            });
            return result;
        },
        //Returns true if the given layer is in this MarkerClusterGroup
        hasLayer: function(layer) {
            if (!layer) return false;
            var i, anArray = this._needsClustering;
            for(i = anArray.length - 1; i >= 0; i--){
                if (anArray[i] === layer) return true;
            }
            anArray = this._needsRemoving;
            for(i = anArray.length - 1; i >= 0; i--){
                if (anArray[i].layer === layer) return false;
            }
            return !!(layer.__parent && layer.__parent._group === this) || this._nonPointGroup.hasLayer(layer);
        },
        //Zoom down to show the given layer (spiderfying if necessary) then calls the callback
        zoomToShowLayer: function(layer, callback) {
            var map = this._map;
            if (typeof callback !== 'function') callback = function() {};
            var showMarker = function() {
                // Assumes that map.hasLayer checks for direct appearance on map, not recursively calling
                // hasLayer on Layer Groups that are on map (typically not calling this MarkerClusterGroup.hasLayer, which would always return true)
                if ((map.hasLayer(layer) || map.hasLayer(layer.__parent)) && !this._inZoomAnimation) {
                    this._map.off('moveend', showMarker, this);
                    this.off('animationend', showMarker, this);
                    if (map.hasLayer(layer)) callback();
                    else if (layer.__parent._icon) {
                        this.once('spiderfied', callback, this);
                        layer.__parent.spiderfy();
                    }
                }
            };
            if (layer._icon && this._map.getBounds().contains(layer.getLatLng())) //Layer is visible ond on screen, immediate return
            callback();
            else if (layer.__parent._zoom < Math.round(this._map._zoom)) {
                //Layer should be visible at this zoom level. It must not be on screen so just pan over to it
                this._map.on('moveend', showMarker, this);
                this._map.panTo(layer.getLatLng());
            } else {
                this._map.on('moveend', showMarker, this);
                this.on('animationend', showMarker, this);
                layer.__parent.zoomToBounds();
            }
        },
        //Overrides FeatureGroup.onAdd
        onAdd: function(map) {
            this._map = map;
            var i, l, layer;
            if (!isFinite(this._map.getMaxZoom())) throw "Map has no maxZoom specified";
            this._featureGroup.addTo(map);
            this._nonPointGroup.addTo(map);
            if (!this._gridClusters) this._generateInitialClusters();
            this._maxLat = map.options.crs.projection.MAX_LATITUDE;
            //Restore all the positions as they are in the MCG before removing them
            for(i = 0, l = this._needsRemoving.length; i < l; i++){
                layer = this._needsRemoving[i];
                layer.newlatlng = layer.layer._latlng;
                layer.layer._latlng = layer.latlng;
            }
            //Remove them, then restore their new positions
            for(i = 0, l = this._needsRemoving.length; i < l; i++){
                layer = this._needsRemoving[i];
                this._removeLayer(layer.layer, true);
                layer.layer._latlng = layer.newlatlng;
            }
            this._needsRemoving = [];
            //Remember the current zoom level and bounds
            this._zoom = Math.round(this._map._zoom);
            this._currentShownBounds = this._getExpandedVisibleBounds();
            this._map.on('zoomend', this._zoomEnd, this);
            this._map.on('moveend', this._moveEnd, this);
            if (this._spiderfierOnAdd) this._spiderfierOnAdd();
            this._bindEvents();
            //Actually add our markers to the map:
            l = this._needsClustering;
            this._needsClustering = [];
            this.addLayers(l, true);
        },
        //Overrides FeatureGroup.onRemove
        onRemove: function(map) {
            map.off('zoomend', this._zoomEnd, this);
            map.off('moveend', this._moveEnd, this);
            this._unbindEvents();
            //In case we are in a cluster animation
            this._map._mapPane.className = this._map._mapPane.className.replace(' leaflet-cluster-anim', '');
            if (this._spiderfierOnRemove) this._spiderfierOnRemove();
            delete this._maxLat;
            //Clean up all the layers we added to the map
            this._hideCoverage();
            this._featureGroup.remove();
            this._nonPointGroup.remove();
            this._featureGroup.clearLayers();
            this._map = null;
        },
        getVisibleParent: function(marker) {
            var vMarker = marker;
            while(vMarker && !vMarker._icon)vMarker = vMarker.__parent;
            return vMarker || null;
        },
        //Remove the given object from the given array
        _arraySplice: function(anArray, obj) {
            for(var i = anArray.length - 1; i >= 0; i--)if (anArray[i] === obj) {
                anArray.splice(i, 1);
                return true;
            }
        },
        /**
		 * Removes a marker from all _gridUnclustered zoom levels, starting at the supplied zoom.
		 * @param marker to be removed from _gridUnclustered.
		 * @param z integer bottom start zoom level (included)
		 * @private
		 */ _removeFromGridUnclustered: function(marker, z) {
            var map = this._map, gridUnclustered = this._gridUnclustered, minZoom = Math.floor(this._map.getMinZoom());
            for(; z >= minZoom; z--){
                if (!gridUnclustered[z].removeObject(marker, map.project(marker.getLatLng(), z))) break;
            }
        },
        _childMarkerDragStart: function(e) {
            e.target.__dragStart = e.target._latlng;
        },
        _childMarkerMoved: function(e) {
            if (!this._ignoreMove && !e.target.__dragStart) {
                var isPopupOpen = e.target._popup && e.target._popup.isOpen();
                this._moveChild(e.target, e.oldLatLng, e.latlng);
                if (isPopupOpen) e.target.openPopup();
            }
        },
        _moveChild: function(layer, from, to) {
            layer._latlng = from;
            this.removeLayer(layer);
            layer._latlng = to;
            this.addLayer(layer);
        },
        _childMarkerDragEnd: function(e) {
            var dragStart = e.target.__dragStart;
            delete e.target.__dragStart;
            if (dragStart) this._moveChild(e.target, dragStart, e.target._latlng);
        },
        //Internal function for removing a marker from everything.
        //dontUpdateMap: set to true if you will handle updating the map manually (for bulk functions)
        _removeLayer: function(marker, removeFromDistanceGrid, dontUpdateMap) {
            var gridClusters = this._gridClusters, gridUnclustered = this._gridUnclustered, fg = this._featureGroup, map = this._map, minZoom = Math.floor(this._map.getMinZoom());
            //Remove the marker from distance clusters it might be in
            if (removeFromDistanceGrid) this._removeFromGridUnclustered(marker, this._maxZoom);
            //Work our way up the clusters removing them as we go if required
            var cluster = marker.__parent, markers = cluster._markers, otherMarker;
            //Remove the marker from the immediate parents marker list
            this._arraySplice(markers, marker);
            while(cluster){
                cluster._childCount--;
                cluster._boundsNeedUpdate = true;
                if (cluster._zoom < minZoom) break;
                else if (removeFromDistanceGrid && cluster._childCount <= 1) {
                    //We need to push the other marker up to the parent
                    otherMarker = cluster._markers[0] === marker ? cluster._markers[1] : cluster._markers[0];
                    //Update distance grid
                    gridClusters[cluster._zoom].removeObject(cluster, map.project(cluster._cLatLng, cluster._zoom));
                    gridUnclustered[cluster._zoom].addObject(otherMarker, map.project(otherMarker.getLatLng(), cluster._zoom));
                    //Move otherMarker up to parent
                    this._arraySplice(cluster.__parent._childClusters, cluster);
                    cluster.__parent._markers.push(otherMarker);
                    otherMarker.__parent = cluster.__parent;
                    if (cluster._icon) {
                        //Cluster is currently on the map, need to put the marker on the map instead
                        fg.removeLayer(cluster);
                        if (!dontUpdateMap) fg.addLayer(otherMarker);
                    }
                } else cluster._iconNeedsUpdate = true;
                cluster = cluster.__parent;
            }
            delete marker.__parent;
        },
        _isOrIsParent: function(el, oel) {
            while(oel){
                if (el === oel) return true;
                oel = oel.parentNode;
            }
            return false;
        },
        //Override L.Evented.fire
        fire: function(type, data, propagate) {
            if (data && data.layer instanceof L.MarkerCluster) {
                //Prevent multiple clustermouseover/off events if the icon is made up of stacked divs (Doesn't work in ie <= 8, no relatedTarget)
                if (data.originalEvent && this._isOrIsParent(data.layer._icon, data.originalEvent.relatedTarget)) return;
                type = 'cluster' + type;
            }
            L.FeatureGroup.prototype.fire.call(this, type, data, propagate);
        },
        //Override L.Evented.listens
        listens: function(type, propagate) {
            return L.FeatureGroup.prototype.listens.call(this, type, propagate) || L.FeatureGroup.prototype.listens.call(this, 'cluster' + type, propagate);
        },
        //Default functionality
        _defaultIconCreateFunction: function(cluster) {
            var childCount = cluster.getChildCount();
            var c = ' marker-cluster-';
            if (childCount < 10) c += 'small';
            else if (childCount < 100) c += 'medium';
            else c += 'large';
            return new L.DivIcon({
                html: '<div><span>' + childCount + '</span></div>',
                className: 'marker-cluster' + c,
                iconSize: new L.Point(40, 40)
            });
        },
        _bindEvents: function() {
            var map = this._map, spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom, showCoverageOnHover = this.options.showCoverageOnHover, zoomToBoundsOnClick = this.options.zoomToBoundsOnClick, spiderfyOnEveryZoom = this.options.spiderfyOnEveryZoom;
            //Zoom on cluster click or spiderfy if we are at the lowest level
            if (spiderfyOnMaxZoom || zoomToBoundsOnClick || spiderfyOnEveryZoom) this.on('clusterclick clusterkeypress', this._zoomOrSpiderfy, this);
            //Show convex hull (boundary) polygon on mouse over
            if (showCoverageOnHover) {
                this.on('clustermouseover', this._showCoverage, this);
                this.on('clustermouseout', this._hideCoverage, this);
                map.on('zoomend', this._hideCoverage, this);
            }
        },
        _zoomOrSpiderfy: function(e) {
            var cluster = e.layer, bottomCluster = cluster;
            if (e.type === 'clusterkeypress' && e.originalEvent && e.originalEvent.keyCode !== 13) return;
            while(bottomCluster._childClusters.length === 1)bottomCluster = bottomCluster._childClusters[0];
            if (bottomCluster._zoom === this._maxZoom && bottomCluster._childCount === cluster._childCount && this.options.spiderfyOnMaxZoom) // All child markers are contained in a single cluster from this._maxZoom to this cluster.
            cluster.spiderfy();
            else if (this.options.zoomToBoundsOnClick) cluster.zoomToBounds();
            if (this.options.spiderfyOnEveryZoom) cluster.spiderfy();
            // Focus the map again for keyboard users.
            if (e.originalEvent && e.originalEvent.keyCode === 13) this._map._container.focus();
        },
        _showCoverage: function(e) {
            var map = this._map;
            if (this._inZoomAnimation) return;
            if (this._shownPolygon) map.removeLayer(this._shownPolygon);
            if (e.layer.getChildCount() > 2 && e.layer !== this._spiderfied) {
                this._shownPolygon = new L.Polygon(e.layer.getConvexHull(), this.options.polygonOptions);
                map.addLayer(this._shownPolygon);
            }
        },
        _hideCoverage: function() {
            if (this._shownPolygon) {
                this._map.removeLayer(this._shownPolygon);
                this._shownPolygon = null;
            }
        },
        _unbindEvents: function() {
            var spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom, showCoverageOnHover = this.options.showCoverageOnHover, zoomToBoundsOnClick = this.options.zoomToBoundsOnClick, spiderfyOnEveryZoom = this.options.spiderfyOnEveryZoom, map = this._map;
            if (spiderfyOnMaxZoom || zoomToBoundsOnClick || spiderfyOnEveryZoom) this.off('clusterclick clusterkeypress', this._zoomOrSpiderfy, this);
            if (showCoverageOnHover) {
                this.off('clustermouseover', this._showCoverage, this);
                this.off('clustermouseout', this._hideCoverage, this);
                map.off('zoomend', this._hideCoverage, this);
            }
        },
        _zoomEnd: function() {
            if (!this._map) return;
            this._mergeSplitClusters();
            this._zoom = Math.round(this._map._zoom);
            this._currentShownBounds = this._getExpandedVisibleBounds();
        },
        _moveEnd: function() {
            if (this._inZoomAnimation) return;
            var newBounds = this._getExpandedVisibleBounds();
            this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, newBounds);
            this._topClusterLevel._recursivelyAddChildrenToMap(null, Math.round(this._map._zoom), newBounds);
            this._currentShownBounds = newBounds;
            return;
        },
        _generateInitialClusters: function() {
            var maxZoom = Math.ceil(this._map.getMaxZoom()), minZoom = Math.floor(this._map.getMinZoom()), radius = this.options.maxClusterRadius, radiusFn = radius;
            //If we just set maxClusterRadius to a single number, we need to create
            //a simple function to return that number. Otherwise, we just have to
            //use the function we've passed in.
            if (typeof radius !== "function") radiusFn = function() {
                return radius;
            };
            if (this.options.disableClusteringAtZoom !== null) maxZoom = this.options.disableClusteringAtZoom - 1;
            this._maxZoom = maxZoom;
            this._gridClusters = {};
            this._gridUnclustered = {};
            //Set up DistanceGrids for each zoom
            for(var zoom = maxZoom; zoom >= minZoom; zoom--){
                this._gridClusters[zoom] = new L.DistanceGrid(radiusFn(zoom));
                this._gridUnclustered[zoom] = new L.DistanceGrid(radiusFn(zoom));
            }
            // Instantiate the appropriate L.MarkerCluster class (animated or not).
            this._topClusterLevel = new this._markerCluster(this, minZoom - 1);
        },
        //Zoom: Zoom to start adding at (Pass this._maxZoom to start at the bottom)
        _addLayer: function(layer, zoom) {
            var gridClusters = this._gridClusters, gridUnclustered = this._gridUnclustered, minZoom = Math.floor(this._map.getMinZoom()), markerPoint, z;
            if (this.options.singleMarkerMode) this._overrideMarkerIcon(layer);
            layer.on(this._childMarkerEventHandlers, this);
            //Find the lowest zoom level to slot this one in
            for(; zoom >= minZoom; zoom--){
                markerPoint = this._map.project(layer.getLatLng(), zoom); // calculate pixel position
                //Try find a cluster close by
                var closest = gridClusters[zoom].getNearObject(markerPoint);
                if (closest) {
                    closest._addChild(layer);
                    layer.__parent = closest;
                    return;
                }
                //Try find a marker close by to form a new cluster with
                closest = gridUnclustered[zoom].getNearObject(markerPoint);
                if (closest) {
                    var parent = closest.__parent;
                    if (parent) this._removeLayer(closest, false);
                    //Create new cluster with these 2 in it
                    var newCluster = new this._markerCluster(this, zoom, closest, layer);
                    gridClusters[zoom].addObject(newCluster, this._map.project(newCluster._cLatLng, zoom));
                    closest.__parent = newCluster;
                    layer.__parent = newCluster;
                    //First create any new intermediate parent clusters that don't exist
                    var lastParent = newCluster;
                    for(z = zoom - 1; z > parent._zoom; z--){
                        lastParent = new this._markerCluster(this, z, lastParent);
                        gridClusters[z].addObject(lastParent, this._map.project(closest.getLatLng(), z));
                    }
                    parent._addChild(lastParent);
                    //Remove closest from this zoom level and any above that it is in, replace with newCluster
                    this._removeFromGridUnclustered(closest, zoom);
                    return;
                }
                //Didn't manage to cluster in at this zoom, record us as a marker here and continue upwards
                gridUnclustered[zoom].addObject(layer, markerPoint);
            }
            //Didn't get in anything, add us to the top
            this._topClusterLevel._addChild(layer);
            layer.__parent = this._topClusterLevel;
            return;
        },
        /**
		 * Refreshes the icon of all "dirty" visible clusters.
		 * Non-visible "dirty" clusters will be updated when they are added to the map.
		 * @private
		 */ _refreshClustersIcons: function() {
            this._featureGroup.eachLayer(function(c) {
                if (c instanceof L.MarkerCluster && c._iconNeedsUpdate) c._updateIcon();
            });
        },
        //Enqueue code to fire after the marker expand/contract has happened
        _enqueue: function(fn) {
            this._queue.push(fn);
            if (!this._queueTimeout) this._queueTimeout = setTimeout(L.bind(this._processQueue, this), 300);
        },
        _processQueue: function() {
            for(var i = 0; i < this._queue.length; i++)this._queue[i].call(this);
            this._queue.length = 0;
            clearTimeout(this._queueTimeout);
            this._queueTimeout = null;
        },
        //Merge and split any existing clusters that are too big or small
        _mergeSplitClusters: function() {
            var mapZoom = Math.round(this._map._zoom);
            //In case we are starting to split before the animation finished
            this._processQueue();
            if (this._zoom < mapZoom && this._currentShownBounds.intersects(this._getExpandedVisibleBounds())) {
                this._animationStart();
                //Remove clusters now off screen
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, this._getExpandedVisibleBounds());
                this._animationZoomIn(this._zoom, mapZoom);
            } else if (this._zoom > mapZoom) {
                this._animationStart();
                this._animationZoomOut(this._zoom, mapZoom);
            } else this._moveEnd();
        },
        //Gets the maps visible bounds expanded in each direction by the size of the screen (so the user cannot see an area we do not cover in one pan)
        _getExpandedVisibleBounds: function() {
            if (!this.options.removeOutsideVisibleBounds) return this._mapBoundsInfinite;
            else if (L.Browser.mobile) return this._checkBoundsMaxLat(this._map.getBounds());
            return this._checkBoundsMaxLat(this._map.getBounds().pad(1)); // Padding expands the bounds by its own dimensions but scaled with the given factor.
        },
        /**
		 * Expands the latitude to Infinity (or -Infinity) if the input bounds reach the map projection maximum defined latitude
		 * (in the case of Web/Spherical Mercator, it is 85.0511287798 / see https://en.wikipedia.org/wiki/Web_Mercator#Formulas).
		 * Otherwise, the removeOutsideVisibleBounds option will remove markers beyond that limit, whereas the same markers without
		 * this option (or outside MCG) will have their position floored (ceiled) by the projection and rendered at that limit,
		 * making the user think that MCG "eats" them and never displays them again.
		 * @param bounds L.LatLngBounds
		 * @returns {L.LatLngBounds}
		 * @private
		 */ _checkBoundsMaxLat: function(bounds) {
            var maxLat = this._maxLat;
            if (maxLat !== undefined) {
                if (bounds.getNorth() >= maxLat) bounds._northEast.lat = Infinity;
                if (bounds.getSouth() <= -maxLat) bounds._southWest.lat = -Infinity;
            }
            return bounds;
        },
        //Shared animation code
        _animationAddLayerNonAnimated: function(layer, newCluster) {
            if (newCluster === layer) this._featureGroup.addLayer(layer);
            else if (newCluster._childCount === 2) {
                newCluster._addToMap();
                var markers = newCluster.getAllChildMarkers();
                this._featureGroup.removeLayer(markers[0]);
                this._featureGroup.removeLayer(markers[1]);
            } else newCluster._updateIcon();
        },
        /**
		 * Extracts individual (i.e. non-group) layers from a Layer Group.
		 * @param group to extract layers from.
		 * @param output {Array} in which to store the extracted layers.
		 * @returns {*|Array}
		 * @private
		 */ _extractNonGroupLayers: function(group, output) {
            var layers = group.getLayers(), i = 0, layer;
            output = output || [];
            for(; i < layers.length; i++){
                layer = layers[i];
                if (layer instanceof L.LayerGroup) {
                    this._extractNonGroupLayers(layer, output);
                    continue;
                }
                output.push(layer);
            }
            return output;
        },
        /**
		 * Implements the singleMarkerMode option.
		 * @param layer Marker to re-style using the Clusters iconCreateFunction.
		 * @returns {L.Icon} The newly created icon.
		 * @private
		 */ _overrideMarkerIcon: function(layer) {
            var icon = layer.options.icon = this.options.iconCreateFunction({
                getChildCount: function() {
                    return 1;
                },
                getAllChildMarkers: function() {
                    return [
                        layer
                    ];
                }
            });
            return icon;
        }
    });
    // Constant bounds used in case option "removeOutsideVisibleBounds" is set to false.
    L.MarkerClusterGroup.include({
        _mapBoundsInfinite: new L.LatLngBounds(new L.LatLng(-Infinity, -Infinity), new L.LatLng(Infinity, Infinity))
    });
    L.MarkerClusterGroup.include({
        _noAnimation: {
            //Non Animated versions of everything
            _animationStart: function() {
            //Do nothing...
            },
            _animationZoomIn: function(previousZoomLevel, newZoomLevel) {
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel);
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //We didn't actually animate, but we use this event to mean "clustering animations have finished"
                this.fire('animationend');
            },
            _animationZoomOut: function(previousZoomLevel, newZoomLevel) {
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel);
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //We didn't actually animate, but we use this event to mean "clustering animations have finished"
                this.fire('animationend');
            },
            _animationAddLayer: function(layer, newCluster) {
                this._animationAddLayerNonAnimated(layer, newCluster);
            }
        },
        _withAnimation: {
            //Animated versions here
            _animationStart: function() {
                this._map._mapPane.className += ' leaflet-cluster-anim';
                this._inZoomAnimation++;
            },
            _animationZoomIn: function(previousZoomLevel, newZoomLevel) {
                var bounds = this._getExpandedVisibleBounds(), fg = this._featureGroup, minZoom = Math.floor(this._map.getMinZoom()), i;
                this._ignoreMove = true;
                //Add all children of current clusters to map and remove those clusters from map
                this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function(c) {
                    var startPos = c._latlng, markers = c._markers, m;
                    if (!bounds.contains(startPos)) startPos = null;
                    if (c._isSingleParent() && previousZoomLevel + 1 === newZoomLevel) {
                        fg.removeLayer(c);
                        c._recursivelyAddChildrenToMap(null, newZoomLevel, bounds);
                    } else {
                        //Fade out old cluster
                        c.clusterHide();
                        c._recursivelyAddChildrenToMap(startPos, newZoomLevel, bounds);
                    }
                    //Remove all markers that aren't visible any more
                    //TODO: Do we actually need to do this on the higher levels too?
                    for(i = markers.length - 1; i >= 0; i--){
                        m = markers[i];
                        if (!bounds.contains(m._latlng)) fg.removeLayer(m);
                    }
                });
                this._forceLayout();
                //Update opacities
                this._topClusterLevel._recursivelyBecomeVisible(bounds, newZoomLevel);
                //TODO Maybe? Update markers in _recursivelyBecomeVisible
                fg.eachLayer(function(n) {
                    if (!(n instanceof L.MarkerCluster) && n._icon) n.clusterShow();
                });
                //update the positions of the just added clusters/markers
                this._topClusterLevel._recursively(bounds, previousZoomLevel, newZoomLevel, function(c) {
                    c._recursivelyRestoreChildPositions(newZoomLevel);
                });
                this._ignoreMove = false;
                //Remove the old clusters and close the zoom animation
                this._enqueue(function() {
                    //update the positions of the just added clusters/markers
                    this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function(c) {
                        fg.removeLayer(c);
                        c.clusterShow();
                    });
                    this._animationEnd();
                });
            },
            _animationZoomOut: function(previousZoomLevel, newZoomLevel) {
                this._animationZoomOutSingle(this._topClusterLevel, previousZoomLevel - 1, newZoomLevel);
                //Need to add markers for those that weren't on the map before but are now
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //Remove markers that were on the map before but won't be now
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel, this._getExpandedVisibleBounds());
            },
            _animationAddLayer: function(layer, newCluster) {
                var me = this, fg = this._featureGroup;
                fg.addLayer(layer);
                if (newCluster !== layer) {
                    if (newCluster._childCount > 2) {
                        newCluster._updateIcon();
                        this._forceLayout();
                        this._animationStart();
                        layer._setPos(this._map.latLngToLayerPoint(newCluster.getLatLng()));
                        layer.clusterHide();
                        this._enqueue(function() {
                            fg.removeLayer(layer);
                            layer.clusterShow();
                            me._animationEnd();
                        });
                    } else {
                        this._forceLayout();
                        me._animationStart();
                        me._animationZoomOutSingle(newCluster, this._map.getMaxZoom(), this._zoom);
                    }
                }
            }
        },
        // Private methods for animated versions.
        _animationZoomOutSingle: function(cluster, previousZoomLevel, newZoomLevel) {
            var bounds = this._getExpandedVisibleBounds(), minZoom = Math.floor(this._map.getMinZoom());
            //Animate all of the markers in the clusters to move to their cluster center point
            cluster._recursivelyAnimateChildrenInAndAddSelfToMap(bounds, minZoom, previousZoomLevel + 1, newZoomLevel);
            var me = this;
            //Update the opacity (If we immediately set it they won't animate)
            this._forceLayout();
            cluster._recursivelyBecomeVisible(bounds, newZoomLevel);
            //TODO: Maybe use the transition timing stuff to make this more reliable
            //When the animations are done, tidy up
            this._enqueue(function() {
                //This cluster stopped being a cluster before the timeout fired
                if (cluster._childCount === 1) {
                    var m = cluster._markers[0];
                    //If we were in a cluster animation at the time then the opacity and position of our child could be wrong now, so fix it
                    this._ignoreMove = true;
                    m.setLatLng(m.getLatLng());
                    this._ignoreMove = false;
                    if (m.clusterShow) m.clusterShow();
                } else cluster._recursively(bounds, newZoomLevel, minZoom, function(c) {
                    c._recursivelyRemoveChildrenFromMap(bounds, minZoom, previousZoomLevel + 1);
                });
                me._animationEnd();
            });
        },
        _animationEnd: function() {
            if (this._map) this._map._mapPane.className = this._map._mapPane.className.replace(' leaflet-cluster-anim', '');
            this._inZoomAnimation--;
            this.fire('animationend');
        },
        //Force a browser layout of stuff in the map
        // Should apply the current opacity and location to all elements so we can update them again for an animation
        _forceLayout: function() {
            //In my testing this works, infact offsetWidth of any element seems to work.
            //Could loop all this._layers and do this for each _icon if it stops working
            L.Util.falseFn(document.body.offsetWidth);
        }
    });
    L.markerClusterGroup = function(options) {
        return new L.MarkerClusterGroup(options);
    };
    var MarkerCluster = L.MarkerCluster = L.Marker.extend({
        options: L.Icon.prototype.options,
        initialize: function(group, zoom, a, b) {
            L.Marker.prototype.initialize.call(this, a ? a._cLatLng || a.getLatLng() : new L.LatLng(0, 0), {
                icon: this,
                pane: group.options.clusterPane
            });
            this._group = group;
            this._zoom = zoom;
            this._markers = [];
            this._childClusters = [];
            this._childCount = 0;
            this._iconNeedsUpdate = true;
            this._boundsNeedUpdate = true;
            this._bounds = new L.LatLngBounds();
            if (a) this._addChild(a);
            if (b) this._addChild(b);
        },
        //Recursively retrieve all child markers of this cluster
        getAllChildMarkers: function(storageArray, ignoreDraggedMarker) {
            storageArray = storageArray || [];
            for(var i = this._childClusters.length - 1; i >= 0; i--)this._childClusters[i].getAllChildMarkers(storageArray, ignoreDraggedMarker);
            for(var j = this._markers.length - 1; j >= 0; j--){
                if (ignoreDraggedMarker && this._markers[j].__dragStart) continue;
                storageArray.push(this._markers[j]);
            }
            return storageArray;
        },
        //Returns the count of how many child markers we have
        getChildCount: function() {
            return this._childCount;
        },
        //Zoom to the minimum of showing all of the child markers, or the extents of this cluster
        zoomToBounds: function(fitBoundsOptions) {
            var childClusters = this._childClusters.slice(), map = this._group._map, boundsZoom = map.getBoundsZoom(this._bounds), zoom = this._zoom + 1, mapZoom = map.getZoom(), i;
            //calculate how far we need to zoom down to see all of the markers
            while(childClusters.length > 0 && boundsZoom > zoom){
                zoom++;
                var newClusters = [];
                for(i = 0; i < childClusters.length; i++)newClusters = newClusters.concat(childClusters[i]._childClusters);
                childClusters = newClusters;
            }
            if (boundsZoom > zoom) this._group._map.setView(this._latlng, zoom);
            else if (boundsZoom <= mapZoom) this._group._map.setView(this._latlng, mapZoom + 1);
            else this._group._map.fitBounds(this._bounds, fitBoundsOptions);
        },
        getBounds: function() {
            var bounds = new L.LatLngBounds();
            bounds.extend(this._bounds);
            return bounds;
        },
        _updateIcon: function() {
            this._iconNeedsUpdate = true;
            if (this._icon) this.setIcon(this);
        },
        //Cludge for Icon, we pretend to be an icon for performance
        createIcon: function() {
            if (this._iconNeedsUpdate) {
                this._iconObj = this._group.options.iconCreateFunction(this);
                this._iconNeedsUpdate = false;
            }
            return this._iconObj.createIcon();
        },
        createShadow: function() {
            return this._iconObj.createShadow();
        },
        _addChild: function(new1, isNotificationFromChild) {
            this._iconNeedsUpdate = true;
            this._boundsNeedUpdate = true;
            this._setClusterCenter(new1);
            if (new1 instanceof L.MarkerCluster) {
                if (!isNotificationFromChild) {
                    this._childClusters.push(new1);
                    new1.__parent = this;
                }
                this._childCount += new1._childCount;
            } else {
                if (!isNotificationFromChild) this._markers.push(new1);
                this._childCount++;
            }
            if (this.__parent) this.__parent._addChild(new1, true);
        },
        /**
		 * Makes sure the cluster center is set. If not, uses the child center if it is a cluster, or the marker position.
		 * @param child L.MarkerCluster|L.Marker that will be used as cluster center if not defined yet.
		 * @private
		 */ _setClusterCenter: function(child) {
            if (!this._cLatLng) // when clustering, take position of the first point as the cluster center
            this._cLatLng = child._cLatLng || child._latlng;
        },
        /**
		 * Assigns impossible bounding values so that the next extend entirely determines the new bounds.
		 * This method avoids having to trash the previous L.LatLngBounds object and to create a new one, which is much slower for this class.
		 * As long as the bounds are not extended, most other methods would probably fail, as they would with bounds initialized but not extended.
		 * @private
		 */ _resetBounds: function() {
            var bounds = this._bounds;
            if (bounds._southWest) {
                bounds._southWest.lat = Infinity;
                bounds._southWest.lng = Infinity;
            }
            if (bounds._northEast) {
                bounds._northEast.lat = -Infinity;
                bounds._northEast.lng = -Infinity;
            }
        },
        _recalculateBounds: function() {
            var markers = this._markers, childClusters = this._childClusters, latSum = 0, lngSum = 0, totalCount = this._childCount, i, child, childLatLng, childCount;
            // Case where all markers are removed from the map and we are left with just an empty _topClusterLevel.
            if (totalCount === 0) return;
            // Reset rather than creating a new object, for performance.
            this._resetBounds();
            // Child markers.
            for(i = 0; i < markers.length; i++){
                childLatLng = markers[i]._latlng;
                this._bounds.extend(childLatLng);
                latSum += childLatLng.lat;
                lngSum += childLatLng.lng;
            }
            // Child clusters.
            for(i = 0; i < childClusters.length; i++){
                child = childClusters[i];
                // Re-compute child bounds and weighted position first if necessary.
                if (child._boundsNeedUpdate) child._recalculateBounds();
                this._bounds.extend(child._bounds);
                childLatLng = child._wLatLng;
                childCount = child._childCount;
                latSum += childLatLng.lat * childCount;
                lngSum += childLatLng.lng * childCount;
            }
            this._latlng = this._wLatLng = new L.LatLng(latSum / totalCount, lngSum / totalCount);
            // Reset dirty flag.
            this._boundsNeedUpdate = false;
        },
        //Set our markers position as given and add it to the map
        _addToMap: function(startPos) {
            if (startPos) {
                this._backupLatlng = this._latlng;
                this.setLatLng(startPos);
            }
            this._group._featureGroup.addLayer(this);
        },
        _recursivelyAnimateChildrenIn: function(bounds, center, maxZoom) {
            this._recursively(bounds, this._group._map.getMinZoom(), maxZoom - 1, function(c) {
                var markers = c._markers, i, m;
                for(i = markers.length - 1; i >= 0; i--){
                    m = markers[i];
                    //Only do it if the icon is still on the map
                    if (m._icon) {
                        m._setPos(center);
                        m.clusterHide();
                    }
                }
            }, function(c) {
                var childClusters = c._childClusters, j, cm;
                for(j = childClusters.length - 1; j >= 0; j--){
                    cm = childClusters[j];
                    if (cm._icon) {
                        cm._setPos(center);
                        cm.clusterHide();
                    }
                }
            });
        },
        _recursivelyAnimateChildrenInAndAddSelfToMap: function(bounds, mapMinZoom, previousZoomLevel, newZoomLevel) {
            this._recursively(bounds, newZoomLevel, mapMinZoom, function(c) {
                c._recursivelyAnimateChildrenIn(bounds, c._group._map.latLngToLayerPoint(c.getLatLng()).round(), previousZoomLevel);
                //TODO: depthToAnimateIn affects _isSingleParent, if there is a multizoom we may/may not be.
                //As a hack we only do a animation free zoom on a single level zoom, if someone does multiple levels then we always animate
                if (c._isSingleParent() && previousZoomLevel - 1 === newZoomLevel) {
                    c.clusterShow();
                    c._recursivelyRemoveChildrenFromMap(bounds, mapMinZoom, previousZoomLevel); //Immediately remove our children as we are replacing them. TODO previousBounds not bounds
                } else c.clusterHide();
                c._addToMap();
            });
        },
        _recursivelyBecomeVisible: function(bounds, zoomLevel) {
            this._recursively(bounds, this._group._map.getMinZoom(), zoomLevel, null, function(c) {
                c.clusterShow();
            });
        },
        _recursivelyAddChildrenToMap: function(startPos, zoomLevel, bounds) {
            this._recursively(bounds, this._group._map.getMinZoom() - 1, zoomLevel, function(c) {
                if (zoomLevel === c._zoom) return;
                //Add our child markers at startPos (so they can be animated out)
                for(var i = c._markers.length - 1; i >= 0; i--){
                    var nm = c._markers[i];
                    if (!bounds.contains(nm._latlng)) continue;
                    if (startPos) {
                        nm._backupLatlng = nm.getLatLng();
                        nm.setLatLng(startPos);
                        if (nm.clusterHide) nm.clusterHide();
                    }
                    c._group._featureGroup.addLayer(nm);
                }
            }, function(c) {
                c._addToMap(startPos);
            });
        },
        _recursivelyRestoreChildPositions: function(zoomLevel) {
            //Fix positions of child markers
            for(var i = this._markers.length - 1; i >= 0; i--){
                var nm = this._markers[i];
                if (nm._backupLatlng) {
                    nm.setLatLng(nm._backupLatlng);
                    delete nm._backupLatlng;
                }
            }
            if (zoomLevel - 1 === this._zoom) //Reposition child clusters
            for(var j = this._childClusters.length - 1; j >= 0; j--)this._childClusters[j]._restorePosition();
            else for(var k = this._childClusters.length - 1; k >= 0; k--)this._childClusters[k]._recursivelyRestoreChildPositions(zoomLevel);
        },
        _restorePosition: function() {
            if (this._backupLatlng) {
                this.setLatLng(this._backupLatlng);
                delete this._backupLatlng;
            }
        },
        //exceptBounds: If set, don't remove any markers/clusters in it
        _recursivelyRemoveChildrenFromMap: function(previousBounds, mapMinZoom, zoomLevel, exceptBounds) {
            var m, i;
            this._recursively(previousBounds, mapMinZoom - 1, zoomLevel - 1, function(c) {
                //Remove markers at every level
                for(i = c._markers.length - 1; i >= 0; i--){
                    m = c._markers[i];
                    if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
                        c._group._featureGroup.removeLayer(m);
                        if (m.clusterShow) m.clusterShow();
                    }
                }
            }, function(c) {
                //Remove child clusters at just the bottom level
                for(i = c._childClusters.length - 1; i >= 0; i--){
                    m = c._childClusters[i];
                    if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
                        c._group._featureGroup.removeLayer(m);
                        if (m.clusterShow) m.clusterShow();
                    }
                }
            });
        },
        //Run the given functions recursively to this and child clusters
        // boundsToApplyTo: a L.LatLngBounds representing the bounds of what clusters to recurse in to
        // zoomLevelToStart: zoom level to start running functions (inclusive)
        // zoomLevelToStop: zoom level to stop running functions (inclusive)
        // runAtEveryLevel: function that takes an L.MarkerCluster as an argument that should be applied on every level
        // runAtBottomLevel: function that takes an L.MarkerCluster as an argument that should be applied at only the bottom level
        _recursively: function(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel) {
            var childClusters = this._childClusters, zoom = this._zoom, i, c;
            if (zoomLevelToStart <= zoom) {
                if (runAtEveryLevel) runAtEveryLevel(this);
                if (runAtBottomLevel && zoom === zoomLevelToStop) runAtBottomLevel(this);
            }
            if (zoom < zoomLevelToStart || zoom < zoomLevelToStop) for(i = childClusters.length - 1; i >= 0; i--){
                c = childClusters[i];
                if (c._boundsNeedUpdate) c._recalculateBounds();
                if (boundsToApplyTo.intersects(c._bounds)) c._recursively(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel);
            }
        },
        //Returns true if we are the parent of only one cluster and that cluster is the same as us
        _isSingleParent: function() {
            //Don't need to check this._markers as the rest won't work if there are any
            return this._childClusters.length > 0 && this._childClusters[0]._childCount === this._childCount;
        }
    });
    /*
	* Extends L.Marker to include two extra methods: clusterHide and clusterShow.
	* 
	* They work as setOpacity(0) and setOpacity(1) respectively, but
	* don't overwrite the options.opacity
	* 
	*/ L.Marker.include({
        clusterHide: function() {
            var backup = this.options.opacity;
            this.setOpacity(0);
            this.options.opacity = backup;
            return this;
        },
        clusterShow: function() {
            return this.setOpacity(this.options.opacity);
        }
    });
    L.DistanceGrid = function(cellSize) {
        this._cellSize = cellSize;
        this._sqCellSize = cellSize * cellSize;
        this._grid = {};
        this._objectPoint = {};
    };
    L.DistanceGrid.prototype = {
        addObject: function(obj, point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), grid = this._grid, row = grid[y] = grid[y] || {}, cell = row[x] = row[x] || [], stamp = L.Util.stamp(obj);
            this._objectPoint[stamp] = point;
            cell.push(obj);
        },
        updateObject: function(obj, point) {
            this.removeObject(obj);
            this.addObject(obj, point);
        },
        //Returns true if the object was found
        removeObject: function(obj, point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), grid = this._grid, row = grid[y] = grid[y] || {}, cell = row[x] = row[x] || [], i, len;
            delete this._objectPoint[L.Util.stamp(obj)];
            for(i = 0, len = cell.length; i < len; i++)if (cell[i] === obj) {
                cell.splice(i, 1);
                if (len === 1) delete row[x];
                return true;
            }
        },
        eachObject: function(fn, context) {
            var i, j, k, len, row, cell, removed, grid = this._grid;
            for(i in grid){
                row = grid[i];
                for(j in row){
                    cell = row[j];
                    for(k = 0, len = cell.length; k < len; k++){
                        removed = fn.call(context, cell[k]);
                        if (removed) {
                            k--;
                            len--;
                        }
                    }
                }
            }
        },
        getNearObject: function(point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), i, j, k, row, cell, len, obj, dist, objectPoint = this._objectPoint, closestDistSq = this._sqCellSize, closest = null;
            for(i = y - 1; i <= y + 1; i++){
                row = this._grid[i];
                if (row) for(j = x - 1; j <= x + 1; j++){
                    cell = row[j];
                    if (cell) for(k = 0, len = cell.length; k < len; k++){
                        obj = cell[k];
                        dist = this._sqDist(objectPoint[L.Util.stamp(obj)], point);
                        if (dist < closestDistSq || dist <= closestDistSq && closest === null) {
                            closestDistSq = dist;
                            closest = obj;
                        }
                    }
                }
            }
            return closest;
        },
        _getCoord: function(x) {
            var coord = Math.floor(x / this._cellSize);
            return isFinite(coord) ? coord : x;
        },
        _sqDist: function(p, p2) {
            var dx = p2.x - p.x, dy = p2.y - p.y;
            return dx * dx + dy * dy;
        }
    };
    /* Copyright (c) 2012 the authors listed at the following URL, and/or
	the authors of referenced articles or incorporated external code:
	http://en.literateprograms.org/Quickhull_(Javascript)?action=history&offset=20120410175256

	Permission is hereby granted, free of charge, to any person obtaining
	a copy of this software and associated documentation files (the
	"Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish,
	distribute, sublicense, and/or sell copies of the Software, and to
	permit persons to whom the Software is furnished to do so, subject to
	the following conditions:

	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

	Retrieved from: http://en.literateprograms.org/Quickhull_(Javascript)?oldid=18434
	*/ (function() {
        L.QuickHull = {
            /*
			 * @param {Object} cpt a point to be measured from the baseline
			 * @param {Array} bl the baseline, as represented by a two-element
			 *   array of latlng objects.
			 * @returns {Number} an approximate distance measure
			 */ getDistant: function(cpt, bl) {
                var vY = bl[1].lat - bl[0].lat, vX = bl[0].lng - bl[1].lng;
                return vX * (cpt.lat - bl[0].lat) + vY * (cpt.lng - bl[0].lng);
            },
            /*
			 * @param {Array} baseLine a two-element array of latlng objects
			 *   representing the baseline to project from
			 * @param {Array} latLngs an array of latlng objects
			 * @returns {Object} the maximum point and all new points to stay
			 *   in consideration for the hull.
			 */ findMostDistantPointFromBaseLine: function(baseLine, latLngs) {
                var maxD = 0, maxPt = null, newPoints = [], i, pt, d;
                for(i = latLngs.length - 1; i >= 0; i--){
                    pt = latLngs[i];
                    d = this.getDistant(pt, baseLine);
                    if (d > 0) newPoints.push(pt);
                    else continue;
                    if (d > maxD) {
                        maxD = d;
                        maxPt = pt;
                    }
                }
                return {
                    maxPoint: maxPt,
                    newPoints: newPoints
                };
            },
            /*
			 * Given a baseline, compute the convex hull of latLngs as an array
			 * of latLngs.
			 *
			 * @param {Array} latLngs
			 * @returns {Array}
			 */ buildConvexHull: function(baseLine, latLngs) {
                var convexHullBaseLines = [], t = this.findMostDistantPointFromBaseLine(baseLine, latLngs);
                if (t.maxPoint) {
                    convexHullBaseLines = convexHullBaseLines.concat(this.buildConvexHull([
                        baseLine[0],
                        t.maxPoint
                    ], t.newPoints));
                    convexHullBaseLines = convexHullBaseLines.concat(this.buildConvexHull([
                        t.maxPoint,
                        baseLine[1]
                    ], t.newPoints));
                    return convexHullBaseLines;
                } else return [
                    baseLine[0]
                ];
            },
            /*
			 * Given an array of latlngs, compute a convex hull as an array
			 * of latlngs
			 *
			 * @param {Array} latLngs
			 * @returns {Array}
			 */ getConvexHull: function(latLngs) {
                // find first baseline
                var maxLat = false, minLat = false, maxLng = false, minLng = false, maxLatPt = null, minLatPt = null, maxLngPt = null, minLngPt = null, maxPt = null, minPt = null, i;
                for(i = latLngs.length - 1; i >= 0; i--){
                    var pt = latLngs[i];
                    if (maxLat === false || pt.lat > maxLat) {
                        maxLatPt = pt;
                        maxLat = pt.lat;
                    }
                    if (minLat === false || pt.lat < minLat) {
                        minLatPt = pt;
                        minLat = pt.lat;
                    }
                    if (maxLng === false || pt.lng > maxLng) {
                        maxLngPt = pt;
                        maxLng = pt.lng;
                    }
                    if (minLng === false || pt.lng < minLng) {
                        minLngPt = pt;
                        minLng = pt.lng;
                    }
                }
                if (minLat !== maxLat) {
                    minPt = minLatPt;
                    maxPt = maxLatPt;
                } else {
                    minPt = minLngPt;
                    maxPt = maxLngPt;
                }
                var ch = [].concat(this.buildConvexHull([
                    minPt,
                    maxPt
                ], latLngs), this.buildConvexHull([
                    maxPt,
                    minPt
                ], latLngs));
                return ch;
            }
        };
    })();
    L.MarkerCluster.include({
        getConvexHull: function() {
            var childMarkers = this.getAllChildMarkers(), points = [], p, i;
            for(i = childMarkers.length - 1; i >= 0; i--){
                p = childMarkers[i].getLatLng();
                points.push(p);
            }
            return L.QuickHull.getConvexHull(points);
        }
    });
    //This code is 100% based on https://github.com/jawj/OverlappingMarkerSpiderfier-Leaflet
    //Huge thanks to jawj for implementing it first to make my job easy :-)
    L.MarkerCluster.include({
        _2PI: Math.PI * 2,
        _circleFootSeparation: 25,
        _circleStartAngle: 0,
        _spiralFootSeparation: 28,
        _spiralLengthStart: 11,
        _spiralLengthFactor: 5,
        _circleSpiralSwitchover: 9,
        // 0 -> always spiral; Infinity -> always circle
        spiderfy: function() {
            if (this._group._spiderfied === this || this._group._inZoomAnimation) return;
            var childMarkers = this.getAllChildMarkers(null, true), group = this._group, map = group._map, center = map.latLngToLayerPoint(this._latlng), positions;
            this._group._unspiderfy();
            this._group._spiderfied = this;
            //TODO Maybe: childMarkers order by distance to center
            if (this._group.options.spiderfyShapePositions) positions = this._group.options.spiderfyShapePositions(childMarkers.length, center);
            else if (childMarkers.length >= this._circleSpiralSwitchover) positions = this._generatePointsSpiral(childMarkers.length, center);
            else {
                center.y += 10; // Otherwise circles look wrong => hack for standard blue icon, renders differently for other icons.
                positions = this._generatePointsCircle(childMarkers.length, center);
            }
            this._animationSpiderfy(childMarkers, positions);
        },
        unspiderfy: function(zoomDetails) {
            /// <param Name="zoomDetails">Argument from zoomanim if being called in a zoom animation or null otherwise</param>
            if (this._group._inZoomAnimation) return;
            this._animationUnspiderfy(zoomDetails);
            this._group._spiderfied = null;
        },
        _generatePointsCircle: function(count, centerPt) {
            var circumference = this._group.options.spiderfyDistanceMultiplier * this._circleFootSeparation * (2 + count), legLength = circumference / this._2PI, angleStep = this._2PI / count, res = [], i, angle;
            legLength = Math.max(legLength, 35); // Minimum distance to get outside the cluster icon.
            res.length = count;
            for(i = 0; i < count; i++){
                angle = this._circleStartAngle + i * angleStep;
                res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
            }
            return res;
        },
        _generatePointsSpiral: function(count, centerPt) {
            var spiderfyDistanceMultiplier = this._group.options.spiderfyDistanceMultiplier, legLength = spiderfyDistanceMultiplier * this._spiralLengthStart, separation = spiderfyDistanceMultiplier * this._spiralFootSeparation, lengthFactor = spiderfyDistanceMultiplier * this._spiralLengthFactor * this._2PI, angle = 0, res = [], i;
            res.length = count;
            // Higher index, closer position to cluster center.
            for(i = count; i >= 0; i--){
                // Skip the first position, so that we are already farther from center and we avoid
                // being under the default cluster icon (especially important for Circle Markers).
                if (i < count) res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
                angle += separation / legLength + i * 0.0005;
                legLength += lengthFactor / angle;
            }
            return res;
        },
        _noanimationUnspiderfy: function() {
            var group = this._group, map = group._map, fg = group._featureGroup, childMarkers = this.getAllChildMarkers(null, true), m, i;
            group._ignoreMove = true;
            this.setOpacity(1);
            for(i = childMarkers.length - 1; i >= 0; i--){
                m = childMarkers[i];
                fg.removeLayer(m);
                if (m._preSpiderfyLatlng) {
                    m.setLatLng(m._preSpiderfyLatlng);
                    delete m._preSpiderfyLatlng;
                }
                if (m.setZIndexOffset) m.setZIndexOffset(0);
                if (m._spiderLeg) {
                    map.removeLayer(m._spiderLeg);
                    delete m._spiderLeg;
                }
            }
            group.fire('unspiderfied', {
                cluster: this,
                markers: childMarkers
            });
            group._ignoreMove = false;
            group._spiderfied = null;
        }
    });
    //Non Animated versions of everything
    L.MarkerClusterNonAnimated = L.MarkerCluster.extend({
        _animationSpiderfy: function(childMarkers, positions) {
            var group = this._group, map = group._map, fg = group._featureGroup, legOptions = this._group.options.spiderLegPolylineOptions, i, m, leg, newPos;
            group._ignoreMove = true;
            // Traverse in ascending order to make sure that inner circleMarkers are on top of further legs. Normal markers are re-ordered by newPosition.
            // The reverse order trick no longer improves performance on modern browsers.
            for(i = 0; i < childMarkers.length; i++){
                newPos = map.layerPointToLatLng(positions[i]);
                m = childMarkers[i];
                // Add the leg before the marker, so that in case the latter is a circleMarker, the leg is behind it.
                leg = new L.Polyline([
                    this._latlng,
                    newPos
                ], legOptions);
                map.addLayer(leg);
                m._spiderLeg = leg;
                // Now add the marker.
                m._preSpiderfyLatlng = m._latlng;
                m.setLatLng(newPos);
                if (m.setZIndexOffset) m.setZIndexOffset(1000000); //Make these appear on top of EVERYTHING
                fg.addLayer(m);
            }
            this.setOpacity(0.3);
            group._ignoreMove = false;
            group.fire('spiderfied', {
                cluster: this,
                markers: childMarkers
            });
        },
        _animationUnspiderfy: function() {
            this._noanimationUnspiderfy();
        }
    });
    //Animated versions here
    L.MarkerCluster.include({
        _animationSpiderfy: function(childMarkers, positions) {
            var me = this, group = this._group, map = group._map, fg = group._featureGroup, thisLayerLatLng = this._latlng, thisLayerPos = map.latLngToLayerPoint(thisLayerLatLng), svg = L.Path.SVG, legOptions = L.extend({}, this._group.options.spiderLegPolylineOptions), finalLegOpacity = legOptions.opacity, i, m, leg, legPath, legLength, newPos;
            if (finalLegOpacity === undefined) finalLegOpacity = L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity;
            if (svg) {
                // If the initial opacity of the spider leg is not 0 then it appears before the animation starts.
                legOptions.opacity = 0;
                // Add the class for CSS transitions.
                legOptions.className = (legOptions.className || '') + ' leaflet-cluster-spider-leg';
            } else // Make sure we have a defined opacity.
            legOptions.opacity = finalLegOpacity;
            group._ignoreMove = true;
            // Add markers and spider legs to map, hidden at our center point.
            // Traverse in ascending order to make sure that inner circleMarkers are on top of further legs. Normal markers are re-ordered by newPosition.
            // The reverse order trick no longer improves performance on modern browsers.
            for(i = 0; i < childMarkers.length; i++){
                m = childMarkers[i];
                newPos = map.layerPointToLatLng(positions[i]);
                // Add the leg before the marker, so that in case the latter is a circleMarker, the leg is behind it.
                leg = new L.Polyline([
                    thisLayerLatLng,
                    newPos
                ], legOptions);
                map.addLayer(leg);
                m._spiderLeg = leg;
                // Explanations: https://jakearchibald.com/2013/animated-line-drawing-svg/
                // In our case the transition property is declared in the CSS file.
                if (svg) {
                    legPath = leg._path;
                    legLength = legPath.getTotalLength() + 0.1; // Need a small extra length to avoid remaining dot in Firefox.
                    legPath.style.strokeDasharray = legLength; // Just 1 length is enough, it will be duplicated.
                    legPath.style.strokeDashoffset = legLength;
                }
                // If it is a marker, add it now and we'll animate it out
                if (m.setZIndexOffset) m.setZIndexOffset(1000000); // Make normal markers appear on top of EVERYTHING
                if (m.clusterHide) m.clusterHide();
                // Vectors just get immediately added
                fg.addLayer(m);
                if (m._setPos) m._setPos(thisLayerPos);
            }
            group._forceLayout();
            group._animationStart();
            // Reveal markers and spider legs.
            for(i = childMarkers.length - 1; i >= 0; i--){
                newPos = map.layerPointToLatLng(positions[i]);
                m = childMarkers[i];
                //Move marker to new position
                m._preSpiderfyLatlng = m._latlng;
                m.setLatLng(newPos);
                if (m.clusterShow) m.clusterShow();
                // Animate leg (animation is actually delegated to CSS transition).
                if (svg) {
                    leg = m._spiderLeg;
                    legPath = leg._path;
                    legPath.style.strokeDashoffset = 0;
                    //legPath.style.strokeOpacity = finalLegOpacity;
                    leg.setStyle({
                        opacity: finalLegOpacity
                    });
                }
            }
            this.setOpacity(0.3);
            group._ignoreMove = false;
            setTimeout(function() {
                group._animationEnd();
                group.fire('spiderfied', {
                    cluster: me,
                    markers: childMarkers
                });
            }, 200);
        },
        _animationUnspiderfy: function(zoomDetails) {
            var me = this, group = this._group, map = group._map, fg = group._featureGroup, thisLayerPos = zoomDetails ? map._latLngToNewLayerPoint(this._latlng, zoomDetails.zoom, zoomDetails.center) : map.latLngToLayerPoint(this._latlng), childMarkers = this.getAllChildMarkers(null, true), svg = L.Path.SVG, m, i, leg, legPath, legLength, nonAnimatable;
            group._ignoreMove = true;
            group._animationStart();
            //Make us visible and bring the child markers back in
            this.setOpacity(1);
            for(i = childMarkers.length - 1; i >= 0; i--){
                m = childMarkers[i];
                //Marker was added to us after we were spiderfied
                if (!m._preSpiderfyLatlng) continue;
                //Close any popup on the marker first, otherwise setting the location of the marker will make the map scroll
                m.closePopup();
                //Fix up the location to the real one
                m.setLatLng(m._preSpiderfyLatlng);
                delete m._preSpiderfyLatlng;
                //Hack override the location to be our center
                nonAnimatable = true;
                if (m._setPos) {
                    m._setPos(thisLayerPos);
                    nonAnimatable = false;
                }
                if (m.clusterHide) {
                    m.clusterHide();
                    nonAnimatable = false;
                }
                if (nonAnimatable) fg.removeLayer(m);
                // Animate the spider leg back in (animation is actually delegated to CSS transition).
                if (svg) {
                    leg = m._spiderLeg;
                    legPath = leg._path;
                    legLength = legPath.getTotalLength() + 0.1;
                    legPath.style.strokeDashoffset = legLength;
                    leg.setStyle({
                        opacity: 0
                    });
                }
            }
            group._ignoreMove = false;
            setTimeout(function() {
                //If we have only <= one child left then that marker will be shown on the map so don't remove it!
                var stillThereChildCount = 0;
                for(i = childMarkers.length - 1; i >= 0; i--){
                    m = childMarkers[i];
                    if (m._spiderLeg) stillThereChildCount++;
                }
                for(i = childMarkers.length - 1; i >= 0; i--){
                    m = childMarkers[i];
                    if (!m._spiderLeg) continue;
                    if (m.clusterShow) m.clusterShow();
                    if (m.setZIndexOffset) m.setZIndexOffset(0);
                    if (stillThereChildCount > 1) fg.removeLayer(m);
                    map.removeLayer(m._spiderLeg);
                    delete m._spiderLeg;
                }
                group._animationEnd();
                group.fire('unspiderfied', {
                    cluster: me,
                    markers: childMarkers
                });
            }, 200);
        }
    });
    L.MarkerClusterGroup.include({
        //The MarkerCluster currently spiderfied (if any)
        _spiderfied: null,
        unspiderfy: function() {
            this._unspiderfy.apply(this, arguments);
        },
        _spiderfierOnAdd: function() {
            this._map.on('click', this._unspiderfyWrapper, this);
            if (this._map.options.zoomAnimation) this._map.on('zoomstart', this._unspiderfyZoomStart, this);
            //Browsers without zoomAnimation or a big zoom don't fire zoomstart
            this._map.on('zoomend', this._noanimationUnspiderfy, this);
            if (!L.Browser.touch) this._map.getRenderer(this);
        },
        _spiderfierOnRemove: function() {
            this._map.off('click', this._unspiderfyWrapper, this);
            this._map.off('zoomstart', this._unspiderfyZoomStart, this);
            this._map.off('zoomanim', this._unspiderfyZoomAnim, this);
            this._map.off('zoomend', this._noanimationUnspiderfy, this);
            //Ensure that markers are back where they should be
            // Use no animation to avoid a sticky leaflet-cluster-anim class on mapPane
            this._noanimationUnspiderfy();
        },
        //On zoom start we add a zoomanim handler so that we are guaranteed to be last (after markers are animated)
        //This means we can define the animation they do rather than Markers doing an animation to their actual location
        _unspiderfyZoomStart: function() {
            if (!this._map) return;
            this._map.on('zoomanim', this._unspiderfyZoomAnim, this);
        },
        _unspiderfyZoomAnim: function(zoomDetails) {
            //Wait until the first zoomanim after the user has finished touch-zooming before running the animation
            if (L.DomUtil.hasClass(this._map._mapPane, 'leaflet-touching')) return;
            this._map.off('zoomanim', this._unspiderfyZoomAnim, this);
            this._unspiderfy(zoomDetails);
        },
        _unspiderfyWrapper: function() {
            /// <summary>_unspiderfy but passes no arguments</summary>
            this._unspiderfy();
        },
        _unspiderfy: function(zoomDetails) {
            if (this._spiderfied) this._spiderfied.unspiderfy(zoomDetails);
        },
        _noanimationUnspiderfy: function() {
            if (this._spiderfied) this._spiderfied._noanimationUnspiderfy();
        },
        //If the given layer is currently being spiderfied then we unspiderfy it so it isn't on the map anymore etc
        _unspiderfyLayer: function(layer) {
            if (layer._spiderLeg) {
                this._featureGroup.removeLayer(layer);
                if (layer.clusterShow) layer.clusterShow();
                //Position will be fixed up immediately in _animationUnspiderfy
                if (layer.setZIndexOffset) layer.setZIndexOffset(0);
                this._map.removeLayer(layer._spiderLeg);
                delete layer._spiderLeg;
            }
        }
    });
    /**
	 * Adds 1 public method to MCG and 1 to L.Marker to facilitate changing
	 * markers' icon options and refreshing their icon and their parent clusters
	 * accordingly (case where their iconCreateFunction uses data of childMarkers
	 * to make up the cluster icon).
	 */ L.MarkerClusterGroup.include({
        /**
		 * Updates the icon of all clusters which are parents of the given marker(s).
		 * In singleMarkerMode, also updates the given marker(s) icon.
		 * @param layers L.MarkerClusterGroup|L.LayerGroup|Array(L.Marker)|Map(L.Marker)|
		 * L.MarkerCluster|L.Marker (optional) list of markers (or single marker) whose parent
		 * clusters need to be updated. If not provided, retrieves all child markers of this.
		 * @returns {L.MarkerClusterGroup}
		 */ refreshClusters: function(layers) {
            if (!layers) layers = this._topClusterLevel.getAllChildMarkers();
            else if (layers instanceof L.MarkerClusterGroup) layers = layers._topClusterLevel.getAllChildMarkers();
            else if (layers instanceof L.LayerGroup) layers = layers._layers;
            else if (layers instanceof L.MarkerCluster) layers = layers.getAllChildMarkers();
            else if (layers instanceof L.Marker) layers = [
                layers
            ];
             // else: must be an Array(L.Marker)|Map(L.Marker)
            this._flagParentsIconsNeedUpdate(layers);
            this._refreshClustersIcons();
            // In case of singleMarkerMode, also re-draw the markers.
            if (this.options.singleMarkerMode) this._refreshSingleMarkerModeMarkers(layers);
            return this;
        },
        /**
		 * Simply flags all parent clusters of the given markers as having a "dirty" icon.
		 * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
		 * @private
		 */ _flagParentsIconsNeedUpdate: function(layers) {
            var id, parent;
            // Assumes layers is an Array or an Object whose prototype is non-enumerable.
            for(id in layers){
                // Flag parent clusters' icon as "dirty", all the way up.
                // Dumb process that flags multiple times upper parents, but still
                // much more efficient than trying to be smart and make short lists,
                // at least in the case of a hierarchy following a power law:
                // http://jsperf.com/flag-nodes-in-power-hierarchy/2
                parent = layers[id].__parent;
                while(parent){
                    parent._iconNeedsUpdate = true;
                    parent = parent.__parent;
                }
            }
        },
        /**
		 * Re-draws the icon of the supplied markers.
		 * To be used in singleMarkerMode only.
		 * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
		 * @private
		 */ _refreshSingleMarkerModeMarkers: function(layers) {
            var id, layer;
            for(id in layers){
                layer = layers[id];
                // Make sure we do not override markers that do not belong to THIS group.
                if (this.hasLayer(layer)) // Need to re-create the icon first, then re-draw the marker.
                layer.setIcon(this._overrideMarkerIcon(layer));
            }
        }
    });
    L.Marker.include({
        /**
		 * Updates the given options in the marker's icon and refreshes the marker.
		 * @param options map object of icon options.
		 * @param directlyRefreshClusters boolean (optional) true to trigger
		 * MCG.refreshClustersOf() right away with this single marker.
		 * @returns {L.Marker}
		 */ refreshIconOptions: function(options, directlyRefreshClusters) {
            var icon = this.options.icon;
            L.setOptions(icon, options);
            this.setIcon(icon);
            // Shortcut to refresh the associated MCG clusters right away.
            // To be used when refreshing a single marker.
            // Otherwise, better use MCG.refreshClusters() once at the end with
            // the list of modified markers.
            if (directlyRefreshClusters && this.__parent) this.__parent._group.refreshClusters(this);
            return this;
        }
    });
    exports1.MarkerClusterGroup = MarkerClusterGroup;
    exports1.MarkerCluster = MarkerCluster;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


// Fix for default markers in Leaflet with bundlers
delete (0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).Icon.Default.prototype._getIconUrl;
(0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).Icon.Default.mergeOptions({
    iconRetinaUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbXNfN1+3eRBozDpnOJgJAzWDZMAQgq4k3d5xA8sIoWZV5QZQQQ4iREIREiIRAJgn2nqXJQPpENHhhBXRBBEQEEeWQIaLi6ue899e95jfvv7Pmv/fwP85v5nPev3Pev9e59wH0A3AFhz8CwEgBcAOBvABqJoEoAJBIAJBhAFqNvwDAF8AL4A10LQB2cgfOUMv9P7RxA8wBwKvYQiGSh2bkgn6rvT8nTvIZIAAQ/PwKWL8Dwm2ZhO7oGgDjAAAA+P1vP4JyAKYAXgQA+Oj/k8kPwJCvbhNPOJmTlFMOk7eSpb3kn7tA6JJB+4kxnogxTfj5r7qEBxAEhvw8ALcB4AVQJwDgZWDgRwDgZgDwZwDQCwJoAAAFIIMEegCTswHPGODgFMAUOB0A7BdgsAPAx9VmQoqkB8RfSkCNhW8wAxI6egUAAPgFAV4C8E8kEi7J6zIZAKAF8LhCwFYB4EQA8HeCcwXA2QZJSM+BFqNSXwEAAFgBtAZcLQDwJQD0VABwNgD4j4D5APAcAPhrAOAJJJAGJtAJJH9jKhFRFEMd+Rjkuow2sAVdPdA8FXP8dQsqGvNfK1/nFDd3oKLM3TvCmI2c0JD9IePMfCsHvdBKP+S2rYYJcQCgwf2aBPxQTJI5yLWZWlYrjvN/tBdqUIB3EoKfKvJfJe7CzNAiXvA9LJkxZ2yxcojFtjcAmTHlFJGXbKWLkKJQr7nCAdVqnlkgLLJZ8BZ0A5hgzJdApRW7fQC0Y6RDQ7a7LIBrJz7FdARyFhYJcgR0yqBhJgMmhb1yVVc5n0bwZJM19C45OowNhXFvuaLVJoA7pSU3H3yEJ/kXCgKkH0fzjI3AmZvgN6OIEBK2Q1wCCVMZxQCzAkZt6h6MsKOawgI6P6AXCzAPEBJgDtCCAXgEBGgsAAmBA9EgAAnAOgEwGwBA2GA+BgAYBACi4FwDYAJgDJBG90AtgPBhNnO4VwAABBIBYw5DwAAkKcoBaEAAIgH+YBrCJ9R/M9wUAQqMBAGCGsEgGuTh4wAAGhJnYHgCzA2DQAQEQBkY6QDaYiYFkZWwygzMgAYH0CMeQAoSPsABPmGU1BBAS8B6QCChJ6tEi5GGAA5gAI+gkPgCBBQzNmOgCQQhDgDQGQAAWwGcCgKJ5QEOjAIcQACEDQKoIAOBYqgCCQGchDABOgEAIoAAjABBgAkCDJAJEFgCIHEE2gDBQAnDfyGwAiDAn2y0TZA1kWHoKv/WTXhIzMrjcO/dQhACf/+rUhBEhOjEFHHWrXiHoQBDCbNGmMc5wTwwA3+AANONhJC0YiCAgQ+qN6P5vADUoAgwj8qk5Hpw5oZbN+YGl9QGqFbHJ2QLRvMzpJGrG6LD9r1w1gkDBoQYMFX+BBgPiQOAABYHwMF2AoLjK6+gGmHsGHaGKCWAP1AqQNXQD2AelAjhABKiAc4AJQDc0ADQM8nV0AORNaAPQEaALQEaAPQEaAPQE6AAOgA6ADQM8nV0AORNaAPQEaALQEaAPQEaAPQE6AAOgA6ADQM8nV0AORNaAPQEaALQEaAPQEaAPQE6AAOgA6ABQD6gFIAPQCaBVHCMTjNV4AARdHpbpQxST4MKEpgJhSJ1SXUEK',
    iconUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbXNfN1+3eRBozDpnOJgJAzWDZMAQgq4k3d5xA8sIoWZV5QZQQQ4iREIREiIRAJgn2nqXJQPpENHhhBXRBBEQEEeWQIaLi6ue899e95jfvv7Pmv/fwP85v5nPev3Pev9e59wH0A3AFhz8CwEgBcAOBvABqJoEoAJBIAJBhAFqNvwDAF8AL4A10LQB2cgfOUMv9P7RxA8wBwKvYQiGSh2bkgn6rvT8nTvIZIAAQ/PwKWL8Dwm2ZhO7oGgDjAAAA+P1vP4JyAKYAXgQA+Oj/k8kPwJCvbhNPOJmTlFMOk7eSpb3kn7tA6JJB+4kxnogxTfj5r7qEBxAEhvw8ALcB4AVQJwDgZWDgRwDgZgDwZwDQCwJoAAAFIIMEegCTswHPGODgFMAUOB0A7BdgsAPAx9VmQoqkB8RfSkCNhW8wAxI6egUAAPgFAV4C8E8kEi7J6zIZAKAF8LhCwFYB4EQA8HeCcwXA2QZJSM+BFqNSXwEAAFgBtAZcLQDwJQD0VABwNgD4j4D5APAcAPhrAOAJJJAGJtAJJH9jKhFRFEMd+Rjkuow2sAVdPdA8FXP8dQsqGvNfK1/nFDd3oKLM3TvCmI2c0JD9IePMfCsHvdBKP+S2rYYJcQCgwf2aBPxQTJI5yLWZWlYrjvN/tBdqUIB3EoKfKvJfJe7CzNAiXvA9LJkxZ2yxcojFtjcAmTHlFJGXbKWLkKJQr7nCAdVqnlkgLLJZ8BZ0A5hgzJdApRW7fQC0Y6RDQ7a7LIBrJz7FdARyFhYJcgR0yqBhJgMmhb1yVVc5n0bwZJM19C45OowNhXFvuaLVJoA7pSU3H3yEJ/kXCgKkH0fzjI3AmZvgN6OIEBK2Q1wCCVMZxQCzAkZt6h6MsKOawgI6P6AXCzAPEBJgDtCCAXgEBGgsAAmBA9EgAAnAOgEwGwBA2GA+BgAYBACi4FwDYAJgDJBG90AtgPBhNnO4VwAABBIBYw5DwAAkKcoBaEAAIgH+YBrCJ9R/M9wUAQqMBAGCGsEgGuTh4wAAGhJnYHgCzA2DQAQEQBkY6QDaYiYFkZWwygzMgAYH0CMeQAoSPsABPmGU1BBAS8B6QCChJ6tEi5GGAA5gAI+gkPgCBBQzNmOgCQQhDgDQGQAAWwGcCgKJ5QEOjAIcQACEDQKoIAOBYqgCCQGchDABOgEAIoAAjABBgAkCDJAJEFgCIHEE2gDBQAnDfyGwAiDAn2y0TZA1kWHoKv/WTXhIzMrjcO/dQhACf/+rUhBEhOjEFHHWrXiHoQBDCbNGmMc5wTwwA3+AANONhJC0YiCAgQ+qN6P5vADUoAgwj8qk5Hpw5oZbN+YGl9QGqFbHJ2QLRvMzpJGrG6LD9r1w1gkDBoQYMFX+BBgPiQOAABYHwMF2AoLjK6+gGmHsGHaGKCWAP1AqQNXQD2AelAjhABKiAc4AJQDc0ADQM8nV0AORNaAPQEaALQEaAPQEaAPQE6AAOgA6ADQM8nV0AORNaAPQEaALQEaAPQEaAPQE6AAOgA6ADQM8nV0AORNaAPQEaALQEaAPQEaAPQE6AAOgA6ABQD6gFIAPQCaBVHCMTjNV4AARdHpbpQxST4MKEpgJhSJ1SXUEK',
    shadowUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD0VNiIiIiIiIiIiIiIiIiIiIhIXGemmPyDZCdJZBBBABDwcBAagEsNAQAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAg'
});
function $b4f3e47ab6efd409$var$MapContainer({ members: members, config: config, height: height, onMarkerHover: onMarkerHover, onMarkerHoverOut: onMarkerHoverOut, onBoundsChange: onBoundsChange, registerMapInstance: registerMapInstance, registerMarker: registerMarker, unregisterMarker: unregisterMarker, isFavorite: isFavorite, onToggleFavorite: onToggleFavorite, isPendingFavorite: isPendingFavorite, isLoggedIn: isLoggedIn = true }) {
    const mapRef = (0, $bh6RR.useRef)(null);
    const mapInstanceRef = (0, $bh6RR.useRef)(null);
    const markersRef = (0, $bh6RR.useRef)(null);
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(true);
    (0, $bh6RR.useEffect)(()=>{
        if (!mapRef.current) return;
        // Initialize map
        const map = (0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).map(mapRef.current, {
            center: [
                config?.config?.center_lat || 40.7128,
                config?.config?.center_lng || -74.006
            ],
            zoom: config?.config?.zoom_level || 10,
            scrollWheelZoom: false
        });
        // Add tile layer
        const tileStyle = config?.config?.tile_style || 'light';
        let tileUrl, attribution;
        switch(tileStyle){
            case 'dark':
                tileUrl = 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png';
                attribution = "\xa9 OpenStreetMap contributors \xa9 CARTO";
                break;
            case 'satellite':
                tileUrl = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';
                attribution = "Tiles \xa9 Esri";
                break;
            default:
                tileUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
                attribution = "\xa9 OpenStreetMap contributors";
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).tileLayer(tileUrl, {
            attribution: attribution,
            referrerPolicy: 'strict-origin-when-cross-origin'
        }).addTo(map);
        // Set up global event delegation for popup buttons
        // This handles both regular markers and clustered markers
        const handlePopupClick = (e)=>{
            const target = e.target.closest('.popup-message-btn, .popup-profile-btn, .popup-favorite-btn');
            if (!target) return;
            e.preventDefault();
            e.stopPropagation();
            if (target.classList.contains('popup-message-btn')) {
                const recipientId = target.getAttribute('data-recipient-id');
                const recipientName = target.getAttribute('data-recipient-name');
                const event = new CustomEvent('openMessageModal', {
                    detail: {
                        recipientId: recipientId,
                        recipientName: recipientName
                    }
                });
                window.dispatchEvent(event);
            } else if (target.classList.contains('popup-profile-btn')) {
                const profileUrl = target.getAttribute('data-profile-url');
                if (profileUrl) window.open(profileUrl, '_blank', 'noopener,noreferrer');
            } else if (target.classList.contains('popup-favorite-btn')) {
                const userId = target.getAttribute('data-user-id');
                if (userId && !target.disabled && onToggleFavorite) onToggleFavorite(userId);
            }
        };
        // Attach event listener to map container
        mapRef.current.addEventListener('click', handlePopupClick, true);
        // Enable scroll wheel zoom with focus
        map.on('focus', ()=>map.scrollWheelZoom.enable());
        map.on('blur', ()=>map.scrollWheelZoom.disable());
        // Create marker cluster group
        const markers = (0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).markerClusterGroup({
            chunkedLoading: true,
            maxClusterRadius: 80,
            spiderfyOnMaxZoom: true,
            showCoverageOnHover: false,
            zoomToBoundsOnClick: true,
            iconCreateFunction: function(cluster) {
                const count = cluster.getChildCount();
                let className = 'marker-cluster-small';
                if (count >= 100) className = 'marker-cluster-large';
                else if (count >= 10) className = 'marker-cluster-medium';
                return new (0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).DivIcon({
                    html: `<div><span>${count}</span></div>`,
                    className: `marker-cluster ${className}`,
                    iconSize: new (0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).Point(40, 40)
                });
            }
        });
        map.addLayer(markers);
        mapInstanceRef.current = map;
        markersRef.current = markers;
        // Register map instance with parent
        if (registerMapInstance) registerMapInstance(map);
        // Add bounds change listener
        if (onBoundsChange) map.on('moveend', ()=>{
            const bounds = map.getBounds();
            const boundsObj = {
                north: bounds.getNorth(),
                south: bounds.getSouth(),
                east: bounds.getEast(),
                west: bounds.getWest()
            };
            onBoundsChange(boundsObj);
        });
        setIsLoading(false);
        // Cleanup function
        return ()=>{
            if (mapRef.current) mapRef.current.removeEventListener('click', handlePopupClick, true);
            if (mapInstanceRef.current) {
                mapInstanceRef.current.remove();
                mapInstanceRef.current = null;
            }
        };
    }, [
        config,
        onToggleFavorite
    ]);
    // Update markers when members change
    (0, $bh6RR.useEffect)(()=>{
        if (!markersRef.current || !members) return;
        // Clear existing markers
        markersRef.current.clearLayers();
        // Add new markers
        const validMembers = members.filter((member)=>member.has_location && member.latitude && member.longitude);
        validMembers.forEach((member)=>{
            const marker = createMemberMarker(member);
            markersRef.current.addLayer(marker);
            // Register marker with parent for hover interactions
            if (registerMarker) registerMarker(member.user_id, marker);
        });
        // Fit map to markers if we have them
        if (validMembers.length > 0 && validMembers.length <= 100) {
            const group = new (0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).featureGroup(markersRef.current.getLayers());
            const bounds = group.getBounds();
            if (bounds.isValid()) mapInstanceRef.current.fitBounds(bounds.pad(0.1));
        }
    }, [
        members,
        config,
        registerMarker,
        isFavorite,
        isPendingFavorite,
        onToggleFavorite,
        isLoggedIn,
        onMarkerHover,
        onMarkerHoverOut
    ]);
    const decodeHtmlEntities = (str)=>{
        if (!str) return str;
        const textarea = document.createElement('textarea');
        textarea.innerHTML = str;
        return textarea.value;
    };
    const createMemberMarker = (member)=>{
        // Create custom icon with marker_icon (fallback to avatar_url for compatibility)
        const markerIconUrl = member.marker_icon || member.avatar_url;
        const iconHtml = `
            <div class="member-marker" data-user-id="${member.user_id}">
                <img src="${markerIconUrl}" alt="${decodeHtmlEntities(member.display_name)}" 
                     class="marker-avatar" 
                     onerror="this.src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNjY2MiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIxNiIgcj0iNiIgZmlsbD0iI2ZmZiIvPgo8cGF0aCBkPSJNMzAgMzJjMC01LjUyMy00LjQ3Ny0xMC0xMC0xMHMtMTAgNC40NzctMTAgMTAiIGZpbGw9IiNmZmYiLz4KPC9zdmc+'" />
            </div>
        `;
        const customIcon = (0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).divIcon({
            html: iconHtml,
            className: 'custom-member-marker',
            iconSize: [
                40,
                40
            ],
            iconAnchor: [
                20,
                40
            ],
            popupAnchor: [
                0,
                -40
            ]
        });
        const marker = (0, (/*@__PURE__*/$parcel$interopDefault($bjwWZ))).marker([
            member.latitude,
            member.longitude
        ], {
            icon: customIcon,
            title: decodeHtmlEntities(member.display_name)
        });
        // Determine if we're using avatar as cover image based on form config (same as OptimizedMemberCard)
        const formConfig = config?.config || config || {};
        const coverImageSource = formConfig.cover_image_source || 'bp_cover';
        const isUsingAvatarAsCover = coverImageSource === 'bp_avatar';
        // Create popup content - use cover_image for popup (fallback to avatar_url for compatibility)
        // Guard: some plugins store the field value as an HTML <img> tag — extract the src if so
        const extractUrlFromHtml = (val)=>{
            if (val && val.includes('<img')) {
                const m = val.match(/src=["']([^"']+)["']/);
                return m ? m[1] : '';
            }
            return val;
        };
        const coverImageUrl = extractUrlFromHtml(member.cover_image) || member.avatar_url;
        let popupContent = `
            <div class="member-popup">
                <div class="popup-cover-header ${isUsingAvatarAsCover ? 'avatar-as-cover' : ''}">
                    <img src="${coverImageUrl}" alt="${decodeHtmlEntities(member.display_name)}" class="member-cover-image ${isUsingAvatarAsCover ? 'is-avatar' : ''}">
                </div>
                <div class="popup-content">
                    <div class="member-name">${decodeHtmlEntities(member.display_name)}</div>
        `;
        if (member.display_fields?.length > 0) {
            // Filter fields that should show in popup
            const popupFields = member.display_fields.filter((field)=>field.show_in_popup !== false);
            if (popupFields.length > 0) {
                popupContent += '<div class="member-fields">';
                popupFields.forEach((field)=>{
                    if (field.value) {
                        let fieldValue;
                        const hideLabel = field.hide_label || false;
                        // Handle custom formatted fields (admin-set HTML content)
                        if (field.type === 'custom_format') // For custom formatted fields, use the value as-is (it's already safe HTML)
                        fieldValue = field.value;
                        else // For regular fields, decode HTML entities
                        fieldValue = Array.isArray(field.value) ? field.value.map((v)=>decodeHtmlEntities(v)).join(', ') : decodeHtmlEntities(field.value);
                        popupContent += `
                            <div class="member-field" data-field-id="${field.field_id}" id="popup-member-${member.user_id}-field-${field.field_id}">
                                ${hideLabel ? '' : `<span class="field-label">${decodeHtmlEntities(field.label)}:</span> `}${fieldValue}
                            </div>
                        `;
                    }
                });
                popupContent += '</div>';
            }
        }
        if (member.profile_url) {
            popupContent += '<div class=\"member-actions\">';
            // Always show profile button
            popupContent += `
                <button 
                    class=\"base-btn profile-btn btn-icon btn-outline popup-profile-btn\" 
                    data-profile-url=\"${member.profile_url}\"
                    title=\"View ${decodeHtmlEntities(member.display_name).replace(/\"/g, '&quot;')}'s profile\"
                >
                    <svg class=\"profile-icon\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"currentColor\">
                        <path d=\"M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z\"/>
                    </svg>
                </button>
            `;
            // Only show message and favorite buttons if user is logged in
            if (isLoggedIn) {
                const memberIsFavorite = isFavorite(member.user_id);
                const memberIsPending = isPendingFavorite(member.user_id);
                popupContent += `
                    <button 
                        class="base-btn message-btn btn-icon btn-outline popup-message-btn" 
                        data-recipient-id="${member.user_id}" 
                        data-recipient-name="${decodeHtmlEntities(member.display_name).replace(/"/g, '&quot;')}"
                        title="Send message to ${decodeHtmlEntities(member.display_name).replace(/"/g, '&quot;')}"
                    >
                        <svg class="message-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"/>
                            <path d="M7 9H17V11H7V9Z"/>
                            <path d="M7 12H13V14H7V12Z"/>
                        </svg>
                    </button>
                    <button 
                        class="base-btn favorite-btn btn-icon btn-outline popup-favorite-btn ${memberIsFavorite ? 'favorited' : ''} ${memberIsPending ? 'pending' : ''}" 
                        data-user-id="${member.user_id}"
                        title="${memberIsPending ? memberIsFavorite ? 'Removing from favorites...' : 'Adding to favorites...' : memberIsFavorite ? 'Remove from favorites' : 'Add to favorites'}"
                        ${memberIsPending ? 'disabled' : ''}
                    >
                `;
                if (memberIsPending) popupContent += `
                        <svg class="favorite-loading" width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-dasharray="32" stroke-dashoffset="32">
                                <animate attributeName="stroke-dasharray" dur="2s" values="0 32;16 16;0 32;0 32" repeatCount="indefinite" />
                                <animate attributeName="stroke-dashoffset" dur="2s" values="0;-16;-32;-32" repeatCount="indefinite" />
                            </circle>
                        </svg>
                    `;
                else popupContent += `
                        <svg class="favorite-icon" width="14" height="14" viewBox="0 0 24 24" fill="${memberIsFavorite ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                        </svg>
                    `;
                popupContent += `
                    </button>
                `;
            }
            popupContent += '</div></div>';
        }
        popupContent += '</div></div>'; // Close popup-content and member-popup
        marker.bindPopup(popupContent);
        // Add event listeners for hover functionality
        marker.on('popupopen', ()=>{
            if (onMarkerHover) onMarkerHover(member);
        });
        marker.on('popupclose', ()=>{
            if (onMarkerHoverOut) onMarkerHoverOut();
        });
        return marker;
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "map-container",
        style: {
            height: height
        },
        children: [
            isLoading && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "map-loading",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: "Loading map..."
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                ref: mapRef,
                className: "leaflet-map",
                style: {
                    height: '100%'
                }
            })
        ]
    });
}
var $b4f3e47ab6efd409$export$2e2bcd8739ae039 = $b4f3e47ab6efd409$var$MapContainer;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
function $7c1373b0e06f0b47$var$Modal({ children: children, onClose: onClose, title: title, headerActions: headerActions, className: className = '' }) {
    (0, $bh6RR.useEffect)(()=>{
        const handleEscape = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleEscape);
        document.body.style.overflow = 'hidden';
        return ()=>{
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'auto';
        };
    }, [
        onClose
    ]);
    const handleBackdropClick = (e)=>{
        if (e.target === e.currentTarget) onClose();
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "modal-overlay",
        onClick: handleBackdropClick,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: `modal-content ${className}`,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "modal-header-content",
                            children: [
                                title && /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                                    className: "modal-title",
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                    onClick: onClose,
                                    className: "modal-close",
                                    "aria-label": "Close modal",
                                    children: "\xd7"
                                })
                            ]
                        }),
                        headerActions && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "modal-header-actions",
                            children: headerActions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "modal-body",
                    children: children
                })
            ]
        })
    });
}
var $7c1373b0e06f0b47$export$2e2bcd8739ae039 = $7c1373b0e06f0b47$var$Modal;



const $d00350881ea0f0be$var$decodeHtmlEntities = (str)=>{
    if (!str) return str;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
};
function $d00350881ea0f0be$var$FilterModal({ config: config, currentFilters: currentFilters, onApply: onApply, onClose: onClose }) {
    const [localFilters, setLocalFilters] = (0, $bh6RR.useState)({
        ...currentFilters
    });
    (0, $bh6RR.useEffect)(()=>{
        setLocalFilters({
            ...currentFilters
        });
    }, [
        currentFilters
    ]);
    const handleFilterChange = (fieldId, value)=>{
        setLocalFilters((prev)=>{
            // If value is empty, remove the filter
            if (!value || Array.isArray(value) && value.length === 0 || typeof value === 'string' && value.trim() === '') {
                const newFilters = {
                    ...prev
                };
                delete newFilters[fieldId];
                return newFilters;
            }
            return {
                ...prev,
                [fieldId]: value
            };
        });
    };
    const handleApply = ()=>{
        onApply(localFilters);
    };
    const handleClear = ()=>{
        setLocalFilters({});
    };
    const renderFilterField = (filter)=>{
        const currentValue = localFilters[filter.field_id] || '';
        const filterType = filter.filter_type || filter.type; // Use configured filter_type or fallback to field type
        const filterLabel = $d00350881ea0f0be$var$decodeHtmlEntities(filter.label || filter.name);
        // Handle the case where checkbox/multiselect fields are configured to display as 'select' (which means multi-select dropdown in admin)
        const isMultiValueField = [
            'checkbox',
            'multiselectbox',
            'multiselect'
        ].includes(filter.type);
        const effectiveFilterType = filterType === 'select' && isMultiValueField ? 'multiselect' : filterType;
        // Special handling for datebox fields rendered as checkbox (has value check)
        // Check both original_type (from BP) and type (mapped) for backward compatibility
        const isDateboxCheckbox = (filter.original_type === 'datebox' || filter.type === 'date') && effectiveFilterType === 'checkbox';
        switch(effectiveFilterType){
            case 'select':
                return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "filter-field",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                            htmlFor: filter.field_id,
                            className: "filter-label",
                            children: filterLabel
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("select", {
                            id: filter.field_id,
                            value: currentValue,
                            onChange: (e)=>handleFilterChange(filter.field_id, e.target.value),
                            className: "filter-select",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("option", {
                                    value: "",
                                    children: "Any"
                                }),
                                filter.options?.map((option)=>/*#__PURE__*/ (0, $ih19M.jsx)("option", {
                                        value: option.value,
                                        children: $d00350881ea0f0be$var$decodeHtmlEntities(option.label)
                                    }, option.value))
                            ]
                        })
                    ]
                }, filter.field_id);
            case 'multiselect':
                return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "filter-field",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                            htmlFor: filter.field_id,
                            className: "filter-label",
                            children: filterLabel
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("select", {
                            id: filter.field_id,
                            value: Array.isArray(currentValue) ? currentValue : [],
                            onChange: (e)=>{
                                const selectedOptions = Array.from(e.target.selectedOptions, (option)=>option.value);
                                handleFilterChange(filter.field_id, selectedOptions);
                            },
                            multiple: true,
                            className: "filter-select",
                            children: filter.options?.map((option)=>/*#__PURE__*/ (0, $ih19M.jsx)("option", {
                                    value: option.value,
                                    children: $d00350881ea0f0be$var$decodeHtmlEntities(option.label)
                                }, option.value))
                        })
                    ]
                }, filter.field_id);
            case 'checkbox':
                // Special case: datebox field as checkbox (single checkbox for "has value")
                if (isDateboxCheckbox) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "filter-field",
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                        className: "checkbox-label",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                type: "checkbox",
                                checked: currentValue === 'has_value' || currentValue === true,
                                onChange: (e)=>{
                                    handleFilterChange(filter.field_id, e.target.checked ? 'has_value' : '');
                                }
                            }),
                            filterLabel
                        ]
                    })
                }, filter.field_id);
                // Regular checkbox field with multiple options
                return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "filter-field checkbox-group",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            className: "filter-label",
                            children: filterLabel
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "checkbox-options",
                            children: filter.options?.map((option)=>/*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                                    className: "checkbox-label",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                            type: "checkbox",
                                            value: option.value,
                                            checked: Array.isArray(currentValue) ? currentValue.includes(option.value) : currentValue === option.value,
                                            onChange: (e)=>{
                                                let newValue;
                                                if (Array.isArray(currentValue)) {
                                                    if (e.target.checked) newValue = [
                                                        ...currentValue,
                                                        option.value
                                                    ];
                                                    else newValue = currentValue.filter((v)=>v !== option.value);
                                                } else newValue = e.target.checked ? [
                                                    option.value
                                                ] : [];
                                                handleFilterChange(filter.field_id, newValue);
                                            }
                                        }),
                                        $d00350881ea0f0be$var$decodeHtmlEntities(option.label)
                                    ]
                                }, option.value))
                        })
                    ]
                }, filter.field_id);
            case 'radio':
                return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "filter-field radio-group",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            className: "filter-label",
                            children: filterLabel
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "radio-options",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                                    className: "radio-label",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                            type: "radio",
                                            name: `filter_${filter.field_id}`,
                                            value: "",
                                            checked: !currentValue,
                                            onChange: (e)=>handleFilterChange(filter.field_id, e.target.value)
                                        }),
                                        "Any"
                                    ]
                                }),
                                filter.options?.map((option)=>/*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                                        className: "radio-label",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                                type: "radio",
                                                name: `filter_${filter.field_id}`,
                                                value: option.value,
                                                checked: currentValue === option.value,
                                                onChange: (e)=>handleFilterChange(filter.field_id, e.target.value)
                                            }),
                                            $d00350881ea0f0be$var$decodeHtmlEntities(option.label)
                                        ]
                                    }, option.value))
                            ]
                        })
                    ]
                }, filter.field_id);
            case 'text':
            case 'search':
                return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "filter-field",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                            htmlFor: filter.field_id,
                            className: "filter-label",
                            children: filterLabel
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                            type: "text",
                            id: filter.field_id,
                            value: currentValue,
                            onChange: (e)=>handleFilterChange(filter.field_id, e.target.value),
                            placeholder: `Search ${filterLabel.toLowerCase()}...`,
                            className: "filter-input"
                        })
                    ]
                }, filter.field_id);
            case 'number':
                return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "filter-field",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                            htmlFor: filter.field_id,
                            className: "filter-label",
                            children: filterLabel
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                            type: "number",
                            id: filter.field_id,
                            value: currentValue,
                            onChange: (e)=>handleFilterChange(filter.field_id, e.target.value),
                            className: "filter-input"
                        })
                    ]
                }, filter.field_id);
            case 'date':
                return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "filter-field",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                            htmlFor: filter.field_id,
                            className: "filter-label",
                            children: filterLabel
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                            type: "date",
                            id: filter.field_id,
                            value: currentValue,
                            onChange: (e)=>handleFilterChange(filter.field_id, e.target.value),
                            className: "filter-input"
                        })
                    ]
                }, filter.field_id);
            case 'range':
                return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "filter-field range-field",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            className: "filter-label",
                            children: filterLabel
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "range-inputs",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                    type: "number",
                                    placeholder: "Min",
                                    value: currentValue?.min || '',
                                    onChange: (e)=>handleFilterChange(filter.field_id, {
                                            ...currentValue,
                                            min: e.target.value
                                        }),
                                    className: "filter-input range-input"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                    className: "range-separator",
                                    children: "to"
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                    type: "number",
                                    placeholder: "Max",
                                    value: currentValue?.max || '',
                                    onChange: (e)=>handleFilterChange(filter.field_id, {
                                            ...currentValue,
                                            max: e.target.value
                                        }),
                                    className: "filter-input range-input"
                                })
                            ]
                        })
                    ]
                }, filter.field_id);
            default:
                return null;
        }
    };
    const activeFilterCount = Object.keys(localFilters).filter((key)=>{
        const value = localFilters[key];
        return value && (typeof value === 'string' && value.trim() || Array.isArray(value) && value.length > 0 || typeof value === 'object' && value !== null && (value.min || value.max));
    }).length;
    const headerActions = /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "filter-count",
                children: activeFilterCount > 0 && /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                    children: [
                        activeFilterCount,
                        " filter",
                        activeFilterCount !== 1 ? 's' : '',
                        " active"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "action-buttons",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e11a6c830487d92f$export$2e2bcd8739ae039), {
                        onClick: handleClear,
                        variant: "outline",
                        disabled: activeFilterCount === 0,
                        children: "Clear All"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e11a6c830487d92f$export$2e2bcd8739ae039), {
                        onClick: handleApply,
                        variant: "primary",
                        children: "Apply Filters"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $7c1373b0e06f0b47$export$2e2bcd8739ae039), {
        onClose: onClose,
        title: "Filter Members",
        headerActions: headerActions,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: "filter-modal-content",
            children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "filter-fields",
                children: [
                    !config?.filters || config.filters.length === 0 ? /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "no-filters-message",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                children: "No filters have been configured for this form."
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)("em", {
                                    children: "Configure filters in the admin panel to enable filtering."
                                })
                            })
                        ]
                    }) : config.filters.map(renderFilterField),
                    config?.config?.enable_location_filters && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "location-filters",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("h4", {
                                children: "Location Filters"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "filter-field",
                                children: /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                            type: "checkbox",
                                            checked: localFilters.has_location || false,
                                            onChange: (e)=>handleFilterChange('has_location', e.target.checked)
                                        }),
                                        "Only show members with location"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "filter-field",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                        htmlFor: "distance_from",
                                        children: "Distance from location"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "distance-filter",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                                type: "text",
                                                id: "location_search",
                                                placeholder: "Enter city or address...",
                                                value: localFilters.location_search || '',
                                                onChange: (e)=>handleFilterChange('location_search', e.target.value),
                                                className: "filter-input"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("select", {
                                                value: localFilters.distance_radius || '',
                                                onChange: (e)=>handleFilterChange('distance_radius', e.target.value),
                                                className: "filter-select distance-select",
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("option", {
                                                        value: "",
                                                        children: "Any distance"
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("option", {
                                                        value: "5",
                                                        children: "Within 5 km"
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("option", {
                                                        value: "10",
                                                        children: "Within 10 km"
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("option", {
                                                        value: "25",
                                                        children: "Within 25 km"
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("option", {
                                                        value: "50",
                                                        children: "Within 50 km"
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("option", {
                                                        value: "100",
                                                        children: "Within 100 km"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var $d00350881ea0f0be$export$2e2bcd8739ae039 = $d00350881ea0f0be$var$FilterModal;



var $fFSBL = parcelRequire("fFSBL");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");



var $fFSBL = parcelRequire("fFSBL");
// API service for communicating with WordPress backend
const $c1444e3d73f2c384$var$API_BASE = window.gwBpGeoSearchAjax?.ajaxurl || '/wp-admin/admin-ajax.php';
const $c1444e3d73f2c384$var$NONCE = window.gwBpGeoSearchAjax?.nonce || '';
const $c1444e3d73f2c384$var$REST_NONCE = window.gwBpGeoSearchAjax?.restNonce || '';
class $c1444e3d73f2c384$var$ApiError extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        this.name = 'ApiError';
    }
}
async function $c1444e3d73f2c384$var$makeRequest(action, data = {}) {
    const formData = new FormData();
    formData.append('action', action);
    formData.append('nonce', $c1444e3d73f2c384$var$NONCE);
    console.log('API: makeRequest called with action:', action);
    console.log('API: makeRequest data:', data);
    Object.keys(data).forEach((key)=>{
        if (data[key] !== null && data[key] !== undefined) {
            if (key === 'xprofile_filters' && typeof data[key] === 'object') // Send each filter as a separate field: xprofile_filters[fieldId]=value
            Object.keys(data[key]).forEach((fieldId)=>{
                const value = data[key][fieldId];
                if (Array.isArray(value)) {
                    // For arrays, always send as array format, even for single values
                    if (value.length === 0) // Don't send empty arrays
                    return;
                    else if (value.length === 1) // For single-item arrays, still use array notation to ensure PHP receives it as array
                    formData.append(`xprofile_filters[${fieldId}][]`, value[0]);
                    else // For multi-item arrays, send each value
                    value.forEach((item)=>{
                        formData.append(`xprofile_filters[${fieldId}][]`, item);
                    });
                } else formData.append(`xprofile_filters[${fieldId}]`, value);
            });
            else if (typeof data[key] === 'object') formData.append(key, JSON.stringify(data[key]));
            else formData.append(key, data[key]);
        }
    });
    // Debug: Log FormData contents
    console.log('API: FormData entries:');
    for (let [key, value] of formData.entries())console.log(`  ${key}:`, value);
    try {
        const response = await fetch($c1444e3d73f2c384$var$API_BASE, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        });
        if (!response.ok) throw new $c1444e3d73f2c384$var$ApiError(`HTTP error! status: ${response.status}`, response.status);
        const result = await response.json();
        if (!result.success) throw new $c1444e3d73f2c384$var$ApiError(result.data?.message || 'API request failed');
        return result.data;
    } catch (error) {
        if (error instanceof $c1444e3d73f2c384$var$ApiError) throw error;
        throw new $c1444e3d73f2c384$var$ApiError(`Network error: ${error.message}`);
    }
}
async function $c1444e3d73f2c384$export$14223e3d3aa5fd3b({ formId: formId, search: search = '', filters: filters = {}, bounds: bounds = null, includeNoLocation: includeNoLocation = false, limit: limit = null, offset: offset = 0 }) {
    console.log('API: fetchMembers called with filters:', filters);
    console.log('API: Filters object type:', typeof filters);
    console.log('API: Filters keys:', Object.keys(filters));
    // Filter out empty values before sending
    const cleanFilters = {};
    Object.keys(filters).forEach((key)=>{
        const value = filters[key];
        if (value && (typeof value === 'string' && value.trim() || Array.isArray(value) && value.length > 0 || typeof value === 'object' && value !== null && (value.min || value.max))) cleanFilters[key] = value;
    });
    console.log('API: Clean filters being sent:', cleanFilters);
    return $c1444e3d73f2c384$var$makeRequest('gw_bp_get_members', {
        form_id: formId,
        search_term: search,
        xprofile_filters: cleanFilters,
        bounds: bounds,
        include_no_location: includeNoLocation,
        limit: limit,
        offset: offset
    });
}
async function $c1444e3d73f2c384$export$a17b4f8f942a1896() {
    return new Promise((resolve, reject)=>{
        if (!navigator.geolocation) {
            reject(new Error('Geolocation is not supported'));
            return;
        }
        navigator.geolocation.getCurrentPosition((position)=>{
            resolve({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                accuracy: position.coords.accuracy
            });
        }, (error)=>{
            reject(new Error(`Geolocation error: ${error.message}`));
        }, {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 300000 // 5 minutes
        });
    });
}
async function $c1444e3d73f2c384$export$465cb47180de50f0({ recipientId: recipientId, subject: subject, message: message }) {
    return $c1444e3d73f2c384$var$makeRequest('gw_bp_send_message', {
        recipient_id: recipientId,
        subject: subject,
        message: message
    });
}
async function $c1444e3d73f2c384$export$3f3dc3c29ae7d456({ limit: limit = 20, offset: offset = 0 }) {
    return $c1444e3d73f2c384$var$makeRequest('gw_bp_get_message_threads', {
        limit: limit,
        offset: offset
    });
}
// Favorites API functions - using GW BP Favorites REST API
const $c1444e3d73f2c384$var$FAVORITES_API_BASE = '/wp-json/bp-favorites/v1';
async function $c1444e3d73f2c384$var$makeFavoritesRequest(endpoint, method = 'GET', data = {}) {
    const url = `${$c1444e3d73f2c384$var$FAVORITES_API_BASE}${endpoint}`;
    const options = {
        method: method,
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': $c1444e3d73f2c384$var$REST_NONCE
        }
    };
    if (method !== 'GET' && Object.keys(data).length > 0) options.body = JSON.stringify(data);
    try {
        const response = await fetch(url, options);
        if (!response.ok) throw new $c1444e3d73f2c384$var$ApiError(`Favorites API error! status: ${response.status}`, response.status);
        return await response.json();
    } catch (error) {
        if (error instanceof $c1444e3d73f2c384$var$ApiError) throw error;
        throw new $c1444e3d73f2c384$var$ApiError(`Favorites network error: ${error.message}`);
    }
}
async function $c1444e3d73f2c384$export$fc33f5d75aa00355(userId) {
    return $c1444e3d73f2c384$var$makeFavoritesRequest(`/${userId}`);
}
async function $c1444e3d73f2c384$export$aa03d8c0f74def9f(favoriteUserId) {
    return $c1444e3d73f2c384$var$makeFavoritesRequest('/add', 'POST', {
        favorite_id: favoriteUserId
    });
}
async function $c1444e3d73f2c384$export$fa150b6a95787654(favoriteUserId) {
    return $c1444e3d73f2c384$var$makeFavoritesRequest('/remove', 'POST', {
        favorite_id: favoriteUserId
    });
}
async function $c1444e3d73f2c384$export$598524930a5d09cb(userId) {
    try {
        console.log('getAllUserFavorites called with userId:', userId);
        const favorites = await $c1444e3d73f2c384$export$fc33f5d75aa00355(userId);
        console.log('Raw favorites response:', favorites);
        // Handle different possible response formats
        if (!favorites) {
            console.log('No favorites returned, returning empty array');
            return [];
        }
        if (Array.isArray(favorites)) {
            // If it's already an array, extract user IDs
            const userIds = favorites.map((fav)=>{
                // Try different possible property names
                return fav.user_id || fav.id || fav.favorite_id || fav;
            }).filter((id)=>id); // Filter out any null/undefined values
            console.log('Extracted user IDs:', userIds);
            return userIds;
        }
        // If it's an object, might be wrapped in a data property
        if (favorites.data && Array.isArray(favorites.data)) {
            const userIds = favorites.data.map((fav)=>fav.user_id || fav.id || fav.favorite_id || fav).filter((id)=>id);
            console.log('Extracted user IDs from data property:', userIds);
            return userIds;
        }
        console.log('Unexpected favorites format, returning empty array');
        return [];
    } catch (error) {
        console.error('Error in getAllUserFavorites:', error);
        // Return empty array on error rather than throwing
        return [];
    }
}


function $a925be1700afc867$var$MessageModal({ isOpen: isOpen, onClose: onClose, recipientId: recipientId, recipientName: recipientName, onMessageSent: onMessageSent = null }) {
    const [subject, setSubject] = (0, $bh6RR.useState)('');
    const [message, setMessage] = (0, $bh6RR.useState)('');
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [errors, setErrors] = (0, $bh6RR.useState)({});
    const [successMessage, setSuccessMessage] = (0, $bh6RR.useState)('');
    // Reset form when modal opens/closes
    (0, $bh6RR.useEffect)(()=>{
        if (isOpen) {
            setSubject('');
            setMessage('');
            setErrors({});
            setSuccessMessage('');
        }
    }, [
        isOpen
    ]);
    const validateForm = ()=>{
        const newErrors = {};
        if (!subject.trim()) newErrors.subject = 'Subject is required';
        else if (subject.length > 100) newErrors.subject = 'Subject must be less than 100 characters';
        if (!message.trim()) newErrors.message = 'Message is required';
        else if (message.length > 5000) newErrors.message = 'Message must be less than 5000 characters';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!validateForm()) return;
        setIsLoading(true);
        setErrors({});
        try {
            await (0, $c1444e3d73f2c384$export$465cb47180de50f0)({
                recipientId: recipientId,
                subject: subject.trim(),
                message: message.trim()
            });
            setSuccessMessage('Message sent successfully!');
            // Call callback if provided
            if (onMessageSent) onMessageSent();
            // Close modal after short delay
            setTimeout(()=>{
                onClose();
            }, 1500);
        } catch (error) {
            setErrors({
                submit: error.message || 'Failed to send message. Please try again.'
            });
        } finally{
            setIsLoading(false);
        }
    };
    const handleCancel = ()=>{
        if (isLoading) return;
        onClose();
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $7c1373b0e06f0b47$export$2e2bcd8739ae039), {
        onClose: handleCancel,
        title: `Send Message to ${recipientName}`,
        className: "message-modal",
        children: successMessage ? /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "message-success",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "success-icon",
                    children: "\u2713"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    children: successMessage
                })
            ]
        }) : /*#__PURE__*/ (0, $ih19M.jsxs)("form", {
            onSubmit: handleSubmit,
            className: "message-form",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "form-group",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                            htmlFor: "message-subject",
                            className: "form-label",
                            children: "Subject *"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                            id: "message-subject",
                            type: "text",
                            value: subject,
                            onChange: (e)=>setSubject(e.target.value),
                            className: `form-input ${errors.subject ? 'error' : ''}`,
                            placeholder: "Enter message subject",
                            maxLength: 100,
                            disabled: isLoading
                        }),
                        errors.subject && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            className: "form-error",
                            children: errors.subject
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "char-count",
                            children: [
                                subject.length,
                                "/100"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "form-group",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                            htmlFor: "message-content",
                            className: "form-label",
                            children: "Message *"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("textarea", {
                            id: "message-content",
                            value: message,
                            onChange: (e)=>setMessage(e.target.value),
                            className: `form-textarea ${errors.message ? 'error' : ''}`,
                            placeholder: `Write your message to ${recipientName}...`,
                            rows: 6,
                            maxLength: 5000,
                            disabled: isLoading
                        }),
                        errors.message && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            className: "form-error",
                            children: errors.message
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "char-count",
                            children: [
                                message.length,
                                "/5000"
                            ]
                        })
                    ]
                }),
                errors.submit && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "form-error submit-error",
                    children: errors.submit
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "form-actions",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $e11a6c830487d92f$export$2e2bcd8739ae039), {
                            type: "button",
                            variant: "secondary",
                            onClick: handleCancel,
                            disabled: isLoading,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $e11a6c830487d92f$export$2e2bcd8739ae039), {
                            type: "submit",
                            variant: "primary",
                            disabled: isLoading || !subject.trim() || !message.trim(),
                            children: isLoading ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $fFSBL.default), {
                                        size: "small"
                                    }),
                                    "Sending..."
                                ]
                            }) : 'Send Message'
                        })
                    ]
                })
            ]
        })
    });
}
var $a925be1700afc867$export$2e2bcd8739ae039 = $a925be1700afc867$var$MessageModal;


function $6ee6e489605fab21$var$MessageManager() {
    const [isModalOpen, setIsModalOpen] = (0, $bh6RR.useState)(false);
    const [recipientId, setRecipientId] = (0, $bh6RR.useState)(null);
    const [recipientName, setRecipientName] = (0, $bh6RR.useState)('');
    const [onMessageSent, setOnMessageSent] = (0, $bh6RR.useState)(null);
    (0, $bh6RR.useEffect)(()=>{
        const handleOpenModal = (event)=>{
            const { recipientId: recipientId, recipientName: recipientName, onMessageSent: onMessageSent } = event.detail;
            setRecipientId(recipientId);
            setRecipientName(recipientName);
            setOnMessageSent(()=>onMessageSent);
            setIsModalOpen(true);
        };
        window.addEventListener('openMessageModal', handleOpenModal);
        return ()=>{
            window.removeEventListener('openMessageModal', handleOpenModal);
        };
    }, []);
    const handleCloseModal = ()=>{
        setIsModalOpen(false);
        setRecipientId(null);
        setRecipientName('');
        setOnMessageSent(null);
    };
    const handleMessageSent = ()=>{
        if (onMessageSent) onMessageSent();
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $a925be1700afc867$export$2e2bcd8739ae039), {
        isOpen: isModalOpen,
        onClose: handleCloseModal,
        recipientId: recipientId,
        recipientName: recipientName,
        onMessageSent: handleMessageSent
    });
}
var $6ee6e489605fab21$export$2e2bcd8739ae039 = $6ee6e489605fab21$var$MessageManager;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

// ─── Helpers ──────────────────────────────────────────────────────────────────
function $977b514f6f3884a3$var$toYMD(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}
function $977b514f6f3884a3$var$getDaysInMonth(year, month) {
    // Returns array of Date objects for every day in the month
    const days = [];
    const total = new Date(year, month + 1, 0).getDate();
    for(let d = 1; d <= total; d++)days.push(new Date(year, month, d));
    return days;
}
function $977b514f6f3884a3$var$isDateUnavailable(dateStr, ranges) {
    return ranges.some((r)=>dateStr >= r.start_date && dateStr <= r.end_date);
}
const $977b514f6f3884a3$var$DAY_LABELS = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
const $977b514f6f3884a3$var$MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
// ─── Calendar grid ─────────────────────────────────────────────────────────────
function $977b514f6f3884a3$var$CalendarGrid({ year: year, month: month, unavailableDates: unavailableDates }) {
    const todayStr = $977b514f6f3884a3$var$toYMD(new Date());
    const days = $977b514f6f3884a3$var$getDaysInMonth(year, month);
    // Padding days before first day of month (0 = Sun)
    const firstDayOfWeek = new Date(year, month, 1).getDay();
    const paddingBefore = Array.from({
        length: firstDayOfWeek
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "avail-calendar__grid",
        children: [
            $977b514f6f3884a3$var$DAY_LABELS.map((label)=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "avail-calendar__day-header",
                    children: label
                }, label)),
            paddingBefore.map((_, i)=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "avail-calendar__day avail-calendar__day--pad"
                }, `pad-${i}`)),
            days.map((date)=>{
                const dateStr = $977b514f6f3884a3$var$toYMD(date);
                const isUnavailable = $977b514f6f3884a3$var$isDateUnavailable(dateStr, unavailableDates);
                const isToday = dateStr === todayStr;
                let cls = 'avail-calendar__day';
                if (isUnavailable) cls += ' avail-calendar__day--unavailable';
                if (isToday) cls += ' avail-calendar__day--today';
                return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: cls,
                    title: isUnavailable ? 'Unavailable' : '',
                    children: date.getDate()
                }, dateStr);
            })
        ]
    });
}
// ─── Main component ────────────────────────────────────────────────────────────
function $977b514f6f3884a3$var$AvailabilityCalendarModal({ restBase: restBase }) {
    const [isOpen, setIsOpen] = (0, $bh6RR.useState)(false);
    const [userId, setUserId] = (0, $bh6RR.useState)(null);
    const [userName, setUserName] = (0, $bh6RR.useState)('');
    const [unavailableDates, setUnavailableDates] = (0, $bh6RR.useState)([]);
    const [loading, setLoading] = (0, $bh6RR.useState)(false);
    const [error, setError] = (0, $bh6RR.useState)(null);
    const [currentMonth, setCurrentMonth] = (0, $bh6RR.useState)(new Date());
    // Listen for open event
    (0, $bh6RR.useEffect)(()=>{
        const handleOpen = (event)=>{
            const { userId: uid, userName: uname } = event.detail;
            setUserId(uid);
            setUserName(uname);
            setCurrentMonth(new Date());
            setUnavailableDates([]);
            setError(null);
            setIsOpen(true);
        };
        window.addEventListener('openAvailabilityCalendar', handleOpen);
        return ()=>window.removeEventListener('openAvailabilityCalendar', handleOpen);
    }, []);
    // Fetch unavailable dates whenever the modal opens for a user
    (0, $bh6RR.useEffect)(()=>{
        if (!isOpen || !userId) return;
        let cancelled = false;
        setLoading(true);
        setError(null);
        const nonce = window.gwBpGeoSearchAjax?.restNonce || '';
        const url = `${restBase}/unavailable-dates/user/${userId}`;
        const headers = {
            'Content-Type': 'application/json'
        };
        if (nonce) headers['X-WP-Nonce'] = nonce;
        fetch(url, {
            headers: headers
        }).then((res)=>{
            if (!res.ok) throw new Error(`Server responded with ${res.status}`);
            return res.json();
        }).then((data)=>{
            if (!cancelled) {
                setUnavailableDates(Array.isArray(data) ? data : []);
                setLoading(false);
            }
        }).catch((err)=>{
            if (!cancelled) {
                setError('Could not load availability data. Please try again.');
                setLoading(false);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        isOpen,
        userId,
        restBase
    ]);
    const handleClose = (0, $bh6RR.useCallback)(()=>{
        setIsOpen(false);
        setUserId(null);
        setUserName('');
        setUnavailableDates([]);
        setError(null);
    }, []);
    const prevMonth = ()=>setCurrentMonth((d)=>new Date(d.getFullYear(), d.getMonth() - 1, 1));
    const nextMonth = ()=>setCurrentMonth((d)=>new Date(d.getFullYear(), d.getMonth() + 1, 1));
    if (!isOpen) return null;
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $7c1373b0e06f0b47$export$2e2bcd8739ae039), {
        title: `${userName}'s Availability`,
        onClose: handleClose,
        className: "availability-calendar-modal",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "avail-calendar",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "avail-calendar__nav",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                            className: "avail-calendar__nav-btn",
                            onClick: prevMonth,
                            "aria-label": "Previous month",
                            children: "\u2039 Prev"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                            className: "avail-calendar__month-label",
                            children: [
                                $977b514f6f3884a3$var$MONTH_NAMES[month],
                                " ",
                                year
                            ]
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                            className: "avail-calendar__nav-btn",
                            onClick: nextMonth,
                            "aria-label": "Next month",
                            children: "Next \u203A"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "avail-calendar__legend",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            className: "avail-calendar__legend-item avail-calendar__legend-item--unavailable",
                            children: "Unavailable"
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            className: "avail-calendar__legend-item avail-calendar__legend-item--available",
                            children: "Available"
                        })
                    ]
                }),
                loading && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "avail-calendar__state",
                    children: "Loading\u2026"
                }),
                error && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "avail-calendar__state avail-calendar__state--error",
                    children: error
                }),
                !loading && !error && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)($977b514f6f3884a3$var$CalendarGrid, {
                            year: year,
                            month: month,
                            unavailableDates: unavailableDates
                        }),
                        unavailableDates.length === 0 && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                            className: "avail-calendar__empty",
                            children: "No unavailable dates have been set."
                        })
                    ]
                })
            ]
        })
    });
}
var $977b514f6f3884a3$export$2e2bcd8739ae039 = $977b514f6f3884a3$var$AvailabilityCalendarModal;



var $bh6RR = parcelRequire("bh6RR");

function $0cc167498daaa88e$export$a51da0b657bb0a3f(config, filters) {
    const [members, setMembers] = (0, $bh6RR.useState)([]);
    const [loading, setLoading] = (0, $bh6RR.useState)(false);
    const [error, setError] = (0, $bh6RR.useState)(null);
    const [searchTerm, setSearchTerm] = (0, $bh6RR.useState)('');
    const loadMembers = (0, $bh6RR.useCallback)(async (clearFirst = false)=>{
        try {
            if (clearFirst) setMembers([]); // Clear existing members when applying new filters
            setLoading(true);
            setError(null);
            // Debug logging
            console.log('Loading members with filters:', filters);
            console.log('Form ID:', config.formId);
            console.log('Search term:', searchTerm);
            console.log('Filters object keys:', Object.keys(filters));
            console.log('Filters object values:', Object.values(filters));
            const data = await (0, $c1444e3d73f2c384$export$14223e3d3aa5fd3b)({
                formId: config.formId,
                search: searchTerm,
                filters: filters,
                includeNoLocation: config.includeNoLocation !== undefined ? config.includeNoLocation : false,
                limit: config.resultLimit || null
            });
            setMembers(data.members || []);
        } catch (err) {
            setError(err.message || 'Failed to load members');
            console.error('Error loading members:', err);
        } finally{
            setLoading(false);
        }
    }, [
        config.formId,
        searchTerm,
        filters
    ]);
    return {
        members: members,
        loading: loading,
        error: error,
        searchTerm: searchTerm,
        setSearchTerm: setSearchTerm,
        loadMembers: loadMembers
    };
}



var $bh6RR = parcelRequire("bh6RR");
function $59ff1d07d9ff0e5f$export$973ca22476b0e05f() {
    const [filters, setFilters] = (0, $bh6RR.useState)({});
    const updateFilter = (0, $bh6RR.useCallback)((fieldId, value)=>{
        console.log('useFilters: Updating filter', fieldId, '=', value);
        setFilters((prev)=>{
            // If value is empty/null/undefined, remove the filter
            if (!value || Array.isArray(value) && value.length === 0 || typeof value === 'string' && value.trim() === '') {
                const newFilters = {
                    ...prev
                };
                delete newFilters[fieldId];
                console.log('useFilters: Removed filter, new filters:', newFilters);
                return newFilters;
            }
            // Store only field ID and value, not field configuration
            const newFilters = {
                ...prev,
                [fieldId]: value
            };
            console.log('useFilters: Updated filters:', newFilters);
            return newFilters;
        });
    }, []);
    const clearFilters = (0, $bh6RR.useCallback)(()=>{
        setFilters({});
    }, []);
    const removeFilter = (0, $bh6RR.useCallback)((fieldId)=>{
        setFilters((prev)=>{
            const newFilters = {
                ...prev
            };
            delete newFilters[fieldId];
            return newFilters;
        });
    }, []);
    return {
        filters: filters,
        updateFilter: updateFilter,
        clearFilters: clearFilters,
        removeFilter: removeFilter
    };
}




var $bh6RR = parcelRequire("bh6RR");
function $15ad8c2440cbec44$export$765f6f656d5c1b7d(includeNoLocation = false) {
    const [mapBounds, setMapBounds] = (0, $bh6RR.useState)(null);
    const [visibleMembers, setVisibleMembers] = (0, $bh6RR.useState)([]);
    const [hoveredMember, setHoveredMember] = (0, $bh6RR.useState)(null);
    const [highlightedMarker, setHighlightedMarker] = (0, $bh6RR.useState)(null);
    const mapInstanceRef = (0, $bh6RR.useRef)(null);
    const markersRef = (0, $bh6RR.useRef)(new Map());
    const memberListRef = (0, $bh6RR.useRef)(null);
    // Update visible members based on map bounds.
    // When includeNoLocation is true, members without a location are always shown
    // (appended after in-bounds members so located members appear first).
    const updateVisibleMembers = (0, $bh6RR.useCallback)((members, bounds)=>{
        if (!bounds || !members) {
            setVisibleMembers(members || []);
            return;
        }
        const inBounds = [];
        const noLocation = [];
        members.forEach((member)=>{
            if (!member.has_location || !member.latitude || !member.longitude) {
                if (includeNoLocation) noLocation.push(member);
                return;
            }
            const lat = parseFloat(member.latitude);
            const lng = parseFloat(member.longitude);
            if (lat >= bounds.south && lat <= bounds.north && lng >= bounds.west && lng <= bounds.east) inBounds.push(member);
        });
        setVisibleMembers([
            ...inBounds,
            ...noLocation
        ]);
    }, [
        includeNoLocation
    ]);
    // Handle map bounds change
    const handleMapBoundsChange = (0, $bh6RR.useCallback)((bounds, members)=>{
        setMapBounds(bounds);
        updateVisibleMembers(members, bounds);
    }, [
        updateVisibleMembers
    ]);
    // Handle member hover in list
    const handleMemberHover = (0, $bh6RR.useCallback)((member)=>{
        setHoveredMember(member);
        if (member && markersRef.current.has(member.user_id)) {
            const marker = markersRef.current.get(member.user_id);
            setHighlightedMarker(marker);
            // Add visual highlight to marker
            const markerElement = marker.getElement();
            if (markerElement) {
                // Find the inner member-marker div and add class to it
                const memberMarkerDiv = markerElement.querySelector('.member-marker');
                if (memberMarkerDiv) memberMarkerDiv.classList.add('marker-highlighted');
            }
            // Open the popup for this marker, even if it's clustered
            if (marker.getPopup()) {
                // Try to open popup normally first
                marker.openPopup();
                // If marker is clustered and popup didn't open, create a temporary popup
                if (!marker.isPopupOpen() && mapInstanceRef.current && member.latitude && member.longitude) {
                    const tempPopup = new L.Popup({
                        closeButton: true,
                        autoClose: true,
                        closeOnEscapeKey: true,
                        className: 'temp-member-popup'
                    }).setLatLng([
                        parseFloat(member.latitude),
                        parseFloat(member.longitude)
                    ]).setContent(marker.getPopup().getContent()).openOn(mapInstanceRef.current);
                }
            }
        } else console.log('No marker found for member:', member.user_id);
    }, []);
    // Handle member hover out in list
    const handleMemberHoverOut = (0, $bh6RR.useCallback)(()=>{
        if (hoveredMember && markersRef.current.has(hoveredMember.user_id)) {
            const marker = markersRef.current.get(hoveredMember.user_id);
            const markerElement = marker.getElement();
            if (markerElement) {
                // Find the inner member-marker div and remove class from it
                const memberMarkerDiv = markerElement.querySelector('.member-marker');
                if (memberMarkerDiv) memberMarkerDiv.classList.remove('marker-highlighted');
            }
            // Close the popup for this marker
            if (marker.getPopup()) marker.closePopup();
        }
        // Also close any temporary popups that might be open
        if (mapInstanceRef.current) mapInstanceRef.current.closePopup();
        setHoveredMember(null);
        setHighlightedMarker(null);
    }, [
        hoveredMember
    ]);
    // Handle marker hover on map
    const handleMarkerHover = (0, $bh6RR.useCallback)((member)=>{
        setHoveredMember(member);
        // Find the member list container
        let memberListElement = memberListRef.current;
        // Fallback: if ref is null, try to find the member list in DOM
        if (!memberListElement) memberListElement = document.querySelector('.member-list-container');
        if (memberListElement && member) // Use the list's highlightMember API which pins member to top and highlights
        {
            if (memberListElement.highlightMember) memberListElement.highlightMember(member.user_id);
        }
    }, []);
    // Handle marker hover out on map
    const handleMarkerHoverOut = (0, $bh6RR.useCallback)(()=>{
        // Find the member list container
        let memberListElement = memberListRef.current;
        // Fallback: if ref is null, try to find the member list in DOM
        if (!memberListElement) memberListElement = document.querySelector('.member-list-container');
        if (memberListElement) {
            // Use enhanced API if available
            if (memberListElement.clearHighlight) memberListElement.clearHighlight();
            else {
                // Fallback to DOM-based clearing (legacy)
                const highlightedElement = memberListElement.querySelector('.member-highlighted');
                if (highlightedElement) highlightedElement.classList.remove('member-highlighted');
            }
        }
        // Reset states
        setHoveredMember(null);
        setHighlightedMarker(null);
    }, []);
    // Register map instance
    const registerMapInstance = (0, $bh6RR.useCallback)((mapInstance)=>{
        mapInstanceRef.current = mapInstance;
    }, []);
    // Register marker
    const registerMarker = (0, $bh6RR.useCallback)((userId, marker)=>{
        markersRef.current.set(userId, marker);
    }, []);
    // Unregister marker
    const unregisterMarker = (0, $bh6RR.useCallback)((userId)=>{
        markersRef.current.delete(userId);
    }, []);
    // Register member list container
    const registerMemberList = (0, $bh6RR.useCallback)((listElement)=>{
        memberListRef.current = listElement;
    }, []);
    return {
        mapBounds: mapBounds,
        visibleMembers: visibleMembers,
        hoveredMember: hoveredMember,
        highlightedMarker: highlightedMarker,
        handleMapBoundsChange: handleMapBoundsChange,
        handleMemberHover: handleMemberHover,
        handleMemberHoverOut: handleMemberHoverOut,
        handleMarkerHover: handleMarkerHover,
        handleMarkerHoverOut: handleMarkerHoverOut,
        registerMapInstance: registerMapInstance,
        registerMarker: registerMarker,
        unregisterMarker: unregisterMarker,
        registerMemberList: registerMemberList,
        updateVisibleMembers: updateVisibleMembers
    };
}



var $bh6RR = parcelRequire("bh6RR");

function $d06630f2130a6dfe$export$5d6d07171bf99999(currentUserId = null) {
    const [favorites, setFavorites] = (0, $bh6RR.useState)(new Set());
    const [loading, setLoading] = (0, $bh6RR.useState)(false);
    const [error, setError] = (0, $bh6RR.useState)(null);
    const [pendingToggle, setPendingToggle] = (0, $bh6RR.useState)(new Set());
    const loadedRef = (0, $bh6RR.useRef)(false);
    // Load user's favorites
    const loadFavorites = (0, $bh6RR.useCallback)(async ()=>{
        if (!currentUserId || loadedRef.current) return;
        try {
            setLoading(true);
            setError(null);
            const favoriteIds = await (0, $c1444e3d73f2c384$export$598524930a5d09cb)(currentUserId);
            setFavorites(new Set(favoriteIds.map(String)));
            loadedRef.current = true;
        } catch (err) {
            console.error('Error loading favorites:', err);
            setError(err.message);
        } finally{
            setLoading(false);
        }
    }, [
        currentUserId
    ]);
    // Toggle favorite status
    const toggleFavorite = (0, $bh6RR.useCallback)(async (userId)=>{
        if (!currentUserId || !userId) return;
        const userIdStr = String(userId);
        const isCurrentlyFavorite = favorites.has(userIdStr);
        // Optimistic update
        const newFavorites = new Set(favorites);
        if (isCurrentlyFavorite) newFavorites.delete(userIdStr);
        else newFavorites.add(userIdStr);
        setFavorites(newFavorites);
        // Track pending state
        const newPending = new Set(pendingToggle);
        newPending.add(userIdStr);
        setPendingToggle(newPending);
        try {
            if (isCurrentlyFavorite) await (0, $c1444e3d73f2c384$export$fa150b6a95787654)(userId);
            else await (0, $c1444e3d73f2c384$export$aa03d8c0f74def9f)(userId);
        } catch (err) {
            console.error('Error toggling favorite:', err);
            // Revert optimistic update on error
            const revertedFavorites = new Set(favorites);
            if (isCurrentlyFavorite) revertedFavorites.add(userIdStr);
            else revertedFavorites.delete(userIdStr);
            setFavorites(revertedFavorites);
            setError(err.message);
        } finally{
            // Remove from pending
            const updatedPending = new Set(pendingToggle);
            updatedPending.delete(userIdStr);
            setPendingToggle(updatedPending);
        }
    }, [
        currentUserId,
        favorites,
        pendingToggle
    ]);
    // Check if a user is favorited
    const isFavorite = (0, $bh6RR.useCallback)((userId)=>{
        return favorites.has(String(userId));
    }, [
        favorites
    ]);
    // Check if a toggle is pending
    const isPending = (0, $bh6RR.useCallback)((userId)=>{
        return pendingToggle.has(String(userId));
    }, [
        pendingToggle
    ]);
    // Clear error
    const clearError = (0, $bh6RR.useCallback)(()=>{
        setError(null);
    }, []);
    // Auto-load favorites when currentUserId becomes available
    (0, $bh6RR.useEffect)(()=>{
        if (currentUserId && !loadedRef.current) loadFavorites();
    }, [
        currentUserId,
        loadFavorites
    ]);
    return {
        favorites: Array.from(favorites),
        loading: loading,
        error: error,
        loadFavorites: loadFavorites,
        toggleFavorite: toggleFavorite,
        isFavorite: isFavorite,
        isPending: isPending,
        clearError: clearError
    };
}


function $7ac7b9e457b0f6ca$var$App({ config: config }) {
    const sortOptions = config?.sortOptions || [];
    const showMap = config?.showMap !== false;
    const [showFilterModal, setShowFilterModal] = (0, $bh6RR.useState)(false);
    const [mobileView, setMobileView] = (0, $bh6RR.useState)('list'); // 'list' or 'map'
    const [mobileSortBy, setMobileSortBy] = (0, $bh6RR.useState)('joined');
    const [mobileViewMode, setMobileViewMode] = (0, $bh6RR.useState)('compact');
    const { isMobile: isMobile } = (0, $f9a85ac8928fb9dc$export$37dc31edf9cb7f3)();
    const { filters: filters, updateFilter: updateFilter, clearFilters: clearFilters } = (0, $59ff1d07d9ff0e5f$export$973ca22476b0e05f)();
    const { members: members, loading: loading, error: error, searchTerm: searchTerm, setSearchTerm: setSearchTerm, loadMembers: loadMembers } = (0, $0cc167498daaa88e$export$a51da0b657bb0a3f)(config, filters);
    const { visibleMembers: visibleMembers, handleMapBoundsChange: handleMapBoundsChange, handleMemberHover: handleMemberHover, handleMemberHoverOut: handleMemberHoverOut, handleMarkerHover: handleMarkerHover, handleMarkerHoverOut: handleMarkerHoverOut, registerMapInstance: registerMapInstance, registerMarker: registerMarker, unregisterMarker: unregisterMarker, registerMemberList: registerMemberList, updateVisibleMembers: updateVisibleMembers } = (0, $15ad8c2440cbec44$export$765f6f656d5c1b7d)(config.includeNoLocation);
    // Get current user ID from config
    const currentUserId = config?.currentUserId || null;
    const { loading: favoritesLoading, error: favoritesError, loadFavorites: loadFavorites, toggleFavorite: toggleFavorite, isFavorite: isFavorite, isPending: isPendingFavorite, clearError: clearFavoritesError } = (0, $d06630f2130a6dfe$export$5d6d07171bf99999)(currentUserId);
    // Determine if user is logged in - user_id is 0 when not logged in
    const isLoggedIn = Boolean(currentUserId) && currentUserId !== '0' && currentUserId !== 0;
    (0, $bh6RR.useEffect)(()=>{
        // Check if filters are being applied (not just cleared)
        const hasActiveFilters = Object.keys(filters).length > 0;
        loadMembers(hasActiveFilters);
    }, [
        filters,
        searchTerm
    ]);
    // Load favorites when currentUserId becomes available
    (0, $bh6RR.useEffect)(()=>{
        if (currentUserId) loadFavorites();
    }, [
        currentUserId,
        loadFavorites
    ]);
    // Update visible members when members change or on initial load
    (0, $bh6RR.useEffect)(()=>{
        updateVisibleMembers(members, null); // null bounds means show all members initially
    }, [
        members,
        updateVisibleMembers
    ]);
    const handleSearch = (term)=>{
        setSearchTerm(term);
    };
    const handleFilterChange = (newFilters)=>{
        // Clear all filters first
        clearFilters();
        // Apply new filters - newFilters should be {fieldId: value}
        Object.keys(newFilters).forEach((fieldId)=>{
            if (newFilters[fieldId]) updateFilter(fieldId, newFilters[fieldId]);
        });
        setShowFilterModal(false);
    };
    const handleClearFilters = ()=>{
        clearFilters();
        setSearchTerm('');
    };
    const isValueActive = (value)=>{
        if (Array.isArray(value)) return value.length > 0;
        if (value && typeof value === 'object') return Object.values(value).some((nestedValue)=>isValueActive(nestedValue));
        if (typeof value === 'string') return value.trim() !== '';
        return Boolean(value);
    };
    const activeFilterCount = Object.values(filters).filter(isValueActive).length;
    const hasActiveFilters = activeFilterCount > 0;
    if (loading) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "gw-bp-geosearch-container",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fFSBL.default), {})
    });
    if (error) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "gw-bp-geosearch-container",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: "error-message",
            children: error
        })
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "gw-bp-geosearch-container",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: `gw-bp-geosearch-content ${isMobile ? 'mobile' : ''}`,
                children: isMobile ? // Mobile: Show either list or map based on toggle
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $8adbcafe5c7ec1d7$export$2e2bcd8739ae039), {
                            searchTerm: searchTerm,
                            onSearch: handleSearch,
                            onShowFilters: ()=>setShowFilterModal(true),
                            onClearFilters: handleClearFilters,
                            hasActiveFilters: hasActiveFilters,
                            sortBy: mobileSortBy,
                            onSortChange: setMobileSortBy,
                            sortOptions: sortOptions,
                            mobileView: mobileView
                        }),
                        mobileView === 'list' || !showMap ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $8ed5b744e753ec9f$export$2e2bcd8739ae039), {
                            members: members,
                            loading: loading,
                            config: config,
                            onMemberHover: handleMemberHover,
                            onMemberHoverOut: handleMemberHoverOut,
                            registerMemberList: registerMemberList,
                            isFavorite: isFavorite,
                            onToggleFavorite: toggleFavorite,
                            isPendingFavorite: isPendingFavorite,
                            isLoggedIn: isLoggedIn,
                            enableVirtualization: true,
                            performanceMode: "auto",
                            sortBy: mobileSortBy,
                            onSortChange: setMobileSortBy,
                            sortOptions: sortOptions,
                            viewMode: mobileViewMode,
                            onViewModeChange: setMobileViewMode
                        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $b4f3e47ab6efd409$export$2e2bcd8739ae039), {
                            members: members,
                            config: config,
                            height: "calc(100vh - 176px)",
                            onMarkerHover: handleMarkerHover,
                            onMarkerHoverOut: handleMarkerHoverOut,
                            onBoundsChange: handleMapBoundsChange,
                            registerMapInstance: registerMapInstance,
                            registerMarker: registerMarker,
                            unregisterMarker: unregisterMarker,
                            isFavorite: isFavorite,
                            onToggleFavorite: toggleFavorite,
                            isPendingFavorite: isPendingFavorite,
                            isLoggedIn: isLoggedIn
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $222280692cf2e3e9$export$2e2bcd8739ae039), {
                            mobileView: mobileView,
                            onMobileViewChange: setMobileView,
                            onShowFilters: ()=>setShowFilterModal(true),
                            hasActiveFilters: hasActiveFilters,
                            activeFilterCount: activeFilterCount,
                            showClear: hasActiveFilters || Boolean(searchTerm),
                            onClear: handleClearFilters,
                            showMap: showMap
                        })
                    ]
                }) : // Desktop: Side-by-side layout
                /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: `left-panel ${!showMap ? 'no-map' : ''}`,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $8adbcafe5c7ec1d7$export$2e2bcd8739ae039), {
                                    searchTerm: searchTerm,
                                    onSearch: handleSearch,
                                    onShowFilters: ()=>setShowFilterModal(true),
                                    onClearFilters: handleClearFilters,
                                    hasActiveFilters: hasActiveFilters,
                                    sortBy: mobileSortBy,
                                    onSortChange: setMobileSortBy,
                                    sortOptions: sortOptions
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $8ed5b744e753ec9f$export$2e2bcd8739ae039), {
                                    members: showMap ? visibleMembers : members,
                                    loading: loading,
                                    config: config,
                                    onMemberHover: handleMemberHover,
                                    onMemberHoverOut: handleMemberHoverOut,
                                    registerMemberList: registerMemberList,
                                    isFavorite: isFavorite,
                                    onToggleFavorite: toggleFavorite,
                                    isPendingFavorite: isPendingFavorite,
                                    isLoggedIn: isLoggedIn,
                                    enableVirtualization: true,
                                    performanceMode: "auto",
                                    showResultCount: true,
                                    totalMembers: members.length,
                                    sortOptions: sortOptions
                                })
                            ]
                        }),
                        showMap && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "right-panel",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b4f3e47ab6efd409$export$2e2bcd8739ae039), {
                                members: members,
                                config: config,
                                height: "100%",
                                onMarkerHover: handleMarkerHover,
                                onMarkerHoverOut: handleMarkerHoverOut,
                                onBoundsChange: (bounds)=>handleMapBoundsChange(bounds, members),
                                registerMapInstance: registerMapInstance,
                                registerMarker: registerMarker,
                                unregisterMarker: unregisterMarker,
                                isFavorite: isFavorite,
                                onToggleFavorite: toggleFavorite,
                                isPendingFavorite: isPendingFavorite,
                                isLoggedIn: isLoggedIn
                            })
                        })
                    ]
                })
            }),
            showFilterModal && /*#__PURE__*/ (0, $ih19M.jsx)((0, $d00350881ea0f0be$export$2e2bcd8739ae039), {
                config: config,
                currentFilters: filters,
                onApply: handleFilterChange,
                onClose: ()=>setShowFilterModal(false)
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $6ee6e489605fab21$export$2e2bcd8739ae039), {}),
            config.gwVisitsCalendarEnabled && /*#__PURE__*/ (0, $ih19M.jsx)((0, $977b514f6f3884a3$export$2e2bcd8739ae039), {
                restBase: config.gwVisitsRestBase
            })
        ]
    });
}
var $7ac7b9e457b0f6ca$export$2e2bcd8739ae039 = $7ac7b9e457b0f6ca$var$App;



// Global initialization function
window.initGeoSearchReact = function(containerId, config) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('GeoSearch container not found:', containerId);
        return;
    }
    const root = (0, $9ATkq.createRoot)(container);
    root.render(/*#__PURE__*/ (0, $ih19M.jsx)((0, $7ac7b9e457b0f6ca$export$2e2bcd8739ae039), {
        config: config
    }));
};
// Auto-initialize if config is available
if (window.gwBpGeoSearchConfig) Object.keys(window.gwBpGeoSearchConfig).forEach((instanceId)=>{
    const config = window.gwBpGeoSearchConfig[instanceId];
    window.initGeoSearchReact(instanceId, config);
});


//# sourceMappingURL=frontend.da23ca02.js.map
